const _excluded = ["className", "bsPrefix", "as"],
      _excluded2 = ["bsPrefix", "placement", "className", "style", "children", "body", "arrowProps", "popper", "show"],
      _excluded3 = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "addEndListener", "children", "childRef"],
      _excluded4 = ["className", "children", "transitionClasses"],
      _excluded5 = ["children", "transition", "popperConfig"],
      _excluded6 = ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"],
      _excluded7 = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"],
      _excluded8 = ["bsPrefix", "className", "eventKey", "disabled", "onClick", "active", "as"],
      _excluded9 = ["bsPrefix", "className", "align", "rootCloseEvent", "flip", "show", "renderOnMount", "as", "popperConfig", "variant"],
      _excluded10 = ["as", "bsPrefix", "variant", "size", "active", "className"],
      _excluded11 = ["bsPrefix", "split", "className", "childBsPrefix", "as"],
      _excluded12 = ["bsPrefix", "drop", "show", "className", "align", "onSelect", "onToggle", "focusFirstItemOnShow", "as", "navbar", "autoClose"],
      _excluded13 = ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuRole", "renderMenuOnMount", "disabled", "href", "id", "menuVariant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("mobx"), require("react-dom"), require("@fortawesome/react-fontawesome"), require("@fortawesome/free-solid-svg-icons"), require("mobx-react"), require("@miriamtech/if2-js-model"), require("react-select"), require("i18next-browser-languagedetector"), require("lodash")) : "function" == typeof define && define.amd ? define(["react", "mobx", "react-dom", "@fortawesome/react-fontawesome", "@fortawesome/free-solid-svg-icons", "mobx-react", "@miriamtech/if2-js-model", "react-select", "i18next-browser-languagedetector", "lodash"], t) : "object" == typeof exports ? exports["if2-processors"] = t(require("react"), require("mobx"), require("react-dom"), require("@fortawesome/react-fontawesome"), require("@fortawesome/free-solid-svg-icons"), require("mobx-react"), require("@miriamtech/if2-js-model"), require("react-select"), require("i18next-browser-languagedetector"), require("lodash")) : e["if2-processors"] = t(e.react, e.mobx, e["react-dom"], e["@fortawesome/react-fontawesome"], e["@fortawesome/free-solid-svg-icons"], e["mobx-react"], e["@miriamtech/if2-js-model"], e["react-select"], e["i18next-browser-languagedetector"], e.lodash);
}(window, function (e, t, n, r, o, i, a, s, c, u) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 48);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    e.exports = n(34);
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    e.exports = n(45)();
  }, function (e, t, n) {
    var r;
    /*!
    	Copyright (c) 2018 Jed Watson.
    	Licensed under the MIT License (MIT), see
    	http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r)) {
              if (r.length) {
                var a = o.apply(null, r);
                a && e.push(a);
              }
            } else if ("object" === i) {
              if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]")) {
                e.push(r.toString());
                continue;
              }

              for (var s in r) n.call(r, s) && r[s] && e.push(s);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (o.default = o, e.exports = o) : void 0 === (r = function () {
        return o;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    var r = n(22);
    e.exports = function (e, t, n) {
      return (t = r(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = i;
  }, function (e, t, n) {
    var r = n(30),
        o = n(31),
        i = n(23),
        a = n(32);
    e.exports = function (e, t) {
      return r(e) || o(e, t) || i(e, t) || a();
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e, t, n, r, o, i, a, s) {
      if (!e) {
        var c;
        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var u = [n, r, o, i, a, s],
              l = 0;
          (c = new Error(t.replace(/%s/g, function () {
            return u[l++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    };
  },, function (e, t, n) {
    "use strict";

    var r = function () {};

    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var r = n(0),
          o = void 0 !== e && e.navigator && "ReactNative" === e.navigator.product,
          i = "undefined" != typeof document;
      t.a = i || o ? r.useLayoutEffect : r.useEffect;
    }).call(this, n(47));
  }, function (e, t) {
    function n(t) {
      return e.exports = n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n(t);
    }

    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    var r = n(22);

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, r(o.key), o);
      }
    }

    e.exports = function (e, t, n) {
      return t && o(e.prototype, t), n && o(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    var r = n(33);
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          o,
          i = r(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) n = a[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
      }

      return i;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    "use strict";

    var r = n(43),
        o = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0
    },
        i = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0
    },
        a = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0
    },
        s = {};

    function c(e) {
      return r.isMemo(e) ? a : s[e.$$typeof] || o;
    }

    s[r.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    }, s[r.Memo] = a;
    var u = Object.defineProperty,
        l = Object.getOwnPropertyNames,
        p = Object.getOwnPropertySymbols,
        f = Object.getOwnPropertyDescriptor,
        d = Object.getPrototypeOf,
        h = Object.prototype;

    e.exports = function e(t, n, r) {
      if ("string" != typeof n) {
        if (h) {
          var o = d(n);
          o && o !== h && e(t, o, r);
        }

        var a = l(n);
        p && (a = a.concat(p(n)));

        for (var s = c(t), g = c(n), v = 0; v < a.length; ++v) {
          var m = a[v];

          if (!(i[m] || r && r[m] || g && g[m] || s && s[m])) {
            var b = f(n, m);

            try {
              u(t, m, b);
            } catch (e) {}
          }
        }
      }

      return t;
    };
  }, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, n) {
    var r = n(15).default,
        o = n(29);
    e.exports = function (e) {
      var t = o(e, "string");
      return "symbol" === r(t) ? t : String(t);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    var r = n(24);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return r(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];

      return r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = c;
  }, function (e) {
    e.exports = JSON.parse('{"en":{"helpers":{"submit":{"harvest_lot":{"create":"Create Harvest Lot","update":"Update Harvest Lot"}}},"if2_processors":{"action_not_authorized":"You are not authorized to perform this action","delete":"Delete","edit":"Edit","fields":{"add":"Add field","fields":"Fields","name":"Field name"},"harvest_lots":{"add":"Add Harvest Lot","application_records":{"sharing":{"after_html":"Application records on or after <strong>%{date}</strong> are shared with the processor","between":"Application records between the following dates are shared with the processor","dates":{"end_date":"End Date","end_date_information":"If left blank, it implies that this relationship is ongoing.","start_date":"Start Date","start_date_information":"If left blank, it implies that this relationship has been in place for as long as the fields have existed."},"disabled":"disabled","enabled":"enabled","information":"If enabled, application records for the fields in this harvest lot\\nwill be shared with the processor. Access will be limited to the\\ndate span specified above, if any.\\n","not_shared":"Application records are not shared with the processor","range_html":"<strong>%{start_date}</strong> to <strong>%{end_date}</strong>","share":"Share application records","shared":"Application records are shared with the processor","sharing":"Record Sharing","until_html":"Application records through <strong>%{date}</strong> are shared with the processor"}},"confirm_delete":"Are you sure you want to delete %{name}?","edit":"Edit: %{name}","empty":"No harvest lots exist, yet.","errors_encountered":{"one":"1 error prohibited this harvest lot from being saved","other":"%{count} errors prohibited this harvest lot from being saved"},"harvest_lots":"Harvest Lots","hints":{"delete":"Delete harvest lot","edit":"Edit harvest lot","view":"View harvest lot"},"name":"Name/Number","new":"New Harvest Lot","processed_by":"Processed by","successfully_created":"Harvest lot was successfully created","successfully_deleted":"Harvest lot was successfully deleted","successfully_updated":"Harvest lot was successfully updated","validations":{"account_cannot_be_processor":"cannot be a processor","end_date_must_follow_end_date":"must follow start date","fields_are_required":"At least 1 field is required"},"view_report":"View Report"},"processor":"Processor","processors":{"select":"Select a processor"},"role":{"privileges":{"edit_harvest_lots":"Edit Harvest Lots","groups":{"harvest_lots":"Harvest Lots"},"view_harvest_lots":"View Harvest Lots"}}}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"helpers":{"submit":{"harvest_lot":{"create":"Crear lote de cosecha","update":"Actualizar lote de cosecha"}}},"if2_processors":{"action_not_authorized":"No está autorizado para realizar esta acción","delete":"Eliminar","edit":"Editar","fields":{"add":"Agregar campo","fields":"Campos","name":"Nombre del campo"},"harvest_lots":{"add":"Agregar lote de cosecha","application_records":{"sharing":{"after_html":"A partir de <strong>%{date}</strong> los registros de aplicación se compartirán con el procesador","between":"Los registros de aplicación dentro del intervalo de fechas se compartirán con el procesador","dates":{"end_date":"Fecha final","end_date_information":"Si se deja en blanco, implica que esta relación está en curso.","start_date":"Fecha de inicio","start_date_information":"Si se deja en blanco, implica que esta relación se ha mantenido desde que existieron los campos."},"disabled":"desactivado","enabled":"activado","information":"Si está activado, los registros de aplicación para los campos en\\neste lote de cosecha se compartirán con el procesador. El acceso\\nserá limitado al intervalo de fechas especificado anteriormente, si\\nse ha especificado.\\n","not_shared":"No se comparten registros de aplicación con el procesador","range_html":"De <strong>%{start_date}</strong> a <strong>%{end_date}</strong>","share":"Compartir registros de aplicación","shared":"Los registros de aplicación se han compartido con el procesador","sharing":"Uso compartido de registros","until_html":"Los registros de aplicación se compartirán con el procesador hasta <strong>%{date}</strong>"}},"confirm_delete":"¿Está seguro de que quiere eliminar a %{name}?","edit":"Editar: %{name}","empty":"Aún no existe ningún lote de cosecha.","errors_encountered":{"one":"1 error impidió que este lote de cosecha se guardara","other":"%{count} errores impidieron quer este lote de cosecha se gaurdara"},"harvest_lots":"Lotes de cosecha","hints":{"delete":"Eliminar lote de cosecha","edit":"Editar lote de cosecha","view":"Ver lote de cosecha"},"name":"Nombre/Número","new":"Nuevo lote de cosecha","processed_by":"Procesado por","successfully_created":"El lote de cosecha se creó con éxito","successfully_deleted":"El lote de cosecha se eliminó con éxito","successfully_updated":"El lote de cosecha se actualizó con éxito","validations":{"account_cannot_be_processor":"no puede ser un procesador","end_date_must_follow_end_date":"debe seguir a la fecha de inicio","fields_are_required":"Se requiere al menos 1 campo"},"view_report":"Ver informe"},"processor":"Procesador","processors":{"select":"Seleccione un procesador"},"role":{"privileges":{"edit_harvest_lots":"Editar lotes de cosecha","groups":{"harvest_lots":"Lotes de cosecha"},"view_harvest_lots":"Ver lotes de cosecha"}}}}}');
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, n) {
    var r = n(15).default;
    e.exports = function (e, t) {
      if ("object" !== r(e) || null === e) return e;
      var n = e[Symbol.toPrimitive];

      if (void 0 !== n) {
        var o = n.call(e, t || "default");
        if ("object" !== r(o)) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === t ? String : Number)(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (null != n) {
        var r,
            o,
            i,
            a,
            s = [],
            c = !0,
            u = !1;

        try {
          if (i = (n = n.call(e)).next, 0 === t) {
            if (Object(n) !== n) return;
            c = !1;
          } else for (; !(c = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
        } catch (e) {
          u = !0, o = e;
        } finally {
          try {
            if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
          } finally {
            if (u) throw o;
          }
        }

        return s;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

      return o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    "use strict";
    /** @license React v16.14.0
     * react-jsx-runtime.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var r = n(0),
        o = 60103;

    if (t.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
      var i = Symbol.for;
      o = i("react.element"), t.Fragment = i("react.fragment");
    }

    var a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
        s = Object.prototype.hasOwnProperty,
        c = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function u(e, t, n) {
      var r,
          i = {},
          u = null,
          l = null;

      for (r in void 0 !== n && (u = "" + n), void 0 !== t.key && (u = "" + t.key), void 0 !== t.ref && (l = t.ref), t) s.call(t, r) && !c.hasOwnProperty(r) && (i[r] = t[r]);

      if (e && e.defaultProps) for (r in t = e.defaultProps) void 0 === i[r] && (i[r] = t[r]);
      return {
        $$typeof: o,
        type: e,
        key: u,
        ref: l,
        props: i,
        _owner: a.current
      };
    }

    t.jsx = u, t.jsxs = u;
  }, function (e, t) {
    e.exports = function (e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    var r = n(37);
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && r(e, t);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    function n(t, r) {
      return e.exports = n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n(t, r);
    }

    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    var r = n(39),
        o = n(40),
        i = n(23),
        a = n(41);
    e.exports = function (e) {
      return r(e) || o(e) || i(e) || a();
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    var r = n(24);
    e.exports = function (e) {
      if (Array.isArray(e)) return r(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    function n() {
      return e.exports = n = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }

        return e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, n.apply(this, arguments);
    }

    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, n) {
    "use strict";

    e.exports = n(44);
  }, function (e, t, n) {
    "use strict";
    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var r = "function" == typeof Symbol && Symbol.for,
        o = r ? Symbol.for("react.element") : 60103,
        i = r ? Symbol.for("react.portal") : 60106,
        a = r ? Symbol.for("react.fragment") : 60107,
        s = r ? Symbol.for("react.strict_mode") : 60108,
        c = r ? Symbol.for("react.profiler") : 60114,
        u = r ? Symbol.for("react.provider") : 60109,
        l = r ? Symbol.for("react.context") : 60110,
        p = r ? Symbol.for("react.async_mode") : 60111,
        f = r ? Symbol.for("react.concurrent_mode") : 60111,
        d = r ? Symbol.for("react.forward_ref") : 60112,
        h = r ? Symbol.for("react.suspense") : 60113,
        g = r ? Symbol.for("react.suspense_list") : 60120,
        v = r ? Symbol.for("react.memo") : 60115,
        m = r ? Symbol.for("react.lazy") : 60116,
        b = r ? Symbol.for("react.block") : 60121,
        y = r ? Symbol.for("react.fundamental") : 60117,
        O = r ? Symbol.for("react.responder") : 60118,
        w = r ? Symbol.for("react.scope") : 60119;

    function x(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            switch (e = e.type) {
              case p:
              case f:
              case a:
              case c:
              case s:
              case h:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case d:
                  case m:
                  case v:
                  case u:
                    return e;

                  default:
                    return t;
                }

            }

          case i:
            return t;
        }
      }
    }

    function j(e) {
      return x(e) === f;
    }

    t.AsyncMode = p, t.ConcurrentMode = f, t.ContextConsumer = l, t.ContextProvider = u, t.Element = o, t.ForwardRef = d, t.Fragment = a, t.Lazy = m, t.Memo = v, t.Portal = i, t.Profiler = c, t.StrictMode = s, t.Suspense = h, t.isAsyncMode = function (e) {
      return j(e) || x(e) === p;
    }, t.isConcurrentMode = j, t.isContextConsumer = function (e) {
      return x(e) === l;
    }, t.isContextProvider = function (e) {
      return x(e) === u;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }, t.isForwardRef = function (e) {
      return x(e) === d;
    }, t.isFragment = function (e) {
      return x(e) === a;
    }, t.isLazy = function (e) {
      return x(e) === m;
    }, t.isMemo = function (e) {
      return x(e) === v;
    }, t.isPortal = function (e) {
      return x(e) === i;
    }, t.isProfiler = function (e) {
      return x(e) === c;
    }, t.isStrictMode = function (e) {
      return x(e) === s;
    }, t.isSuspense = function (e) {
      return x(e) === h;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === a || e === f || e === c || e === s || e === h || e === g || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === v || e.$$typeof === u || e.$$typeof === l || e.$$typeof === d || e.$$typeof === y || e.$$typeof === O || e.$$typeof === w || e.$$typeof === b);
    }, t.typeOf = x;
  }, function (e, t, n) {
    "use strict";

    var r = n(46);

    function o() {}

    function i() {}

    i.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, i, a) {
        if (a !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bigint: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "IF2Processors", function () {
      return r;
    });
    var r = {};
    n.r(r), n.d(r, "NestedAttributesMultiSelect", function () {
      return In;
    }), n.d(r, "OptionalViewIcon", function () {
      return qi;
    }), n.d(r, "OptionalEditIcon", function () {
      return ea;
    }), n.d(r, "OptionalDeleteIcon", function () {
      return ca;
    }), n.d(r, "ProcessorSelector", function () {
      return rl;
    }), n.d(r, "ViewReportButton", function () {
      return Cp;
    });
    var o = n(0),
        i = n.n(o),
        a = n(2),
        s = n(9),
        c = n(16),
        u = n.n(c),
        l = n(17),
        p = n.n(l),
        f = n(8),
        d = n.n(f);

    function h(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function g(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? h(Object(n), !0).forEach(function (t) {
          d()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var v,
        m = {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: !0,
      transWrapTextNodes: "",
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
      useSuspense: !0
    },
        b = Object(o.createContext)();

    function y() {
      return m;
    }

    var O = function () {
      function e() {
        u()(this, e), this.usedNamespaces = {};
      }

      return p()(e, [{
        key: "addUsedNamespaces",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
          });
        }
      }, {
        key: "getUsedNamespaces",
        value: function () {
          return Object.keys(this.usedNamespaces);
        }
      }]), e;
    }();

    function w() {
      return v;
    }

    var x = {
      type: "3rdParty",
      init: function (e) {
        !function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          m = g(g({}, m), e);
        }(e.options.react), function (e) {
          v = e;
        }(e);
      }
    };

    function j(e) {
      var t = e.i18n,
          n = e.defaultNS,
          r = e.children,
          i = Object(o.useMemo)(function () {
        return {
          i18n: t,
          defaultNS: n
        };
      }, [t, n]);
      return Object(o.createElement)(b.Provider, {
        value: i
      }, r);
    }

    var S = n(10),
        E = n.n(S),
        k = n(18),
        P = n.n(k);

    function C() {
      if (console && console.warn) {
        for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];

        "string" == typeof n[0] && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
      }
    }

    var _ = {};

    function R() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

      "string" == typeof t[0] && _[t[0]] || ("string" == typeof t[0] && (_[t[0]] = new Date()), C.apply(void 0, t));
    }

    function N(e, t, n) {
      e.loadNamespaces(t, function () {
        if (e.isInitialized) n();else {
          e.on("initialized", function t() {
            setTimeout(function () {
              e.off("initialized", t);
            }, 0), n();
          });
        }
      });
    }

    function D(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = t.languages[0],
          o = !!t.options && t.options.fallbackLng,
          i = t.languages[t.languages.length - 1];
      if ("cimode" === r.toLowerCase()) return !0;

      var a = function (e, n) {
        var r = t.services.backendConnector.state["".concat(e, "|").concat(n)];
        return -1 === r || 2 === r;
      };

      return !(n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e)) && (!!t.hasResourceBundle(r, e) || !(t.services.backendConnector.backend && (!t.options.resources || t.options.partialBundledLanguages)) || !(!a(r, e) || o && !a(i, e)));
    }

    function I(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (!t.languages || !t.languages.length) return R("i18n.languages were undefined or empty", t.languages), !0;
      var r = void 0 !== t.options.ignoreJSONStructure;
      return r ? t.hasLoadedNamespace(e, {
        precheck: function (t, r) {
          if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !r(t.isLanguageChangingTo, e)) return !1;
        }
      }) : D(e, t, n);
    }

    function L(e) {
      return e.displayName || e.name || ("string" == typeof e && e.length > 0 ? e : "Unknown");
    }

    function M(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function T(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? M(Object(n), !0).forEach(function (t) {
          d()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var A = function (e, t) {
      var n = Object(o.useRef)();
      return Object(o.useEffect)(function () {
        n.current = t ? n.current : e;
      }, [e, t]), n.current;
    };

    function V(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = t.i18n,
          r = Object(o.useContext)(b) || {},
          i = r.i18n,
          a = r.defaultNS,
          s = n || i || w();

      if (s && !s.reportNamespaces && (s.reportNamespaces = new O()), !s) {
        R("You will need to pass in an i18next instance by using initReactI18next");

        var c = function (e) {
          return Array.isArray(e) ? e[e.length - 1] : e;
        },
            u = [c, {}, !1];

        return u.t = c, u.i18n = {}, u.ready = !1, u;
      }

      s.options.react && void 0 !== s.options.react.wait && R("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
      var l = T(T(T({}, y()), s.options.react), t),
          p = l.useSuspense,
          f = l.keyPrefix,
          d = e || a || s.options && s.options.defaultNS;
      d = "string" == typeof d ? [d] : d || ["translation"], s.reportNamespaces.addUsedNamespaces && s.reportNamespaces.addUsedNamespaces(d);
      var h = (s.isInitialized || s.initializedStoreOnce) && d.every(function (e) {
        return I(e, s, l);
      });

      function g() {
        return s.getFixedT(null, "fallback" === l.nsMode ? d : d[0], f);
      }

      var v = Object(o.useState)(g),
          m = E()(v, 2),
          x = m[0],
          j = m[1],
          S = d.join(),
          k = A(S),
          P = Object(o.useRef)(!0);
      Object(o.useEffect)(function () {
        var e = l.bindI18n,
            t = l.bindI18nStore;

        function n() {
          P.current && j(g);
        }

        return P.current = !0, h || p || N(s, d, function () {
          P.current && j(g);
        }), h && k && k !== S && P.current && j(g), e && s && s.on(e, n), t && s && s.store.on(t, n), function () {
          P.current = !1, e && s && e.split(" ").forEach(function (e) {
            return s.off(e, n);
          }), t && s && t.split(" ").forEach(function (e) {
            return s.store.off(e, n);
          });
        };
      }, [s, S]);
      var C = Object(o.useRef)(!0);
      Object(o.useEffect)(function () {
        P.current && !C.current && j(g), C.current = !1;
      }, [s]);
      var _ = [x, s, h];
      if (_.t = x, _.i18n = s, _.ready = h, h) return _;
      if (!h && !p) return _;
      throw new Promise(function (e) {
        N(s, d, function () {
          e();
        });
      });
    }

    var F = ["forwardedRef"];

    function z(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function H(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? z(Object(n), !0).forEach(function (t) {
          d()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : z(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function U(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return function (n) {
        function r(r) {
          var i = r.forwardedRef,
              a = P()(r, F),
              s = V(e, H(H({}, a), {}, {
            keyPrefix: t.keyPrefix
          })),
              c = E()(s, 3),
              u = c[0],
              l = c[1],
              p = c[2],
              f = H(H({}, a), {}, {
            t: u,
            i18n: l,
            tReady: p
          });
          return t.withRef && i ? f.ref = i : !t.withRef && i && (f.forwardedRef = i), Object(o.createElement)(n, f);
        }

        r.displayName = "withI18nextTranslation(".concat(L(n), ")"), r.WrappedComponent = n;
        return t.withRef ? Object(o.forwardRef)(function (e, t) {
          return Object(o.createElement)(r, Object.assign({}, e, {
            forwardedRef: t
          }));
        }) : r;
      };
    }

    function B(e) {
      return (B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function $(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function q(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function W(e, t, n) {
      return t && q(e.prototype, t), n && q(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function K(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Y(e, t) {
      return (Y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function G(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Y(e, t);
    }

    function J(e, t) {
      if (t && ("object" === B(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return K(e);
    }

    function X(e) {
      return (X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Z(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Q(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];

      return r;
    }

    function ee(e) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Q(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Q(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function te(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ne(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? te(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : te(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var re = {
      type: "logger",
      log: function (e) {
        this.output("log", e);
      },
      warn: function (e) {
        this.output("warn", e);
      },
      error: function (e) {
        this.output("error", e);
      },
      output: function (e, t) {
        console && console[e] && console[e].apply(console, t);
      }
    },
        oe = new (function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        $(this, e), this.init(t, n);
      }

      return W(e, [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.prefix = t.prefix || "i18next:", this.logger = e || re, this.options = t, this.debug = t.debug;
        }
      }, {
        key: "setDebug",
        value: function (e) {
          this.debug = e;
        }
      }, {
        key: "log",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

          return this.forward(t, "log", "", !0);
        }
      }, {
        key: "warn",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

          return this.forward(t, "warn", "", !0);
        }
      }, {
        key: "error",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

          return this.forward(t, "error", "");
        }
      }, {
        key: "deprecate",
        value: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

          return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
        }
      }, {
        key: "forward",
        value: function (e, t, n, r) {
          return r && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(n).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
        }
      }, {
        key: "create",
        value: function (t) {
          return new e(this.logger, ne(ne({}, {
            prefix: "".concat(this.prefix, ":").concat(t, ":")
          }), this.options));
        }
      }]), e;
    }())(),
        ie = function () {
      function e() {
        $(this, e), this.observers = {};
      }

      return W(e, [{
        key: "on",
        value: function (e, t) {
          var n = this;
          return e.split(" ").forEach(function (e) {
            n.observers[e] = n.observers[e] || [], n.observers[e].push(t);
          }), this;
        }
      }, {
        key: "off",
        value: function (e, t) {
          this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
            return e !== t;
          }) : delete this.observers[e]);
        }
      }, {
        key: "emit",
        value: function (e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];

          if (this.observers[e]) {
            var o = [].concat(this.observers[e]);
            o.forEach(function (e) {
              e.apply(void 0, n);
            });
          }

          if (this.observers["*"]) {
            var i = [].concat(this.observers["*"]);
            i.forEach(function (t) {
              t.apply(t, [e].concat(n));
            });
          }
        }
      }]), e;
    }();

    function ae() {
      var e,
          t,
          n = new Promise(function (n, r) {
        e = n, t = r;
      });
      return n.resolve = e, n.reject = t, n;
    }

    function se(e) {
      return null == e ? "" : "" + e;
    }

    function ce(e, t, n) {
      e.forEach(function (e) {
        t[e] && (n[e] = t[e]);
      });
    }

    function ue(e, t, n) {
      function r(e) {
        return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
      }

      function o() {
        return !e || "string" == typeof e;
      }

      for (var i = "string" != typeof t ? [].concat(t) : t.split("."); i.length > 1;) {
        if (o()) return {};
        var a = r(i.shift());
        !e[a] && n && (e[a] = new n()), e = Object.prototype.hasOwnProperty.call(e, a) ? e[a] : {};
      }

      return o() ? {} : {
        obj: e,
        k: r(i.shift())
      };
    }

    function le(e, t, n) {
      var r = ue(e, t, Object);
      r.obj[r.k] = n;
    }

    function pe(e, t) {
      var n = ue(e, t),
          r = n.obj,
          o = n.k;
      if (r) return r[o];
    }

    function fe(e, t, n) {
      var r = pe(e, n);
      return void 0 !== r ? r : pe(t, n);
    }

    function de(e, t, n) {
      for (var r in t) "__proto__" !== r && "constructor" !== r && (r in e ? "string" == typeof e[r] || e[r] instanceof String || "string" == typeof t[r] || t[r] instanceof String ? n && (e[r] = t[r]) : de(e[r], t[r], n) : e[r] = t[r]);

      return e;
    }

    function he(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    var ge = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };

    function ve(e) {
      return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
        return ge[e];
      }) : e;
    }

    var me = "undefined" != typeof window && window.navigator && void 0 === window.navigator.userAgentData && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
        be = [" ", ",", "?", "!", ";"];

    function ye(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Oe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ye(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function we(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = X(e);

        if (t) {
          var o = X(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return J(this, n);
      };
    }

    function xe(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";

      if (e) {
        if (e[t]) return e[t];

        for (var r = t.split(n), o = e, i = 0; i < r.length; ++i) {
          if (!o) return;
          if ("string" == typeof o[r[i]] && i + 1 < r.length) return;

          if (void 0 === o[r[i]]) {
            for (var a = 2, s = r.slice(i, i + a).join(n), c = o[s]; void 0 === c && r.length > i + a;) a++, c = o[s = r.slice(i, i + a).join(n)];

            if (void 0 === c) return;
            if (null === c) return null;

            if (t.endsWith(s)) {
              if ("string" == typeof c) return c;
              if (s && "string" == typeof c[s]) return c[s];
            }

            var u = r.slice(i + a).join(n);
            return u ? xe(c, u, n) : void 0;
          }

          o = o[r[i]];
        }

        return o;
      }
    }

    var je = function (e) {
      G(n, e);
      var t = we(n);

      function n(e) {
        var r,
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          ns: ["translation"],
          defaultNS: "translation"
        };
        return $(this, n), r = t.call(this), me && ie.call(K(r)), r.data = e || {}, r.options = o, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), void 0 === r.options.ignoreJSONStructure && (r.options.ignoreJSONStructure = !0), r;
      }

      return W(n, [{
        key: "addNamespaces",
        value: function (e) {
          this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
        }
      }, {
        key: "removeNamespaces",
        value: function (e) {
          var t = this.options.ns.indexOf(e);
          t > -1 && this.options.ns.splice(t, 1);
        }
      }, {
        key: "getResource",
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = void 0 !== r.keySeparator ? r.keySeparator : this.options.keySeparator,
              i = void 0 !== r.ignoreJSONStructure ? r.ignoreJSONStructure : this.options.ignoreJSONStructure,
              a = [e, t];
          n && "string" != typeof n && (a = a.concat(n)), n && "string" == typeof n && (a = a.concat(o ? n.split(o) : n)), e.indexOf(".") > -1 && (a = e.split("."));
          var s = pe(this.data, a);
          return s || !i || "string" != typeof n ? s : xe(this.data && this.data[e] && this.data[e][t], n, o);
        }
      }, {
        key: "addResource",
        value: function (e, t, n, r) {
          var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
            silent: !1
          },
              i = this.options.keySeparator;
          void 0 === i && (i = ".");
          var a = [e, t];
          n && (a = a.concat(i ? n.split(i) : n)), e.indexOf(".") > -1 && (r = t, t = (a = e.split("."))[1]), this.addNamespaces(t), le(this.data, a, r), o.silent || this.emit("added", e, t, n, r);
        }
      }, {
        key: "addResources",
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            silent: !1
          };

          for (var o in n) "string" != typeof n[o] && "[object Array]" !== Object.prototype.toString.apply(n[o]) || this.addResource(e, t, o, n[o], {
            silent: !0
          });

          r.silent || this.emit("added", e, t, n);
        }
      }, {
        key: "addResourceBundle",
        value: function (e, t, n, r, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
            silent: !1
          },
              a = [e, t];
          e.indexOf(".") > -1 && (r = n, n = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
          var s = pe(this.data, a) || {};
          r ? de(s, n, o) : s = Oe(Oe({}, s), n), le(this.data, a, s), i.silent || this.emit("added", e, t, n);
        }
      }, {
        key: "removeResourceBundle",
        value: function (e, t) {
          this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
        }
      }, {
        key: "hasResourceBundle",
        value: function (e, t) {
          return void 0 !== this.getResource(e, t);
        }
      }, {
        key: "getResourceBundle",
        value: function (e, t) {
          return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? Oe(Oe({}, {}), this.getResource(e, t)) : this.getResource(e, t);
        }
      }, {
        key: "getDataByLanguage",
        value: function (e) {
          return this.data[e];
        }
      }, {
        key: "hasLanguageSomeTranslations",
        value: function (e) {
          var t = this.getDataByLanguage(e);
          return !!(t && Object.keys(t) || []).find(function (e) {
            return t[e] && Object.keys(t[e]).length > 0;
          });
        }
      }, {
        key: "toJSON",
        value: function () {
          return this.data;
        }
      }]), n;
    }(ie),
        Se = {
      processors: {},
      addPostProcessor: function (e) {
        this.processors[e.name] = e;
      },
      handle: function (e, t, n, r, o) {
        var i = this;
        return e.forEach(function (e) {
          i.processors[e] && (t = i.processors[e].process(t, n, r, o));
        }), t;
      }
    };

    function Ee(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ke(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ee(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ee(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function Pe(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = X(e);

        if (t) {
          var o = X(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return J(this, n);
      };
    }

    var Ce = {},
        _e = function (e) {
      G(n, e);
      var t = Pe(n);

      function n(e) {
        var r,
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return $(this, n), r = t.call(this), me && ie.call(K(r)), ce(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, K(r)), r.options = o, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), r.logger = oe.create("translator"), r;
      }

      return W(n, [{
        key: "changeLanguage",
        value: function (e) {
          e && (this.language = e);
        }
      }, {
        key: "exists",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          };
          if (null == e) return !1;
          var n = this.resolve(e, t);
          return n && void 0 !== n.res;
        }
      }, {
        key: "extractFromKey",
        value: function (e, t) {
          var n = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
          void 0 === n && (n = ":");
          var r = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              o = t.ns || this.options.defaultNS || [],
              i = n && e.indexOf(n) > -1,
              a = !(this.options.userDefinedKeySeparator || t.keySeparator || this.options.userDefinedNsSeparator || t.nsSeparator || function (e, t, n) {
            t = t || "", n = n || "";
            var r = be.filter(function (e) {
              return t.indexOf(e) < 0 && n.indexOf(e) < 0;
            });
            if (0 === r.length) return !0;
            var o = new RegExp("(".concat(r.map(function (e) {
              return "?" === e ? "\\?" : e;
            }).join("|"), ")")),
                i = !o.test(e);

            if (!i) {
              var a = e.indexOf(n);
              a > 0 && !o.test(e.substring(0, a)) && (i = !0);
            }

            return i;
          }(e, n, r));

          if (i && !a) {
            var s = e.match(this.interpolator.nestingRegexp);
            if (s && s.length > 0) return {
              key: e,
              namespaces: o
            };
            var c = e.split(n);
            (n !== r || n === r && this.options.ns.indexOf(c[0]) > -1) && (o = c.shift()), e = c.join(r);
          }

          return "string" == typeof o && (o = [o]), {
            key: e,
            namespaces: o
          };
        }
      }, {
        key: "translate",
        value: function (e, t, r) {
          var o = this;
          if ("object" !== B(t) && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), t || (t = {}), null == e) return "";
          Array.isArray(e) || (e = [String(e)]);
          var i = void 0 !== t.returnDetails ? t.returnDetails : this.options.returnDetails,
              a = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              s = this.extractFromKey(e[e.length - 1], t),
              c = s.key,
              u = s.namespaces,
              l = u[u.length - 1],
              p = t.lng || this.language,
              f = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

          if (p && "cimode" === p.toLowerCase()) {
            if (f) {
              var d = t.nsSeparator || this.options.nsSeparator;
              return i ? (h.res = "".concat(l).concat(d).concat(c), h) : "".concat(l).concat(d).concat(c);
            }

            return i ? (h.res = c, h) : c;
          }

          var h = this.resolve(e, t),
              g = h && h.res,
              v = h && h.usedKey || c,
              m = h && h.exactUsedKey || c,
              b = Object.prototype.toString.apply(g),
              y = ["[object Number]", "[object Function]", "[object RegExp]"],
              O = void 0 !== t.joinArrays ? t.joinArrays : this.options.joinArrays,
              w = !this.i18nFormat || this.i18nFormat.handleAsObject,
              x = "string" != typeof g && "boolean" != typeof g && "number" != typeof g;

          if (w && g && x && y.indexOf(b) < 0 && ("string" != typeof O || "[object Array]" !== b)) {
            if (!t.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
              var j = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(v, g, ke(ke({}, t), {}, {
                ns: u
              })) : "key '".concat(c, " (").concat(this.language, ")' returned an object instead of string.");
              return i ? (h.res = j, h) : j;
            }

            if (a) {
              var S = "[object Array]" === b,
                  E = S ? [] : {},
                  k = S ? m : v;

              for (var P in g) if (Object.prototype.hasOwnProperty.call(g, P)) {
                var C = "".concat(k).concat(a).concat(P);
                E[P] = this.translate(C, ke(ke({}, t), {
                  joinArrays: !1,
                  ns: u
                })), E[P] === C && (E[P] = g[P]);
              }

              g = E;
            }
          } else if (w && "string" == typeof O && "[object Array]" === b) (g = g.join(O)) && (g = this.extendTranslation(g, e, t, r));else {
            var _ = !1,
                R = !1,
                N = void 0 !== t.count && "string" != typeof t.count,
                D = n.hasDefaultValue(t),
                I = N ? this.pluralResolver.getSuffix(p, t.count, t) : "",
                L = t["defaultValue".concat(I)] || t.defaultValue;

            !this.isValidLookup(g) && D && (_ = !0, g = L), this.isValidLookup(g) || (R = !0, g = c);
            var M = t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey,
                T = M && R ? void 0 : g,
                A = D && L !== g && this.options.updateMissing;

            if (R || _ || A) {
              if (this.logger.log(A ? "updateKey" : "missingKey", p, l, c, A ? L : g), a) {
                var V = this.resolve(c, ke(ke({}, t), {}, {
                  keySeparator: !1
                }));
                V && V.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
              }

              var F = [],
                  z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
              if ("fallback" === this.options.saveMissingTo && z && z[0]) for (var H = 0; H < z.length; H++) F.push(z[H]);else "all" === this.options.saveMissingTo ? F = this.languageUtils.toResolveHierarchy(t.lng || this.language) : F.push(t.lng || this.language);

              var U = function (e, n, r) {
                var i = D && r !== g ? r : T;
                o.options.missingKeyHandler ? o.options.missingKeyHandler(e, l, n, i, A, t) : o.backendConnector && o.backendConnector.saveMissing && o.backendConnector.saveMissing(e, l, n, i, A, t), o.emit("missingKey", e, l, n, g);
              };

              this.options.saveMissing && (this.options.saveMissingPlurals && N ? F.forEach(function (e) {
                o.pluralResolver.getSuffixes(e, t).forEach(function (n) {
                  U([e], c + n, t["defaultValue".concat(n)] || L);
                });
              }) : U(F, c, L));
            }

            g = this.extendTranslation(g, e, t, h, r), R && g === c && this.options.appendNamespaceToMissingKey && (g = "".concat(l, ":").concat(c)), (R || _) && this.options.parseMissingKeyHandler && (g = "v1" !== this.options.compatibilityAPI ? this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(l, ":").concat(c) : c, _ ? g : void 0) : this.options.parseMissingKeyHandler(g));
          }

          return i ? (h.res = g, h) : g;
        }
      }, {
        key: "extendTranslation",
        value: function (e, t, n, r, o) {
          var i = this;
          if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, ke(ke({}, this.options.interpolation.defaultVariables), n), r.usedLng, r.usedNS, r.usedKey, {
            resolved: r
          });else if (!n.skipInterpolation) {
            n.interpolation && this.interpolator.init(ke(ke({}, n), {
              interpolation: ke(ke({}, this.options.interpolation), n.interpolation)
            }));
            var a,
                s = "string" == typeof e && (n && n.interpolation && void 0 !== n.interpolation.skipOnVariables ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);

            if (s) {
              var c = e.match(this.interpolator.nestingRegexp);
              a = c && c.length;
            }

            var u = n.replace && "string" != typeof n.replace ? n.replace : n;

            if (this.options.interpolation.defaultVariables && (u = ke(ke({}, this.options.interpolation.defaultVariables), u)), e = this.interpolator.interpolate(e, u, n.lng || this.language, n), s) {
              var l = e.match(this.interpolator.nestingRegexp);
              a < (l && l.length) && (n.nest = !1);
            }

            !1 !== n.nest && (e = this.interpolator.nest(e, function () {
              for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++) r[a] = arguments[a];

              return o && o[0] === r[0] && !n.context ? (i.logger.warn("It seems you are nesting recursively key: ".concat(r[0], " in key: ").concat(t[0])), null) : i.translate.apply(i, r.concat([t]));
            }, n)), n.interpolation && this.interpolator.reset();
          }
          var p = n.postProcess || this.options.postProcess,
              f = "string" == typeof p ? [p] : p;
          return null != e && f && f.length && !1 !== n.applyPostProcessor && (e = Se.handle(f, e, t, this.options && this.options.postProcessPassResolved ? ke({
            i18nResolved: r
          }, n) : n, this)), e;
        }
      }, {
        key: "resolve",
        value: function (e) {
          var t,
              n,
              r,
              o,
              i,
              a = this,
              s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof e && (e = [e]), e.forEach(function (e) {
            if (!a.isValidLookup(t)) {
              var c = a.extractFromKey(e, s),
                  u = c.key;
              n = u;
              var l = c.namespaces;
              a.options.fallbackNS && (l = l.concat(a.options.fallbackNS));
              var p = void 0 !== s.count && "string" != typeof s.count,
                  f = p && !s.ordinal && 0 === s.count && a.pluralResolver.shouldUseIntlApi(),
                  d = void 0 !== s.context && ("string" == typeof s.context || "number" == typeof s.context) && "" !== s.context,
                  h = s.lngs ? s.lngs : a.languageUtils.toResolveHierarchy(s.lng || a.language, s.fallbackLng);
              l.forEach(function (e) {
                a.isValidLookup(t) || (i = e, !Ce["".concat(h[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(i) && (Ce["".concat(h[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(n, '" for languages "').concat(h.join(", "), '" won\'t get resolved as namespace "').concat(i, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach(function (n) {
                  if (!a.isValidLookup(t)) {
                    o = n;
                    var i,
                        c = [u];
                    if (a.i18nFormat && a.i18nFormat.addLookupKeys) a.i18nFormat.addLookupKeys(c, u, n, e, s);else {
                      var l;
                      p && (l = a.pluralResolver.getSuffix(n, s.count, s));

                      if (p && (c.push(u + l), f && c.push(u + "_zero")), d) {
                        var h = "".concat(u).concat(a.options.contextSeparator).concat(s.context);
                        c.push(h), p && (c.push(h + l), f && c.push(h + "_zero"));
                      }
                    }

                    for (; i = c.pop();) a.isValidLookup(t) || (r = i, t = a.getResource(n, e, i, s));
                  }
                }));
              });
            }
          }), {
            res: t,
            usedKey: n,
            exactUsedKey: r,
            usedLng: o,
            usedNS: i
          };
        }
      }, {
        key: "isValidLookup",
        value: function (e) {
          return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
        }
      }, {
        key: "getResource",
        value: function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, n, r) : this.resourceStore.getResource(e, t, n, r);
        }
      }], [{
        key: "hasDefaultValue",
        value: function (e) {
          for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t) && "defaultValue" === t.substring(0, "defaultValue".length) && void 0 !== e[t]) return !0;

          return !1;
        }
      }]), n;
    }(ie);

    function Re(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }

    var Ne = function () {
      function e(t) {
        $(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = oe.create("languageUtils");
      }

      return W(e, [{
        key: "getScriptPartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return null;
          var t = e.split("-");
          return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
        }
      }, {
        key: "getLanguagePartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return e;
          var t = e.split("-");
          return this.formatLanguageCode(t[0]);
        }
      }, {
        key: "formatLanguageCode",
        value: function (e) {
          if ("string" == typeof e && e.indexOf("-") > -1) {
            var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                n = e.split("-");
            return this.options.lowerCaseLng ? n = n.map(function (e) {
              return e.toLowerCase();
            }) : 2 === n.length ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = Re(n[1].toLowerCase()))) : 3 === n.length && (n[0] = n[0].toLowerCase(), 2 === n[1].length && (n[1] = n[1].toUpperCase()), "sgn" !== n[0] && 2 === n[2].length && (n[2] = n[2].toUpperCase()), t.indexOf(n[1].toLowerCase()) > -1 && (n[1] = Re(n[1].toLowerCase())), t.indexOf(n[2].toLowerCase()) > -1 && (n[2] = Re(n[2].toLowerCase()))), n.join("-");
          }

          return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
        }
      }, {
        key: "isSupportedCode",
        value: function (e) {
          return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
        }
      }, {
        key: "getBestMatchFromCodes",
        value: function (e) {
          var t,
              n = this;
          return e ? (e.forEach(function (e) {
            if (!t) {
              var r = n.formatLanguageCode(e);
              n.options.supportedLngs && !n.isSupportedCode(r) || (t = r);
            }
          }), !t && this.options.supportedLngs && e.forEach(function (e) {
            if (!t) {
              var r = n.getLanguagePartFromCode(e);
              if (n.isSupportedCode(r)) return t = r;
              t = n.options.supportedLngs.find(function (e) {
                if (0 === e.indexOf(r)) return e;
              });
            }
          }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
        }
      }, {
        key: "getFallbackCodes",
        value: function (e, t) {
          if (!e) return [];
          if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
          if (!t) return e.default || [];
          var n = e[t];
          return n || (n = e[this.getScriptPartFromCode(t)]), n || (n = e[this.formatLanguageCode(t)]), n || (n = e[this.getLanguagePartFromCode(t)]), n || (n = e.default), n || [];
        }
      }, {
        key: "toResolveHierarchy",
        value: function (e, t) {
          var n = this,
              r = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
              o = [],
              i = function (e) {
            e && (n.isSupportedCode(e) ? o.push(e) : n.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
          };

          return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && i(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && i(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && i(this.getLanguagePartFromCode(e))) : "string" == typeof e && i(this.formatLanguageCode(e)), r.forEach(function (e) {
            o.indexOf(e) < 0 && i(n.formatLanguageCode(e));
          }), o;
        }
      }]), e;
    }(),
        De = [{
      lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
      nr: [1, 2],
      fc: 1
    }, {
      lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
      nr: [1, 2],
      fc: 2
    }, {
      lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
      nr: [1],
      fc: 3
    }, {
      lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
      nr: [1, 2, 5],
      fc: 4
    }, {
      lngs: ["ar"],
      nr: [0, 1, 2, 3, 11, 100],
      fc: 5
    }, {
      lngs: ["cs", "sk"],
      nr: [1, 2, 5],
      fc: 6
    }, {
      lngs: ["csb", "pl"],
      nr: [1, 2, 5],
      fc: 7
    }, {
      lngs: ["cy"],
      nr: [1, 2, 3, 8],
      fc: 8
    }, {
      lngs: ["fr"],
      nr: [1, 2],
      fc: 9
    }, {
      lngs: ["ga"],
      nr: [1, 2, 3, 7, 11],
      fc: 10
    }, {
      lngs: ["gd"],
      nr: [1, 2, 3, 20],
      fc: 11
    }, {
      lngs: ["is"],
      nr: [1, 2],
      fc: 12
    }, {
      lngs: ["jv"],
      nr: [0, 1],
      fc: 13
    }, {
      lngs: ["kw"],
      nr: [1, 2, 3, 4],
      fc: 14
    }, {
      lngs: ["lt"],
      nr: [1, 2, 10],
      fc: 15
    }, {
      lngs: ["lv"],
      nr: [1, 2, 0],
      fc: 16
    }, {
      lngs: ["mk"],
      nr: [1, 2],
      fc: 17
    }, {
      lngs: ["mnk"],
      nr: [0, 1, 2],
      fc: 18
    }, {
      lngs: ["mt"],
      nr: [1, 2, 11, 20],
      fc: 19
    }, {
      lngs: ["or"],
      nr: [2, 1],
      fc: 2
    }, {
      lngs: ["ro"],
      nr: [1, 2, 20],
      fc: 20
    }, {
      lngs: ["sl"],
      nr: [5, 1, 2, 3],
      fc: 21
    }, {
      lngs: ["he", "iw"],
      nr: [1, 2, 20, 21],
      fc: 22
    }],
        Ie = {
      1: function (e) {
        return Number(e > 1);
      },
      2: function (e) {
        return Number(1 != e);
      },
      3: function (e) {
        return 0;
      },
      4: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      5: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
      },
      6: function (e) {
        return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
      },
      7: function (e) {
        return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      8: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
      },
      9: function (e) {
        return Number(e >= 2);
      },
      10: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
      },
      11: function (e) {
        return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
      },
      12: function (e) {
        return Number(e % 10 != 1 || e % 100 == 11);
      },
      13: function (e) {
        return Number(0 !== e);
      },
      14: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
      },
      15: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      16: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
      },
      17: function (e) {
        return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
      },
      18: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2);
      },
      19: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
      },
      20: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
      },
      21: function (e) {
        return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
      },
      22: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
      }
    },
        Le = ["v1", "v2", "v3"],
        Me = {
      zero: 0,
      one: 1,
      two: 2,
      few: 3,
      many: 4,
      other: 5
    };

    function Te() {
      var e = {};
      return De.forEach(function (t) {
        t.lngs.forEach(function (n) {
          e[n] = {
            numbers: t.nr,
            plurals: Ie[t.fc]
          };
        });
      }), e;
    }

    var Ae = function () {
      function e(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        $(this, e), this.languageUtils = t, this.options = n, this.logger = oe.create("pluralResolver"), this.options.compatibilityJSON && "v4" !== this.options.compatibilityJSON || "undefined" != typeof Intl && Intl.PluralRules || (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Te();
      }

      return W(e, [{
        key: "addRule",
        value: function (e, t) {
          this.rules[e] = t;
        }
      }, {
        key: "getRule",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules(e, {
              type: t.ordinal ? "ordinal" : "cardinal"
            });
          } catch (e) {
            return;
          }
          return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
        }
      }, {
        key: "needsPlural",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.getRule(e, t);
          return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
        }
      }, {
        key: "getPluralFormsOfKey",
        value: function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return this.getSuffixes(e, n).map(function (e) {
            return "".concat(t).concat(e);
          });
        }
      }, {
        key: "getSuffixes",
        value: function (e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.getRule(e, n);
          return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort(function (e, t) {
            return Me[e] - Me[t];
          }).map(function (e) {
            return "".concat(t.options.prepend).concat(e);
          }) : r.numbers.map(function (r) {
            return t.getSuffix(e, r, n);
          }) : [];
        }
      }, {
        key: "getSuffix",
        value: function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.getRule(e, n);
          return r ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(r.select(t)) : this.getSuffixRetroCompatible(r, t) : (this.logger.warn("no plural rule found for: ".concat(e)), "");
        }
      }, {
        key: "getSuffixRetroCompatible",
        value: function (e, t) {
          var n = this,
              r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t)),
              o = e.numbers[r];
          this.options.simplifyPluralSuffix && 2 === e.numbers.length && 1 === e.numbers[0] && (2 === o ? o = "plural" : 1 === o && (o = ""));

          var i = function () {
            return n.options.prepend && o.toString() ? n.options.prepend + o.toString() : o.toString();
          };

          return "v1" === this.options.compatibilityJSON ? 1 === o ? "" : "number" == typeof o ? "_plural_".concat(o.toString()) : i() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === e.numbers.length && 1 === e.numbers[0] ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
        }
      }, {
        key: "shouldUseIntlApi",
        value: function () {
          return !Le.includes(this.options.compatibilityJSON);
        }
      }]), e;
    }();

    function Ve(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Fe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ve(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ve(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var ze = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        $(this, e), this.logger = oe.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
          return e;
        }, this.init(t);
      }

      return W(e, [{
        key: "init",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e.interpolation || (e.interpolation = {
            escapeValue: !0
          });
          var t = e.interpolation;
          this.escape = void 0 !== t.escape ? t.escape : ve, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? he(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? he(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? he(t.nestingPrefix) : t.nestingPrefixEscaped || he("$t("), this.nestingSuffix = t.nestingSuffix ? he(t.nestingSuffix) : t.nestingSuffixEscaped || he(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
        }
      }, {
        key: "reset",
        value: function () {
          this.options && this.init(this.options);
        }
      }, {
        key: "resetRegExp",
        value: function () {
          var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
          this.regexp = new RegExp(e, "g");
          var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
          this.regexpUnescape = new RegExp(t, "g");
          var n = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
          this.nestingRegexp = new RegExp(n, "g");
        }
      }, {
        key: "interpolate",
        value: function (e, t, n, r) {
          var o,
              i,
              a,
              s = this,
              c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

          function u(e) {
            return e.replace(/\$/g, "$$$$");
          }

          var l = function (e) {
            if (e.indexOf(s.formatSeparator) < 0) {
              var o = fe(t, c, e);
              return s.alwaysFormat ? s.format(o, void 0, n, Fe(Fe(Fe({}, r), t), {}, {
                interpolationkey: e
              })) : o;
            }

            var i = e.split(s.formatSeparator),
                a = i.shift().trim(),
                u = i.join(s.formatSeparator).trim();
            return s.format(fe(t, c, a), u, n, Fe(Fe(Fe({}, r), t), {}, {
              interpolationkey: a
            }));
          };

          this.resetRegExp();
          var p = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler,
              f = r && r.interpolation && void 0 !== r.interpolation.skipOnVariables ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
          return [{
            regex: this.regexpUnescape,
            safeValue: function (e) {
              return u(e);
            }
          }, {
            regex: this.regexp,
            safeValue: function (e) {
              return s.escapeValue ? u(s.escape(e)) : u(e);
            }
          }].forEach(function (t) {
            for (a = 0; o = t.regex.exec(e);) {
              var n = o[1].trim();
              if (void 0 === (i = l(n))) {
                if ("function" == typeof p) {
                  var c = p(e, o, r);
                  i = "string" == typeof c ? c : "";
                } else if (r && r.hasOwnProperty(n)) i = "";else {
                  if (f) {
                    i = o[0];
                    continue;
                  }

                  s.logger.warn("missed to pass in variable ".concat(n, " for interpolating ").concat(e)), i = "";
                }
              } else "string" == typeof i || s.useRawValueToEscape || (i = se(i));
              var u = t.safeValue(i);
              if (e = e.replace(o[0], u), f ? (t.regex.lastIndex += i.length, t.regex.lastIndex -= o[0].length) : t.regex.lastIndex = 0, ++a >= s.maxReplaces) break;
            }
          }), e;
        }
      }, {
        key: "nest",
        value: function (e, t) {
          var n,
              r,
              o = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = Fe({}, i);

          function s(e, t) {
            var n = this.nestingOptionsSeparator;
            if (e.indexOf(n) < 0) return e;
            var r = e.split(new RegExp("".concat(n, "[ ]*{"))),
                o = "{".concat(r[1]);
            e = r[0], o = (o = this.interpolate(o, a)).replace(/'/g, '"');

            try {
              a = JSON.parse(o), t && (a = Fe(Fe({}, t), a));
            } catch (t) {
              return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(n).concat(o);
            }

            return delete a.defaultValue, e;
          }

          for (a.applyPostProcessor = !1, delete a.defaultValue; n = this.nestingRegexp.exec(e);) {
            var c = [],
                u = !1;

            if (-1 !== n[0].indexOf(this.formatSeparator) && !/{.*}/.test(n[1])) {
              var l = n[1].split(this.formatSeparator).map(function (e) {
                return e.trim();
              });
              n[1] = l.shift(), c = l, u = !0;
            }

            if ((r = t(s.call(this, n[1].trim(), a), a)) && n[0] === e && "string" != typeof r) return r;
            "string" != typeof r && (r = se(r)), r || (this.logger.warn("missed to resolve ".concat(n[1], " for nesting ").concat(e)), r = ""), u && (r = c.reduce(function (e, t) {
              return o.format(e, t, i.lng, Fe(Fe({}, i), {}, {
                interpolationkey: n[1].trim()
              }));
            }, r.trim())), e = e.replace(n[0], r), this.regexp.lastIndex = 0;
          }

          return e;
        }
      }]), e;
    }();

    function He(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Ue(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? He(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : He(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    var Be = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        $(this, e), this.logger = oe.create("formatter"), this.options = t, this.formats = {
          number: function (e, t, n) {
            return new Intl.NumberFormat(t, n).format(e);
          },
          currency: function (e, t, n) {
            return new Intl.NumberFormat(t, Ue(Ue({}, n), {}, {
              style: "currency"
            })).format(e);
          },
          datetime: function (e, t, n) {
            return new Intl.DateTimeFormat(t, Ue({}, n)).format(e);
          },
          relativetime: function (e, t, n) {
            return new Intl.RelativeTimeFormat(t, Ue({}, n)).format(e, n.range || "day");
          },
          list: function (e, t, n) {
            return new Intl.ListFormat(t, Ue({}, n)).format(e);
          }
        }, this.init(t);
      }

      return W(e, [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          },
              n = t.interpolation;
          this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",";
        }
      }, {
        key: "add",
        value: function (e, t) {
          this.formats[e.toLowerCase().trim()] = t;
        }
      }, {
        key: "format",
        value: function (e, t, n, r) {
          var o = this;
          return t.split(this.formatSeparator).reduce(function (e, t) {
            var i = function (e) {
              var t = e.toLowerCase().trim(),
                  n = {};

              if (e.indexOf("(") > -1) {
                var r = e.split("(");
                t = r[0].toLowerCase().trim();
                var o = r[1].substring(0, r[1].length - 1);
                if ("currency" === t && o.indexOf(":") < 0) n.currency || (n.currency = o.trim());else if ("relativetime" === t && o.indexOf(":") < 0) n.range || (n.range = o.trim());else {
                  o.split(";").forEach(function (e) {
                    if (e) {
                      var t = ee(e.split(":")),
                          r = t[0],
                          o = t.slice(1).join(":").trim().replace(/^'+|'+$/g, "");
                      n[r.trim()] || (n[r.trim()] = o), "false" === o && (n[r.trim()] = !1), "true" === o && (n[r.trim()] = !0), isNaN(o) || (n[r.trim()] = parseInt(o, 10));
                    }
                  });
                }
              }

              return {
                formatName: t,
                formatOptions: n
              };
            }(t),
                a = i.formatName,
                s = i.formatOptions;

            if (o.formats[a]) {
              var c = e;

              try {
                var u = r && r.formatParams && r.formatParams[r.interpolationkey] || {},
                    l = u.locale || u.lng || r.locale || r.lng || n;
                c = o.formats[a](e, l, Ue(Ue(Ue({}, s), r), u));
              } catch (e) {
                o.logger.warn(e);
              }

              return c;
            }

            return o.logger.warn("there was no format function for ".concat(a)), e;
          }, e);
        }
      }]), e;
    }();

    function $e(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function qe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $e(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $e(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function We(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = X(e);

        if (t) {
          var o = X(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return J(this, n);
      };
    }

    var Ke = function (e) {
      G(n, e);
      var t = We(n);

      function n(e, r, o) {
        var i,
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return $(this, n), i = t.call(this), me && ie.call(K(i)), i.backend = e, i.store = r, i.services = o, i.languageUtils = o.languageUtils, i.options = a, i.logger = oe.create("backendConnector"), i.waitingReads = [], i.maxParallelReads = a.maxParallelReads || 10, i.readingCalls = 0, i.state = {}, i.queue = [], i.backend && i.backend.init && i.backend.init(o, a.backend, a), i;
      }

      return W(n, [{
        key: "queueLoad",
        value: function (e, t, n, r) {
          var o = this,
              i = {},
              a = {},
              s = {},
              c = {};
          return e.forEach(function (e) {
            var r = !0;
            t.forEach(function (t) {
              var s = "".concat(e, "|").concat(t);
              !n.reload && o.store.hasResourceBundle(e, t) ? o.state[s] = 2 : o.state[s] < 0 || (1 === o.state[s] ? void 0 === a[s] && (a[s] = !0) : (o.state[s] = 1, r = !1, void 0 === a[s] && (a[s] = !0), void 0 === i[s] && (i[s] = !0), void 0 === c[t] && (c[t] = !0)));
            }), r || (s[e] = !0);
          }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
            pending: a,
            pendingCount: Object.keys(a).length,
            loaded: {},
            errors: [],
            callback: r
          }), {
            toLoad: Object.keys(i),
            pending: Object.keys(a),
            toLoadLanguages: Object.keys(s),
            toLoadNamespaces: Object.keys(c)
          };
        }
      }, {
        key: "loaded",
        value: function (e, t, n) {
          var r = e.split("|"),
              o = r[0],
              i = r[1];
          t && this.emit("failedLoading", o, i, t), n && this.store.addResourceBundle(o, i, n), this.state[e] = t ? -1 : 2;
          var a = {};
          this.queue.forEach(function (n) {
            !function (e, t, n, r) {
              var o = ue(e, t, Object),
                  i = o.obj,
                  a = o.k;
              i[a] = i[a] || [], r && (i[a] = i[a].concat(n)), r || i[a].push(n);
            }(n.loaded, [o], i), function (e, t) {
              void 0 !== e.pending[t] && (delete e.pending[t], e.pendingCount--);
            }(n, e), t && n.errors.push(t), 0 !== n.pendingCount || n.done || (Object.keys(n.loaded).forEach(function (e) {
              a[e] || (a[e] = {});
              var t = n.loaded[e];
              t.length && t.forEach(function (t) {
                void 0 === a[e][t] && (a[e][t] = !0);
              });
            }), n.done = !0, n.errors.length ? n.callback(n.errors) : n.callback());
          }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
            return !e.done;
          });
        }
      }, {
        key: "read",
        value: function (e, t, n) {
          var r = this,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350,
              a = arguments.length > 5 ? arguments[5] : void 0;
          return e.length ? this.readingCalls >= this.maxParallelReads ? void this.waitingReads.push({
            lng: e,
            ns: t,
            fcName: n,
            tried: o,
            wait: i,
            callback: a
          }) : (this.readingCalls++, this.backend[n](e, t, function (s, c) {
            if (s && c && o < 5) setTimeout(function () {
              r.read.call(r, e, t, n, o + 1, 2 * i, a);
            }, i);else {
              if (r.readingCalls--, r.waitingReads.length > 0) {
                var u = r.waitingReads.shift();
                r.read(u.lng, u.ns, u.fcName, u.tried, u.wait, u.callback);
              }

              a(s, c);
            }
          })) : a(null, {});
        }
      }, {
        key: "prepareLoading",
        value: function (e, t) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = arguments.length > 3 ? arguments[3] : void 0;
          if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
          "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
          var i = this.queueLoad(e, t, r, o);
          if (!i.toLoad.length) return i.pending.length || o(), null;
          i.toLoad.forEach(function (e) {
            n.loadOne(e);
          });
        }
      }, {
        key: "load",
        value: function (e, t, n) {
          this.prepareLoading(e, t, {}, n);
        }
      }, {
        key: "reload",
        value: function (e, t, n) {
          this.prepareLoading(e, t, {
            reload: !0
          }, n);
        }
      }, {
        key: "loadOne",
        value: function (e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              r = e.split("|"),
              o = r[0],
              i = r[1];
          this.read(o, i, "read", void 0, void 0, function (r, a) {
            r && t.logger.warn("".concat(n, "loading namespace ").concat(i, " for language ").concat(o, " failed"), r), !r && a && t.logger.log("".concat(n, "loaded namespace ").concat(i, " for language ").concat(o), a), t.loaded(e, r, a);
          });
        }
      }, {
        key: "saveMissing",
        value: function (e, t, n, r, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(n, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != n && "" !== n && (this.backend && this.backend.create && this.backend.create(e, t, n, r, null, qe(qe({}, i), {}, {
            isUpdate: o
          })), e && e[0] && this.store.addResource(e[0], t, n, r));
        }
      }]), n;
    }(ie);

    function Ye() {
      return {
        debug: !1,
        initImmediate: !0,
        ns: ["translation"],
        defaultNS: ["translation"],
        fallbackLng: ["dev"],
        fallbackNS: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: "all",
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: "fallback",
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !0,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: function (e) {
          var t = {};

          if ("object" === B(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === B(e[2]) || "object" === B(e[3])) {
            var n = e[3] || e[2];
            Object.keys(n).forEach(function (e) {
              t[e] = n[e];
            });
          }

          return t;
        },
        interpolation: {
          escapeValue: !0,
          format: function (e, t, n, r) {
            return e;
          },
          prefix: "{{",
          suffix: "}}",
          formatSeparator: ",",
          unescapePrefix: "-",
          nestingPrefix: "$t(",
          nestingSuffix: ")",
          nestingOptionsSeparator: ",",
          maxReplaces: 1e3,
          skipOnVariables: !0
        }
      };
    }

    function Ge(e) {
      return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
    }

    function Je(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Xe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Je(Object(n), !0).forEach(function (t) {
          Z(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Je(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function Ze(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = X(e);

        if (t) {
          var o = X(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return J(this, n);
      };
    }

    function Qe() {}

    function et(e) {
      Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach(function (t) {
        "function" == typeof e[t] && (e[t] = e[t].bind(e));
      });
    }

    var tt = function (e) {
      G(n, e);
      var t = Ze(n);

      function n() {
        var e,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = arguments.length > 1 ? arguments[1] : void 0;

        if ($(this, n), e = t.call(this), me && ie.call(K(e)), e.options = Ge(r), e.services = {}, e.logger = oe, e.modules = {
          external: []
        }, et(K(e)), o && !e.isInitialized && !r.isClone) {
          if (!e.options.initImmediate) return e.init(r, o), J(e, K(e));
          setTimeout(function () {
            e.init(r, o);
          }, 0);
        }

        return e;
      }

      return W(n, [{
        key: "init",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 ? arguments[1] : void 0;
          "function" == typeof t && (n = t, t = {}), !t.defaultNS && t.ns && ("string" == typeof t.ns ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
          var r = Ye();

          function o(e) {
            return e ? "function" == typeof e ? new e() : e : null;
          }

          if (this.options = Xe(Xe(Xe({}, r), this.options), Ge(t)), "v1" !== this.options.compatibilityAPI && (this.options.interpolation = Xe(Xe({}, r.interpolation), this.options.interpolation)), void 0 !== t.keySeparator && (this.options.userDefinedKeySeparator = t.keySeparator), void 0 !== t.nsSeparator && (this.options.userDefinedNsSeparator = t.nsSeparator), !this.options.isClone) {
            var i;
            this.modules.logger ? oe.init(o(this.modules.logger), this.options) : oe.init(null, this.options), this.modules.formatter ? i = this.modules.formatter : "undefined" != typeof Intl && (i = Be);
            var a = new Ne(this.options);
            this.store = new je(this.options.resources, this.options);
            var s = this.services;
            s.logger = oe, s.resourceStore = this.store, s.languageUtils = a, s.pluralResolver = new Ae(a, {
              prepend: this.options.pluralSeparator,
              compatibilityJSON: this.options.compatibilityJSON,
              simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }), !i || this.options.interpolation.format && this.options.interpolation.format !== r.interpolation.format || (s.formatter = o(i), s.formatter.init(s, this.options), this.options.interpolation.format = s.formatter.format.bind(s.formatter)), s.interpolator = new ze(this.options), s.utils = {
              hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            }, s.backendConnector = new Ke(o(this.modules.backend), s.resourceStore, s, this.options), s.backendConnector.on("*", function (t) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];

              e.emit.apply(e, [t].concat(r));
            }), this.modules.languageDetector && (s.languageDetector = o(this.modules.languageDetector), s.languageDetector.init(s, this.options.detection, this.options)), this.modules.i18nFormat && (s.i18nFormat = o(this.modules.i18nFormat), s.i18nFormat.init && s.i18nFormat.init(this)), this.translator = new _e(this.services, this.options), this.translator.on("*", function (t) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];

              e.emit.apply(e, [t].concat(r));
            }), this.modules.external.forEach(function (t) {
              t.init && t.init(e);
            });
          }

          if (this.format = this.options.interpolation.format, n || (n = Qe), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            var c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            c.length > 0 && "dev" !== c[0] && (this.options.lng = c[0]);
          }

          this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
          var u = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
          u.forEach(function (t) {
            e[t] = function () {
              var n;
              return (n = e.store)[t].apply(n, arguments);
            };
          });
          var l = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
          l.forEach(function (t) {
            e[t] = function () {
              var n;
              return (n = e.store)[t].apply(n, arguments), e;
            };
          });

          var p = ae(),
              f = function () {
            var t = function (t, r) {
              e.isInitialized && !e.initializedStoreOnce && e.logger.warn("init: i18next is already initialized. You should call init just once!"), e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), p.resolve(r), n(t, r);
            };

            if (e.languages && "v1" !== e.options.compatibilityAPI && !e.isInitialized) return t(null, e.t.bind(e));
            e.changeLanguage(e.options.lng, t);
          };

          return this.options.resources || !this.options.initImmediate ? f() : setTimeout(f, 0), p;
        }
      }, {
        key: "loadResources",
        value: function (e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Qe,
              r = n,
              o = "string" == typeof e ? e : this.language;

          if ("function" == typeof e && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
            if (o && "cimode" === o.toLowerCase()) return r();

            var i = [],
                a = function (e) {
              e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                i.indexOf(e) < 0 && i.push(e);
              });
            };

            if (o) a(o);else {
              var s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
              s.forEach(function (e) {
                return a(e);
              });
            }
            this.options.preload && this.options.preload.forEach(function (e) {
              return a(e);
            }), this.services.backendConnector.load(i, this.options.ns, function (e) {
              e || t.resolvedLanguage || !t.language || t.setResolvedLanguage(t.language), r(e);
            });
          } else r(null);
        }
      }, {
        key: "reloadResources",
        value: function (e, t, n) {
          var r = ae();
          return e || (e = this.languages), t || (t = this.options.ns), n || (n = Qe), this.services.backendConnector.reload(e, t, function (e) {
            r.resolve(), n(e);
          }), r;
        }
      }, {
        key: "use",
        value: function (e) {
          if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
          if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
          return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && Se.addPostProcessor(e), "formatter" === e.type && (this.modules.formatter = e), "3rdParty" === e.type && this.modules.external.push(e), this;
        }
      }, {
        key: "setResolvedLanguage",
        value: function (e) {
          if (e && this.languages && !(["cimode", "dev"].indexOf(e) > -1)) for (var t = 0; t < this.languages.length; t++) {
            var n = this.languages[t];

            if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
              this.resolvedLanguage = n;
              break;
            }
          }
        }
      }, {
        key: "changeLanguage",
        value: function (e, t) {
          var n = this;
          this.isLanguageChangingTo = e;
          var r = ae();
          this.emit("languageChanging", e);

          var o = function (e) {
            n.language = e, n.languages = n.services.languageUtils.toResolveHierarchy(e), n.resolvedLanguage = void 0, n.setResolvedLanguage(e);
          },
              i = function (i) {
            e || i || !n.services.languageDetector || (i = []);
            var a = "string" == typeof i ? i : n.services.languageUtils.getBestMatchFromCodes(i);
            a && (n.language || o(a), n.translator.language || n.translator.changeLanguage(a), n.services.languageDetector && n.services.languageDetector.cacheUserLanguage(a)), n.loadResources(a, function (e) {
              !function (e, i) {
                i ? (o(i), n.translator.changeLanguage(i), n.isLanguageChangingTo = void 0, n.emit("languageChanged", i), n.logger.log("languageChanged", i)) : n.isLanguageChangingTo = void 0, r.resolve(function () {
                  return n.t.apply(n, arguments);
                }), t && t(e, function () {
                  return n.t.apply(n, arguments);
                });
              }(e, a);
            });
          };

          return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(i) : i(e) : i(this.services.languageDetector.detect()), r;
        }
      }, {
        key: "getFixedT",
        value: function (e, t, n) {
          var r = this,
              o = function e(t, o) {
            var i;

            if ("object" !== B(o)) {
              for (var a = arguments.length, s = new Array(a > 2 ? a - 2 : 0), c = 2; c < a; c++) s[c - 2] = arguments[c];

              i = r.options.overloadTranslationOptionHandler([t, o].concat(s));
            } else i = Xe({}, o);

            i.lng = i.lng || e.lng, i.lngs = i.lngs || e.lngs, i.ns = i.ns || e.ns;
            var u = r.options.keySeparator || ".",
                l = n ? "".concat(n).concat(u).concat(t) : t;
            return r.t(l, i);
          };

          return "string" == typeof e ? o.lng = e : o.lngs = e, o.ns = t, o.keyPrefix = n, o;
        }
      }, {
        key: "t",
        value: function () {
          var e;
          return this.translator && (e = this.translator).translate.apply(e, arguments);
        }
      }, {
        key: "exists",
        value: function () {
          var e;
          return this.translator && (e = this.translator).exists.apply(e, arguments);
        }
      }, {
        key: "setDefaultNamespace",
        value: function (e) {
          this.options.defaultNS = e;
        }
      }, {
        key: "hasLoadedNamespace",
        value: function (e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
          if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
          var r = this.resolvedLanguage || this.languages[0],
              o = !!this.options && this.options.fallbackLng,
              i = this.languages[this.languages.length - 1];
          if ("cimode" === r.toLowerCase()) return !0;

          var a = function (e, n) {
            var r = t.services.backendConnector.state["".concat(e, "|").concat(n)];
            return -1 === r || 2 === r;
          };

          if (n.precheck) {
            var s = n.precheck(this, a);
            if (void 0 !== s) return s;
          }

          return !!this.hasResourceBundle(r, e) || !(this.services.backendConnector.backend && (!this.options.resources || this.options.partialBundledLanguages)) || !(!a(r, e) || o && !a(i, e));
        }
      }, {
        key: "loadNamespaces",
        value: function (e, t) {
          var n = this,
              r = ae();
          return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
            n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
          }), this.loadResources(function (e) {
            r.resolve(), t && t(e);
          }), r) : (t && t(), Promise.resolve());
        }
      }, {
        key: "loadLanguages",
        value: function (e, t) {
          var n = ae();
          "string" == typeof e && (e = [e]);
          var r = this.options.preload || [],
              o = e.filter(function (e) {
            return r.indexOf(e) < 0;
          });
          return o.length ? (this.options.preload = r.concat(o), this.loadResources(function (e) {
            n.resolve(), t && t(e);
          }), n) : (t && t(), Promise.resolve());
        }
      }, {
        key: "dir",
        value: function (e) {
          if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
          return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
        }
      }, {
        key: "cloneInstance",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Qe,
              o = Xe(Xe(Xe({}, this.options), t), {
            isClone: !0
          }),
              i = new n(o),
              a = ["store", "services", "language"];
          return a.forEach(function (t) {
            i[t] = e[t];
          }), i.services = Xe({}, this.services), i.services.utils = {
            hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
          }, i.translator = new _e(i.services, i.options), i.translator.on("*", function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];

            i.emit.apply(i, [e].concat(n));
          }), i.init(o, r), i.translator.options = i.options, i.translator.backendConnector.services.utils = {
            hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
          }, i;
        }
      }, {
        key: "toJSON",
        value: function () {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
          };
        }
      }]), n;
    }(ie);

    Z(tt, "createInstance", function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 ? arguments[1] : void 0;
      return new tt(e, t);
    });
    var nt = tt.createInstance();
    nt.createInstance = tt.createInstance;
    nt.createInstance, nt.init, nt.loadResources, nt.reloadResources, nt.use, nt.changeLanguage, nt.getFixedT, nt.t, nt.exists, nt.setDefaultNamespace, nt.hasLoadedNamespace, nt.loadNamespaces, nt.loadLanguages;
    var rt = nt,
        ot = n(25),
        it = n.n(ot),
        at = n(26),
        st = n(27);

    function ct(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function ut(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ct(Object(n), !0).forEach(function (t) {
          lt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ct(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function lt(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var pt = {
      en: {
        translation: ft(at.en)
      },
      es: {
        translation: ft(st.es)
      }
    };

    function ft(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = {};
      return Object.keys(e).forEach(function (r) {
        var o = e[r],
            i = r;
        t.length > 0 && (i = "".concat(t, ".").concat(r)), "string" == typeof o ? n[i] = o : n = ut(ut({}, n), ft(o, i));
      }), n;
    }

    rt.use(it.a).use(x).init({
      resources: pt,
      languages: ["en", "es"],
      fallbackLng: "en",
      detection: {
        order: ["querystring", "path"],
        lookupFromPathIndex: 1,
        lookupQuerystring: "locale"
      },
      keySeparator: !0,
      interpolation: {
        escapeValue: !1,
        prefix: "%{",
        suffix: "}"
      }
    });
    var dt,
        ht,
        gt = n(6),
        vt = n(7),
        mt = n(28),
        bt = n(20),
        yt = n(21),
        Ot = n.n(yt);

    function wt(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function xt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function jt(e, t) {
      return (jt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function St(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = kt(e);

        if (t) {
          var o = kt(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Et(this, n);
      };
    }

    function Et(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function kt(e) {
      return (kt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Pt,
        Ct,
        _t,
        Rt,
        Nt,
        Dt,
        It,
        Lt,
        Mt,
        Tt,
        At,
        Vt = Object(s.observer)((ht = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jt(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = St(a);

      function a() {
        return wt(this, a), o.apply(this, arguments);
      }

      return t = a, (n = [{
        key: "_item",
        get: function () {
          var e = this.props.item;
          if (!e) throw new Error("NamedSelectedItem needs an 'item' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          return i.a.createElement(j, {
            i18n: rt
          }, this._item.option.name);
        }
      }]) && xt(t.prototype, n), r && xt(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), Pt = ht.prototype, Ct = "_item", _t = [a.computed], Rt = Object.getOwnPropertyDescriptor(ht.prototype, "_item"), Nt = ht.prototype, Dt = {}, Object.keys(Rt).forEach(function (e) {
      Dt[e] = Rt[e];
    }), Dt.enumerable = !!Dt.enumerable, Dt.configurable = !!Dt.configurable, ("value" in Dt || Dt.initializer) && (Dt.writable = !0), Dt = _t.slice().reverse().reduce(function (e, t) {
      return t(Pt, Ct, e) || e;
    }, Dt), Nt && void 0 !== Dt.initializer && (Dt.value = Dt.initializer ? Dt.initializer.call(Nt) : void 0, Dt.initializer = void 0), void 0 === Dt.initializer && (Object.defineProperty(Pt, Ct, Dt), Dt = null), dt = ht)) || dt,
        Ft = U()(Vt);

    function zt(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Ht(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Ut(e, t, n, r) {
      n && Object.defineProperty(e, t, {
        enumerable: n.enumerable,
        configurable: n.configurable,
        writable: n.writable,
        value: n.initializer ? n.initializer.call(r) : void 0
      });
    }

    function Bt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function $t(e, t, n) {
      return t && Bt(e.prototype, t), n && Bt(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function qt(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Wt,
        Kt,
        Yt,
        Gt,
        Jt = (Lt = qt((It = $t(function e(t, n, r, o) {
      var a = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Ut(this, "id", Lt, this), Ut(this, "name", Mt, this), Ut(this, "type", Tt, this), Ut(this, "component", At, this), this.renderComponent = function (e, t, n) {
        var r = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? zt(Object(n), !0).forEach(function (t) {
              Ht(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({
          item: e,
          baseInputName: t
        }, n),
            o = a.component;

        return i.a.createElement(o, r);
      }, this.id = t, this.name = n, this.type = r, this.component = o || Ft;
    })).prototype, "id", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Mt = qt(It.prototype, "name", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Tt = qt(It.prototype, "type", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), At = qt(It.prototype, "component", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), It);

    function Xt(e, t, n, r) {
      n && Object.defineProperty(e, t, {
        enumerable: n.enumerable,
        configurable: n.configurable,
        writable: n.writable,
        value: n.initializer ? n.initializer.call(r) : void 0
      });
    }

    function Zt(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function Qt(e, t, n) {
      return t && Zt(e.prototype, t), n && Zt(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function en(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var tn,
        nn,
        rn,
        on,
        an,
        sn,
        cn = (Kt = en((Wt = Qt(function e(t, n) {
      var r = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Xt(this, "id", Kt, this), Xt(this, "option", Yt, this), Xt(this, "destroyed", Gt, this), this.renderComponent = function (e, t) {
        return r.option.renderComponent(r, e, t);
      }, this.id = t, this.option = n, this.destroyed = !1;
    })).prototype, "id", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Yt = en(Wt.prototype, "option", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Gt = en(Wt.prototype, "destroyed", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Wt);

    function un(e) {
      return function (e) {
        if (Array.isArray(e)) return ln(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return ln(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ln(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function ln(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];

      return r;
    }

    function pn(e, t, n, r) {
      n && Object.defineProperty(e, t, {
        enumerable: n.enumerable,
        configurable: n.configurable,
        writable: n.writable,
        value: n.initializer ? n.initializer.call(r) : void 0
      });
    }

    function fn(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function dn(e, t) {
      return (dn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function hn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = mn(e);

        if (t) {
          var o = mn(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return gn(this, n);
      };
    }

    function gn(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return vn(e);
    }

    function vn(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function mn(e) {
      return (mn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bn(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var yn,
        On,
        wn = Object(s.observer)((nn = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && dn(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = hn(a);

      function a(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), pn(t = o.call(this, e), "_selections", rn, vn(t)), pn(t, "_handleChange", on, vn(t)), pn(t, "_remove", an, vn(t)), pn(t, "_pruneSelections", sn, vn(t)), t._baseInputName = function (e) {
          return "".concat(t._modelName, "[").concat(t._attributeName, "][").concat(e, "]");
        }, t._selections = un(t._initialSelections), t._formId = Object(mt.uniqueId)("multi-select-"), t;
      }

      return t = a, (n = [{
        key: "_placeholder",
        get: function () {
          var e = this.props.placeholder;
          if (!e) throw new Error("MultiSelect needs a 'placeholder' property");
          return e;
        }
      }, {
        key: "_inputId",
        get: function () {
          return this.props.inputId;
        }
      }, {
        key: "_options",
        get: function () {
          var e = this.props.options;
          if (!e) throw new Error("MultiSelect needs an 'options' property");
          return e.forEach(function (e) {
            if (!(e instanceof Jt)) throw new Error("MultiSelect requires all options to be SelectOption instances");
          }), e;
        }
      }, {
        key: "_validOptions",
        get: function () {
          var e = this;
          return this._options.filter(function (t) {
            return !e._currentSelections.find(function (e) {
              return e.option.id == t.id;
            });
          });
        }
      }, {
        key: "_optionsForSelect",
        get: function () {
          return this._validOptions.sort(bt.sortByName).map(function (e) {
            return {
              value: e.id,
              label: e.name
            };
          });
        }
      }, {
        key: "_selectionsForSelect",
        get: function () {
          return this._currentSelections.map(function (e) {
            return {
              value: e.option.id,
              label: e.option.name
            };
          });
        }
      }, {
        key: "_relationAttributeName",
        get: function () {
          var e = this.props.relationAttributeName;
          if (!e) throw new Error("MultiSelect needs a 'relationAttributeName' property");
          return e;
        }
      }, {
        key: "_modelName",
        get: function () {
          var e = this.props.modelName;
          if (!e) throw new Error("MultiSelect needs an 'modelName' property");
          return e;
        }
      }, {
        key: "_attributeName",
        get: function () {
          var e = this.props.attributeName;
          if (!e) throw new Error("MultiSelect needs an 'attributeName' property");
          return e;
        }
      }, {
        key: "_supportMultiple",
        get: function () {
          return !0 === this.props.supportMultiple;
        }
      }, {
        key: "_initialSelections",
        get: function () {
          var e = this.props.current;
          if (!e) return [];
          var t = null;
          return (t = Array.isArray(e) ? e : [e]).forEach(function (e) {
            if (!(e instanceof cn)) throw new Error("MultiSelect requires all current objects to be SelectedItem instances");
          }), t;
        }
      }, {
        key: "_currentSelections",
        get: function () {
          return this._selections.filter(function (e) {
            return !e.destroyed;
          });
        }
      }, {
        key: "_optionFromId",
        value: function (e) {
          var t = this._options.find(function (t) {
            return t.id == e;
          });

          if (!t) throw new Error("Unable to find option for id: ".concat(e));
          return t;
        }
      }, {
        key: "_renderEachSelection",
        value: function (e, t) {
          var n = this,
              r = this.props.renderSelectionOptions;
          return i.a.createElement("li", {
            className: "list-group-item d-flex justify-content-between align-items-center",
            key: e.option.id,
            "data-testid": "selection-item-".concat(e.option.id)
          }, i.a.createElement("div", {
            className: "col"
          }, e.renderComponent(this._baseInputName(t), r)), i.a.createElement("a", {
            href: "#",
            onClick: function (t) {
              t.preventDefault(), n._remove(e);
            }
          }, i.a.createElement(gt.FontAwesomeIcon, {
            icon: vt.faTimes
          })));
        }
      }, {
        key: "_renderSelections",
        value: function () {
          var e = this;
          if (this._currentSelections.length > 0) return i.a.createElement("div", {
            className: "row form-group"
          }, i.a.createElement("div", {
            className: "col"
          }, i.a.createElement("ul", {
            className: "list-group"
          }, this._selections.slice().sort(function (e, t) {
            return e.option.name > t.option.name;
          }).map(function (t, n) {
            return t.destroyed ? null : e._renderEachSelection(t, n);
          }))));
        }
      }, {
        key: "_renderFormItemInputs",
        value: function (e, t) {
          var n = this._baseInputName(t),
              r = "".concat(n, "[id]"),
              o = "".concat(n, "[_destroy]"),
              a = "".concat(n, "[").concat(this._relationAttributeName, "]");

          return i.a.createElement(i.a.Fragment, {
            key: n
          }, i.a.createElement("input", {
            type: "hidden",
            name: a,
            value: e.option.id
          }), null !== e.id ? i.a.createElement("input", {
            type: "hidden",
            name: r,
            value: e.id
          }) : null, null !== e.id && e.destroyed ? i.a.createElement("input", {
            type: "hidden",
            name: o,
            value: !0
          }) : null);
        }
      }, {
        key: "_renderFormItems",
        value: function () {
          var e = this;
          return i.a.createElement(i.a.Fragment, null, this._selections.map(function (t, n) {
            return e._renderFormItemInputs(t, n);
          }));
        }
      }, {
        key: "_renderOptions",
        value: function () {
          var e = !0,
              t = {};

          if (this._validOptions.forEach(function (n) {
            n.type ? (n.type in t || (t[n.type] = []), t[n.type].push(n)) : e = !1;
          }), e) {
            var n = Object.keys(t).sort();
            return i.a.createElement(i.a.Fragment, null, n.map(function (e) {
              return i.a.createElement("optgroup", {
                key: e,
                label: e
              }, t[e].map(function (e) {
                return i.a.createElement("option", {
                  key: e.id,
                  value: e.id
                }, e.name);
              }));
            }));
          }

          return i.a.createElement(i.a.Fragment, null, this._validOptions.sort(bt.sortByName).map(function (e) {
            return i.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.name);
          }));
        }
      }, {
        key: "render",
        value: function () {
          return i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
            className: "row form-group"
          }, i.a.createElement("div", {
            className: "col",
            "data-testid": "select-container"
          }, i.a.createElement(Ot.a, {
            placeholder: this._placeholder,
            value: this._selectionsForSelect,
            options: this._optionsForSelect,
            isSearchable: !0,
            isMulti: !0,
            isClearable: !1,
            filterOption: Object(yt.createFilter)({
              ignoreCase: !0,
              ignoreAccents: !0,
              matchFrom: "any",
              stringify: function (e) {
                return "".concat(e.label);
              },
              trim: !0
            }),
            controlShouldRenderValue: !1,
            onChange: this._handleChange,
            inputId: this._inputId,
            className: "multi-select-container",
            classNamePrefix: "multi-select"
          }))), this._renderSelections(), this._renderFormItems());
        }
      }]) && fn(t.prototype, n), r && fn(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), rn = bn(nn.prototype, "_selections", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), bn(nn.prototype, "_placeholder", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_placeholder"), nn.prototype), bn(nn.prototype, "_inputId", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_inputId"), nn.prototype), bn(nn.prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_options"), nn.prototype), bn(nn.prototype, "_validOptions", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_validOptions"), nn.prototype), bn(nn.prototype, "_optionsForSelect", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_optionsForSelect"), nn.prototype), bn(nn.prototype, "_selectionsForSelect", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_selectionsForSelect"), nn.prototype), bn(nn.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_relationAttributeName"), nn.prototype), bn(nn.prototype, "_modelName", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_modelName"), nn.prototype), bn(nn.prototype, "_attributeName", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_attributeName"), nn.prototype), bn(nn.prototype, "_supportMultiple", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_supportMultiple"), nn.prototype), bn(nn.prototype, "_initialSelections", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_initialSelections"), nn.prototype), bn(nn.prototype, "_currentSelections", [a.computed], Object.getOwnPropertyDescriptor(nn.prototype, "_currentSelections"), nn.prototype), on = bn(nn.prototype, "_handleChange", [a.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.forEach(function (t) {
            var n = t.value,
                r = e._optionFromId(n),
                o = e._selections.find(function (e) {
              return e.option.id == n;
            });

            o || (o = new cn(null, r), e._selections.push(o)), o.destroyed = !1;
          });

          for (var n = t.map(function (e) {
            return e.value;
          }), r = e._selections.length - 1; r >= 0; r -= 1) {
            var o = e._selections[r];
            n.includes(o.option.id) || (o.id ? o.destroyed = !0 : e._selections.splice(r, 1));
          }
        };
      }
    }), an = bn(nn.prototype, "_remove", [a.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.destroyed = !0, e._pruneSelections();
        };
      }
    }), sn = bn(nn.prototype, "_pruneSelections", [a.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e._selections = e._selections.filter(function (e) {
            return null !== e.id || !e.destroyed;
          });
        };
      }
    }), tn = nn)) || tn;

    function xn(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function jn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? xn(Object(n), !0).forEach(function (t) {
          Sn(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xn(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function Sn(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function En(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function kn(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function Pn(e, t) {
      return (Pn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Cn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Rn(e);

        if (t) {
          var o = Rn(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return _n(this, n);
      };
    }

    function _n(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Rn(e) {
      return (Rn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Nn(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Dn = Object(s.observer)((Nn((On = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Pn(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = Cn(a);

      function a() {
        return En(this, a), o.apply(this, arguments);
      }

      return t = a, (n = [{
        key: "_options",
        get: function () {
          var e = this.props.options;
          if (!e) throw new Error("NestedAttributesMultiSelect needs an 'options' property");
          return e.map(function (e) {
            if (!("id" in e)) throw new Error("All options must include an 'id' property");
            if (!("name" in e)) throw new Error("All options must include a 'name' property");
            var t = e.id;
            return "serial" in e && (t = e.serial), new Jt(t, e.name, e.type);
          });
        }
      }, {
        key: "_current",
        get: function () {
          var e,
              t,
              n,
              r = this.props.current;
          return e = r, t = this._options, n = this._relationAttributeName, e ? (Array.isArray(e) ? e : [e]).map(function (e) {
            if (!("id" in e)) throw new Error("All items must include an 'id' property");
            if (!(n in e)) throw new Error("All items must include a '".concat(n, "' property"));
            var r = e[n],
                o = t.find(function (e) {
              return e.id == r;
            });
            if (!o) throw new Error("Unable to find option for id: ".concat(r));
            return new cn(e.id, o);
          }) : [];
        }
      }, {
        key: "_relationAttributeName",
        get: function () {
          var e = this.props.relationAttributeName;
          if (!e) throw new Error("NestedAttributesMultiSelect needs a 'relationAttributeName' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          var e = jn(jn({}, this.props), {}, {
            options: this._options,
            current: this._current
          });
          return i.a.createElement(j, {
            i18n: rt
          }, i.a.createElement(wn, e));
        }
      }]) && kn(t.prototype, n), r && kn(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(i.a.Component)).prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(On.prototype, "_options"), On.prototype), Nn(On.prototype, "_current", [a.computed], Object.getOwnPropertyDescriptor(On.prototype, "_current"), On.prototype), Nn(On.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(On.prototype, "_relationAttributeName"), On.prototype), yn = On)) || yn,
        In = U()(Dn);

    function Ln(e, t) {
      return e.contains ? e.contains(t) : e.compareDocumentPosition ? e === t || !!(16 & e.compareDocumentPosition(t)) : void 0;
    }

    function Mn() {
      var e = Object(o.useRef)(!0),
          t = Object(o.useRef)(function () {
        return e.current;
      });
      return Object(o.useEffect)(function () {
        return e.current = !0, function () {
          e.current = !1;
        };
      }, []), t.current;
    }

    function Tn(e) {
      var t,
          n,
          r = (t = e, (n = Object(o.useRef)(t)).current = t, n);
      Object(o.useEffect)(function () {
        return function () {
          return r.current();
        };
      }, []);
    }

    var An = Math.pow(2, 31) - 1;

    function Vn() {
      var e = Mn(),
          t = Object(o.useRef)();
      return Tn(function () {
        return clearTimeout(t.current);
      }), Object(o.useMemo)(function () {
        var n = function () {
          return clearTimeout(t.current);
        };

        return {
          set: function (r, o) {
            void 0 === o && (o = 0), e() && (n(), o <= An ? t.current = setTimeout(r, o) : function e(t, n, r) {
              var o = r - Date.now();
              t.current = o <= An ? setTimeout(n, o) : setTimeout(function () {
                return e(t, n, r);
              }, An);
            }(t, r, Date.now() + o));
          },
          clear: n
        };
      }, []);
    }

    var Fn = n(13),
        zn = n.n(Fn);

    function Hn() {
      return (Hn = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }

        return e;
      }).apply(this, arguments);
    }

    function Un(e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

      return o;
    }

    n(11);

    function Bn(e) {
      return "default" + e.charAt(0).toUpperCase() + e.substr(1);
    }

    function $n(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var n = e[Symbol.toPrimitive];

        if (void 0 !== n) {
          var r = n.call(e, t || "default");
          if ("object" != typeof r) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function qn(e, t, n) {
      var r = Object(o.useRef)(void 0 !== e),
          i = Object(o.useState)(t),
          a = i[0],
          s = i[1],
          c = void 0 !== e,
          u = r.current;
      return r.current = c, !c && u && a !== t && s(t), [c ? e : a, Object(o.useCallback)(function (e) {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) r[o - 1] = arguments[o];

        n && n.apply(void 0, [e].concat(r)), s(e);
      }, [n])];
    }

    function Wn(e, t) {
      return (Wn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Kn(e, t) {
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Wn(e, t);
    }

    function Yn() {
      var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
      null != e && this.setState(e);
    }

    function Gn(e) {
      this.setState(function (t) {
        var n = this.constructor.getDerivedStateFromProps(e, t);
        return null != n ? n : null;
      }.bind(this));
    }

    function Jn(e, t) {
      try {
        var n = this.props,
            r = this.state;
        this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, r);
      } finally {
        this.props = n, this.state = r;
      }
    }

    Yn.__suppressDeprecationWarning = !0, Gn.__suppressDeprecationWarning = !0, Jn.__suppressDeprecationWarning = !0;

    var Xn = function (e) {
      return e && "function" != typeof e ? function (t) {
        e.current = t;
      } : e;
    };

    var Zn = function (e, t) {
      return Object(o.useMemo)(function () {
        return function (e, t) {
          var n = Xn(e),
              r = Xn(t);
          return function (e) {
            n && n(e), r && r(e);
          };
        }(e, t);
      }, [e, t]);
    },
        Qn = n(4),
        er = n.n(Qn),
        tr = n(5),
        nr = n.n(tr);

    function rr() {
      return Object(o.useState)(null);
    }

    var or = Object.prototype.hasOwnProperty;

    function ir(e, t, n) {
      var _iterator = _createForOfIteratorHelper(e.keys()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          n = _step.value;
          if (ar(n, t)) return n;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    function ar(e, t) {
      var n, r, o;
      if (e === t) return !0;

      if (e && t && (n = e.constructor) === t.constructor) {
        if (n === Date) return e.getTime() === t.getTime();
        if (n === RegExp) return e.toString() === t.toString();

        if (n === Array) {
          if ((r = e.length) === t.length) for (; r-- && ar(e[r], t[r]););
          return -1 === r;
        }

        if (n === Set) {
          if (e.size !== t.size) return !1;

          var _iterator2 = _createForOfIteratorHelper(e),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              r = _step2.value;
              if ((o = r) && "object" == typeof o && !(o = ir(t, o))) return !1;
              if (!t.has(o)) return !1;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return !0;
        }

        if (n === Map) {
          if (e.size !== t.size) return !1;

          var _iterator3 = _createForOfIteratorHelper(e),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              r = _step3.value;
              if ((o = r[0]) && "object" == typeof o && !(o = ir(t, o))) return !1;
              if (!ar(r[1], t.get(o))) return !1;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return !0;
        }

        if (n === ArrayBuffer) e = new Uint8Array(e), t = new Uint8Array(t);else if (n === DataView) {
          if ((r = e.byteLength) === t.byteLength) for (; r-- && e.getInt8(r) === t.getInt8(r););
          return -1 === r;
        }

        if (ArrayBuffer.isView(e)) {
          if ((r = e.byteLength) === t.byteLength) for (; r-- && e[r] === t[r];);
          return -1 === r;
        }

        if (!n || "object" == typeof e) {
          for (n in r = 0, e) {
            if (or.call(e, n) && ++r && !or.call(t, n)) return !1;
            if (!(n in t) || !ar(e[n], t[n])) return !1;
          }

          return Object.keys(t).length === r;
        }
      }

      return e != e && t != t;
    }

    var sr = function (e) {
      var t = Mn();
      return [e[0], Object(o.useCallback)(function (n) {
        if (t()) return e[1](n);
      }, [t, e[1]])];
    };

    function cr(e) {
      return e.split("-")[0];
    }

    function ur(e) {
      if (null == e) return window;

      if ("[object Window]" !== e.toString()) {
        var t = e.ownerDocument;
        return t && t.defaultView || window;
      }

      return e;
    }

    function lr(e) {
      return e instanceof ur(e).Element || e instanceof Element;
    }

    function pr(e) {
      return e instanceof ur(e).HTMLElement || e instanceof HTMLElement;
    }

    function fr(e) {
      return "undefined" != typeof ShadowRoot && (e instanceof ur(e).ShadowRoot || e instanceof ShadowRoot);
    }

    var dr = Math.max,
        hr = Math.min,
        gr = Math.round;

    function vr(e, t) {
      void 0 === t && (t = !1);
      var n = e.getBoundingClientRect(),
          r = 1,
          o = 1;

      if (pr(e) && t) {
        var i = e.offsetHeight,
            a = e.offsetWidth;
        a > 0 && (r = gr(n.width) / a || 1), i > 0 && (o = gr(n.height) / i || 1);
      }

      return {
        width: n.width / r,
        height: n.height / o,
        top: n.top / o,
        right: n.right / r,
        bottom: n.bottom / o,
        left: n.left / r,
        x: n.left / r,
        y: n.top / o
      };
    }

    function mr(e) {
      var t = vr(e),
          n = e.offsetWidth,
          r = e.offsetHeight;
      return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
        x: e.offsetLeft,
        y: e.offsetTop,
        width: n,
        height: r
      };
    }

    function br(e, t) {
      var n = t.getRootNode && t.getRootNode();
      if (e.contains(t)) return !0;

      if (n && fr(n)) {
        var r = t;

        do {
          if (r && e.isSameNode(r)) return !0;
          r = r.parentNode || r.host;
        } while (r);
      }

      return !1;
    }

    function yr(e) {
      return e ? (e.nodeName || "").toLowerCase() : null;
    }

    function Or(e) {
      return ur(e).getComputedStyle(e);
    }

    function wr(e) {
      return ["table", "td", "th"].indexOf(yr(e)) >= 0;
    }

    function xr(e) {
      return ((lr(e) ? e.ownerDocument : e.document) || window.document).documentElement;
    }

    function jr(e) {
      return "html" === yr(e) ? e : e.assignedSlot || e.parentNode || (fr(e) ? e.host : null) || xr(e);
    }

    function Sr(e) {
      return pr(e) && "fixed" !== Or(e).position ? e.offsetParent : null;
    }

    function Er(e) {
      for (var t = ur(e), n = Sr(e); n && wr(n) && "static" === Or(n).position;) n = Sr(n);

      return n && ("html" === yr(n) || "body" === yr(n) && "static" === Or(n).position) ? t : n || function (e) {
        var t = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
        if (-1 !== navigator.userAgent.indexOf("Trident") && pr(e) && "fixed" === Or(e).position) return null;
        var n = jr(e);

        for (fr(n) && (n = n.host); pr(n) && ["html", "body"].indexOf(yr(n)) < 0;) {
          var r = Or(n);
          if ("none" !== r.transform || "none" !== r.perspective || "paint" === r.contain || -1 !== ["transform", "perspective"].indexOf(r.willChange) || t && "filter" === r.willChange || t && r.filter && "none" !== r.filter) return n;
          n = n.parentNode;
        }

        return null;
      }(e) || t;
    }

    function kr(e) {
      return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
    }

    function Pr(e, t, n) {
      return dr(e, hr(t, n));
    }

    function Cr(e) {
      return Object.assign({}, {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }, e);
    }

    function _r(e, t) {
      return t.reduce(function (t, n) {
        return t[n] = e, t;
      }, {});
    }

    var Rr = "top",
        Nr = "bottom",
        Dr = "right",
        Ir = "left",
        Lr = [Rr, Nr, Dr, Ir],
        Mr = Lr.reduce(function (e, t) {
      return e.concat([t + "-start", t + "-end"]);
    }, []),
        Tr = [].concat(Lr, ["auto"]).reduce(function (e, t) {
      return e.concat([t, t + "-start", t + "-end"]);
    }, []),
        Ar = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];
    var Vr = {
      name: "arrow",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t,
            n = e.state,
            r = e.name,
            o = e.options,
            i = n.elements.arrow,
            a = n.modifiersData.popperOffsets,
            s = cr(n.placement),
            c = kr(s),
            u = [Ir, Dr].indexOf(s) >= 0 ? "height" : "width";

        if (i && a) {
          var l = function (e, t) {
            return Cr("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
              placement: t.placement
            })) : e) ? e : _r(e, Lr));
          }(o.padding, n),
              p = mr(i),
              f = "y" === c ? Rr : Ir,
              d = "y" === c ? Nr : Dr,
              h = n.rects.reference[u] + n.rects.reference[c] - a[c] - n.rects.popper[u],
              g = a[c] - n.rects.reference[c],
              v = Er(i),
              m = v ? "y" === c ? v.clientHeight || 0 : v.clientWidth || 0 : 0,
              b = h / 2 - g / 2,
              y = l[f],
              O = m - p[u] - l[d],
              w = m / 2 - p[u] / 2 + b,
              x = Pr(y, w, O),
              j = c;

          n.modifiersData[r] = ((t = {})[j] = x, t.centerOffset = x - w, t);
        }
      },
      effect: function (e) {
        var t = e.state,
            n = e.options.element,
            r = void 0 === n ? "[data-popper-arrow]" : n;
        null != r && ("string" != typeof r || (r = t.elements.popper.querySelector(r))) && br(t.elements.popper, r) && (t.elements.arrow = r);
      },
      requires: ["popperOffsets"],
      requiresIfExists: ["preventOverflow"]
    };

    function Fr(e) {
      return e.split("-")[1];
    }

    var zr = {
      top: "auto",
      right: "auto",
      bottom: "auto",
      left: "auto"
    };

    function Hr(e) {
      var t,
          n = e.popper,
          r = e.popperRect,
          o = e.placement,
          i = e.variation,
          a = e.offsets,
          s = e.position,
          c = e.gpuAcceleration,
          u = e.adaptive,
          l = e.roundOffsets,
          p = e.isFixed,
          f = a.x,
          d = void 0 === f ? 0 : f,
          h = a.y,
          g = void 0 === h ? 0 : h,
          v = "function" == typeof l ? l({
        x: d,
        y: g
      }) : {
        x: d,
        y: g
      };
      d = v.x, g = v.y;
      var m = a.hasOwnProperty("x"),
          b = a.hasOwnProperty("y"),
          y = Ir,
          O = Rr,
          w = window;

      if (u) {
        var x = Er(n),
            j = "clientHeight",
            S = "clientWidth";
        if (x === ur(n) && "static" !== Or(x = xr(n)).position && "absolute" === s && (j = "scrollHeight", S = "scrollWidth"), x = x, o === Rr || (o === Ir || o === Dr) && "end" === i) O = Nr, g -= (p && x === w && w.visualViewport ? w.visualViewport.height : x[j]) - r.height, g *= c ? 1 : -1;
        if (o === Ir || (o === Rr || o === Nr) && "end" === i) y = Dr, d -= (p && x === w && w.visualViewport ? w.visualViewport.width : x[S]) - r.width, d *= c ? 1 : -1;
      }

      var E,
          k = Object.assign({
        position: s
      }, u && zr),
          P = !0 === l ? function (e) {
        var t = e.x,
            n = e.y,
            r = window.devicePixelRatio || 1;
        return {
          x: gr(t * r) / r || 0,
          y: gr(n * r) / r || 0
        };
      }({
        x: d,
        y: g
      }) : {
        x: d,
        y: g
      };
      return d = P.x, g = P.y, c ? Object.assign({}, k, ((E = {})[O] = b ? "0" : "", E[y] = m ? "0" : "", E.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + g + "px)" : "translate3d(" + d + "px, " + g + "px, 0)", E)) : Object.assign({}, k, ((t = {})[O] = b ? g + "px" : "", t[y] = m ? d + "px" : "", t.transform = "", t));
    }

    var Ur = {
      name: "computeStyles",
      enabled: !0,
      phase: "beforeWrite",
      fn: function (e) {
        var t = e.state,
            n = e.options,
            r = n.gpuAcceleration,
            o = void 0 === r || r,
            i = n.adaptive,
            a = void 0 === i || i,
            s = n.roundOffsets,
            c = void 0 === s || s,
            u = {
          placement: cr(t.placement),
          variation: Fr(t.placement),
          popper: t.elements.popper,
          popperRect: t.rects.popper,
          gpuAcceleration: o,
          isFixed: "fixed" === t.options.strategy
        };
        null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, Hr(Object.assign({}, u, {
          offsets: t.modifiersData.popperOffsets,
          position: t.options.strategy,
          adaptive: a,
          roundOffsets: c
        })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, Hr(Object.assign({}, u, {
          offsets: t.modifiersData.arrow,
          position: "absolute",
          adaptive: !1,
          roundOffsets: c
        })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
          "data-popper-placement": t.placement
        });
      },
      data: {}
    },
        Br = {
      passive: !0
    };
    var $r = {
      name: "eventListeners",
      enabled: !0,
      phase: "write",
      fn: function () {},
      effect: function (e) {
        var t = e.state,
            n = e.instance,
            r = e.options,
            o = r.scroll,
            i = void 0 === o || o,
            a = r.resize,
            s = void 0 === a || a,
            c = ur(t.elements.popper),
            u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
        return i && u.forEach(function (e) {
          e.addEventListener("scroll", n.update, Br);
        }), s && c.addEventListener("resize", n.update, Br), function () {
          i && u.forEach(function (e) {
            e.removeEventListener("scroll", n.update, Br);
          }), s && c.removeEventListener("resize", n.update, Br);
        };
      },
      data: {}
    },
        qr = {
      left: "right",
      right: "left",
      bottom: "top",
      top: "bottom"
    };

    function Wr(e) {
      return e.replace(/left|right|bottom|top/g, function (e) {
        return qr[e];
      });
    }

    var Kr = {
      start: "end",
      end: "start"
    };

    function Yr(e) {
      return e.replace(/start|end/g, function (e) {
        return Kr[e];
      });
    }

    function Gr(e) {
      var t = ur(e);
      return {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
      };
    }

    function Jr(e) {
      return vr(xr(e)).left + Gr(e).scrollLeft;
    }

    function Xr(e) {
      var t = Or(e),
          n = t.overflow,
          r = t.overflowX,
          o = t.overflowY;
      return /auto|scroll|overlay|hidden/.test(n + o + r);
    }

    function Zr(e, t) {
      var n;
      void 0 === t && (t = []);

      var r = function e(t) {
        return ["html", "body", "#document"].indexOf(yr(t)) >= 0 ? t.ownerDocument.body : pr(t) && Xr(t) ? t : e(jr(t));
      }(e),
          o = r === (null == (n = e.ownerDocument) ? void 0 : n.body),
          i = ur(r),
          a = o ? [i].concat(i.visualViewport || [], Xr(r) ? r : []) : r,
          s = t.concat(a);

      return o ? s : s.concat(Zr(jr(a)));
    }

    function Qr(e) {
      return Object.assign({}, e, {
        left: e.x,
        top: e.y,
        right: e.x + e.width,
        bottom: e.y + e.height
      });
    }

    function eo(e, t) {
      return "viewport" === t ? Qr(function (e) {
        var t = ur(e),
            n = xr(e),
            r = t.visualViewport,
            o = n.clientWidth,
            i = n.clientHeight,
            a = 0,
            s = 0;
        return r && (o = r.width, i = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = r.offsetLeft, s = r.offsetTop)), {
          width: o,
          height: i,
          x: a + Jr(e),
          y: s
        };
      }(e)) : lr(t) ? function (e) {
        var t = vr(e);
        return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
      }(t) : Qr(function (e) {
        var t,
            n = xr(e),
            r = Gr(e),
            o = null == (t = e.ownerDocument) ? void 0 : t.body,
            i = dr(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0),
            a = dr(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0),
            s = -r.scrollLeft + Jr(e),
            c = -r.scrollTop;
        return "rtl" === Or(o || n).direction && (s += dr(n.clientWidth, o ? o.clientWidth : 0) - i), {
          width: i,
          height: a,
          x: s,
          y: c
        };
      }(xr(e)));
    }

    function to(e, t, n) {
      var r = "clippingParents" === t ? function (e) {
        var t = Zr(jr(e)),
            n = ["absolute", "fixed"].indexOf(Or(e).position) >= 0 && pr(e) ? Er(e) : e;
        return lr(n) ? t.filter(function (e) {
          return lr(e) && br(e, n) && "body" !== yr(e);
        }) : [];
      }(e) : [].concat(t),
          o = [].concat(r, [n]),
          i = o[0],
          a = o.reduce(function (t, n) {
        var r = eo(e, n);
        return t.top = dr(r.top, t.top), t.right = hr(r.right, t.right), t.bottom = hr(r.bottom, t.bottom), t.left = dr(r.left, t.left), t;
      }, eo(e, i));
      return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
    }

    function no(e) {
      var t,
          n = e.reference,
          r = e.element,
          o = e.placement,
          i = o ? cr(o) : null,
          a = o ? Fr(o) : null,
          s = n.x + n.width / 2 - r.width / 2,
          c = n.y + n.height / 2 - r.height / 2;

      switch (i) {
        case Rr:
          t = {
            x: s,
            y: n.y - r.height
          };
          break;

        case Nr:
          t = {
            x: s,
            y: n.y + n.height
          };
          break;

        case Dr:
          t = {
            x: n.x + n.width,
            y: c
          };
          break;

        case Ir:
          t = {
            x: n.x - r.width,
            y: c
          };
          break;

        default:
          t = {
            x: n.x,
            y: n.y
          };
      }

      var u = i ? kr(i) : null;

      if (null != u) {
        var l = "y" === u ? "height" : "width";

        switch (a) {
          case "start":
            t[u] = t[u] - (n[l] / 2 - r[l] / 2);
            break;

          case "end":
            t[u] = t[u] + (n[l] / 2 - r[l] / 2);
        }
      }

      return t;
    }

    function ro(e, t) {
      void 0 === t && (t = {});
      var n = t,
          r = n.placement,
          o = void 0 === r ? e.placement : r,
          i = n.boundary,
          a = void 0 === i ? "clippingParents" : i,
          s = n.rootBoundary,
          c = void 0 === s ? "viewport" : s,
          u = n.elementContext,
          l = void 0 === u ? "popper" : u,
          p = n.altBoundary,
          f = void 0 !== p && p,
          d = n.padding,
          h = void 0 === d ? 0 : d,
          g = Cr("number" != typeof h ? h : _r(h, Lr)),
          v = "popper" === l ? "reference" : "popper",
          m = e.rects.popper,
          b = e.elements[f ? v : l],
          y = to(lr(b) ? b : b.contextElement || xr(e.elements.popper), a, c),
          O = vr(e.elements.reference),
          w = no({
        reference: O,
        element: m,
        strategy: "absolute",
        placement: o
      }),
          x = Qr(Object.assign({}, m, w)),
          j = "popper" === l ? x : O,
          S = {
        top: y.top - j.top + g.top,
        bottom: j.bottom - y.bottom + g.bottom,
        left: y.left - j.left + g.left,
        right: j.right - y.right + g.right
      },
          E = e.modifiersData.offset;

      if ("popper" === l && E) {
        var k = E[o];
        Object.keys(S).forEach(function (e) {
          var t = [Dr, Nr].indexOf(e) >= 0 ? 1 : -1,
              n = [Rr, Nr].indexOf(e) >= 0 ? "y" : "x";
          S[e] += k[n] * t;
        });
      }

      return S;
    }

    var oo = {
      name: "flip",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t = e.state,
            n = e.options,
            r = e.name;

        if (!t.modifiersData[r]._skip) {
          for (var o = n.mainAxis, i = void 0 === o || o, a = n.altAxis, s = void 0 === a || a, c = n.fallbackPlacements, u = n.padding, l = n.boundary, p = n.rootBoundary, f = n.altBoundary, d = n.flipVariations, h = void 0 === d || d, g = n.allowedAutoPlacements, v = t.options.placement, m = cr(v), b = c || (m === v || !h ? [Wr(v)] : function (e) {
            if ("auto" === cr(e)) return [];
            var t = Wr(e);
            return [Yr(e), t, Yr(t)];
          }(v)), y = [v].concat(b).reduce(function (e, n) {
            return e.concat("auto" === cr(n) ? function (e, t) {
              void 0 === t && (t = {});
              var n = t,
                  r = n.placement,
                  o = n.boundary,
                  i = n.rootBoundary,
                  a = n.padding,
                  s = n.flipVariations,
                  c = n.allowedAutoPlacements,
                  u = void 0 === c ? Tr : c,
                  l = Fr(r),
                  p = l ? s ? Mr : Mr.filter(function (e) {
                return Fr(e) === l;
              }) : Lr,
                  f = p.filter(function (e) {
                return u.indexOf(e) >= 0;
              });
              0 === f.length && (f = p);
              var d = f.reduce(function (t, n) {
                return t[n] = ro(e, {
                  placement: n,
                  boundary: o,
                  rootBoundary: i,
                  padding: a
                })[cr(n)], t;
              }, {});
              return Object.keys(d).sort(function (e, t) {
                return d[e] - d[t];
              });
            }(t, {
              placement: n,
              boundary: l,
              rootBoundary: p,
              padding: u,
              flipVariations: h,
              allowedAutoPlacements: g
            }) : n);
          }, []), O = t.rects.reference, w = t.rects.popper, x = new Map(), j = !0, S = y[0], E = 0; E < y.length; E++) {
            var k = y[E],
                P = cr(k),
                C = "start" === Fr(k),
                _ = [Rr, Nr].indexOf(P) >= 0,
                R = _ ? "width" : "height",
                N = ro(t, {
              placement: k,
              boundary: l,
              rootBoundary: p,
              altBoundary: f,
              padding: u
            }),
                D = _ ? C ? Dr : Ir : C ? Nr : Rr;

            O[R] > w[R] && (D = Wr(D));
            var I = Wr(D),
                L = [];

            if (i && L.push(N[P] <= 0), s && L.push(N[D] <= 0, N[I] <= 0), L.every(function (e) {
              return e;
            })) {
              S = k, j = !1;
              break;
            }

            x.set(k, L);
          }

          if (j) for (var M = function (e) {
            var t = y.find(function (t) {
              var n = x.get(t);
              if (n) return n.slice(0, e).every(function (e) {
                return e;
              });
            });
            if (t) return S = t, "break";
          }, T = h ? 3 : 1; T > 0; T--) {
            if ("break" === M(T)) break;
          }
          t.placement !== S && (t.modifiersData[r]._skip = !0, t.placement = S, t.reset = !0);
        }
      },
      requiresIfExists: ["offset"],
      data: {
        _skip: !1
      }
    };

    function io(e, t, n) {
      return void 0 === n && (n = {
        x: 0,
        y: 0
      }), {
        top: e.top - t.height - n.y,
        right: e.right - t.width + n.x,
        bottom: e.bottom - t.height + n.y,
        left: e.left - t.width - n.x
      };
    }

    function ao(e) {
      return [Rr, Dr, Nr, Ir].some(function (t) {
        return e[t] >= 0;
      });
    }

    var so = {
      name: "hide",
      enabled: !0,
      phase: "main",
      requiresIfExists: ["preventOverflow"],
      fn: function (e) {
        var t = e.state,
            n = e.name,
            r = t.rects.reference,
            o = t.rects.popper,
            i = t.modifiersData.preventOverflow,
            a = ro(t, {
          elementContext: "reference"
        }),
            s = ro(t, {
          altBoundary: !0
        }),
            c = io(a, r),
            u = io(s, o, i),
            l = ao(c),
            p = ao(u);
        t.modifiersData[n] = {
          referenceClippingOffsets: c,
          popperEscapeOffsets: u,
          isReferenceHidden: l,
          hasPopperEscaped: p
        }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
          "data-popper-reference-hidden": l,
          "data-popper-escaped": p
        });
      }
    };
    var co = {
      name: "offset",
      enabled: !0,
      phase: "main",
      requires: ["popperOffsets"],
      fn: function (e) {
        var t = e.state,
            n = e.options,
            r = e.name,
            o = n.offset,
            i = void 0 === o ? [0, 0] : o,
            a = Tr.reduce(function (e, n) {
          return e[n] = function (e, t, n) {
            var r = cr(e),
                o = [Ir, Rr].indexOf(r) >= 0 ? -1 : 1,
                i = "function" == typeof n ? n(Object.assign({}, t, {
              placement: e
            })) : n,
                a = i[0],
                s = i[1];
            return a = a || 0, s = (s || 0) * o, [Ir, Dr].indexOf(r) >= 0 ? {
              x: s,
              y: a
            } : {
              x: a,
              y: s
            };
          }(n, t.rects, i), e;
        }, {}),
            s = a[t.placement],
            c = s.x,
            u = s.y;
        null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
      }
    };
    var uo = {
      name: "popperOffsets",
      enabled: !0,
      phase: "read",
      fn: function (e) {
        var t = e.state,
            n = e.name;
        t.modifiersData[n] = no({
          reference: t.rects.reference,
          element: t.rects.popper,
          strategy: "absolute",
          placement: t.placement
        });
      },
      data: {}
    };
    var lo = {
      name: "preventOverflow",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t = e.state,
            n = e.options,
            r = e.name,
            o = n.mainAxis,
            i = void 0 === o || o,
            a = n.altAxis,
            s = void 0 !== a && a,
            c = n.boundary,
            u = n.rootBoundary,
            l = n.altBoundary,
            p = n.padding,
            f = n.tether,
            d = void 0 === f || f,
            h = n.tetherOffset,
            g = void 0 === h ? 0 : h,
            v = ro(t, {
          boundary: c,
          rootBoundary: u,
          padding: p,
          altBoundary: l
        }),
            m = cr(t.placement),
            b = Fr(t.placement),
            y = !b,
            O = kr(m),
            w = "x" === O ? "y" : "x",
            x = t.modifiersData.popperOffsets,
            j = t.rects.reference,
            S = t.rects.popper,
            E = "function" == typeof g ? g(Object.assign({}, t.rects, {
          placement: t.placement
        })) : g,
            k = "number" == typeof E ? {
          mainAxis: E,
          altAxis: E
        } : Object.assign({
          mainAxis: 0,
          altAxis: 0
        }, E),
            P = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
            C = {
          x: 0,
          y: 0
        };

        if (x) {
          if (i) {
            var _,
                R = "y" === O ? Rr : Ir,
                N = "y" === O ? Nr : Dr,
                D = "y" === O ? "height" : "width",
                I = x[O],
                L = I + v[R],
                M = I - v[N],
                T = d ? -S[D] / 2 : 0,
                A = "start" === b ? j[D] : S[D],
                V = "start" === b ? -S[D] : -j[D],
                F = t.elements.arrow,
                z = d && F ? mr(F) : {
              width: 0,
              height: 0
            },
                H = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
                U = H[R],
                B = H[N],
                $ = Pr(0, j[D], z[D]),
                q = y ? j[D] / 2 - T - $ - U - k.mainAxis : A - $ - U - k.mainAxis,
                W = y ? -j[D] / 2 + T + $ + B + k.mainAxis : V + $ + B + k.mainAxis,
                K = t.elements.arrow && Er(t.elements.arrow),
                Y = K ? "y" === O ? K.clientTop || 0 : K.clientLeft || 0 : 0,
                G = null != (_ = null == P ? void 0 : P[O]) ? _ : 0,
                J = I + W - G,
                X = Pr(d ? hr(L, I + q - G - Y) : L, I, d ? dr(M, J) : M);

            x[O] = X, C[O] = X - I;
          }

          if (s) {
            var Z,
                Q = "x" === O ? Rr : Ir,
                ee = "x" === O ? Nr : Dr,
                te = x[w],
                ne = "y" === w ? "height" : "width",
                re = te + v[Q],
                oe = te - v[ee],
                ie = -1 !== [Rr, Ir].indexOf(m),
                ae = null != (Z = null == P ? void 0 : P[w]) ? Z : 0,
                se = ie ? re : te - j[ne] - S[ne] - ae + k.altAxis,
                ce = ie ? te + j[ne] + S[ne] - ae - k.altAxis : oe,
                ue = d && ie ? function (e, t, n) {
              var r = Pr(e, t, n);
              return r > n ? n : r;
            }(se, te, ce) : Pr(d ? se : re, te, d ? ce : oe);
            x[w] = ue, C[w] = ue - te;
          }

          t.modifiersData[r] = C;
        }
      },
      requiresIfExists: ["offset"]
    };

    function po(e, t, n) {
      void 0 === n && (n = !1);

      var r,
          o,
          i = pr(t),
          a = pr(t) && function (e) {
        var t = e.getBoundingClientRect(),
            n = gr(t.width) / e.offsetWidth || 1,
            r = gr(t.height) / e.offsetHeight || 1;
        return 1 !== n || 1 !== r;
      }(t),
          s = xr(t),
          c = vr(e, a),
          u = {
        scrollLeft: 0,
        scrollTop: 0
      },
          l = {
        x: 0,
        y: 0
      };

      return (i || !i && !n) && (("body" !== yr(t) || Xr(s)) && (u = (r = t) !== ur(r) && pr(r) ? {
        scrollLeft: (o = r).scrollLeft,
        scrollTop: o.scrollTop
      } : Gr(r)), pr(t) ? ((l = vr(t, !0)).x += t.clientLeft, l.y += t.clientTop) : s && (l.x = Jr(s))), {
        x: c.left + u.scrollLeft - l.x,
        y: c.top + u.scrollTop - l.y,
        width: c.width,
        height: c.height
      };
    }

    function fo(e) {
      var t = new Map(),
          n = new Set(),
          r = [];
      return e.forEach(function (e) {
        t.set(e.name, e);
      }), e.forEach(function (e) {
        n.has(e.name) || function e(o) {
          n.add(o.name), [].concat(o.requires || [], o.requiresIfExists || []).forEach(function (r) {
            if (!n.has(r)) {
              var o = t.get(r);
              o && e(o);
            }
          }), r.push(o);
        }(e);
      }), r;
    }

    var ho = {
      placement: "bottom",
      modifiers: [],
      strategy: "absolute"
    };

    function go() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

      return !t.some(function (e) {
        return !(e && "function" == typeof e.getBoundingClientRect);
      });
    }

    function vo(e) {
      void 0 === e && (e = {});
      var t = e,
          n = t.defaultModifiers,
          r = void 0 === n ? [] : n,
          o = t.defaultOptions,
          i = void 0 === o ? ho : o;
      return function (e, t, n) {
        void 0 === n && (n = i);
        var o,
            a,
            s = {
          placement: "bottom",
          orderedModifiers: [],
          options: Object.assign({}, ho, i),
          modifiersData: {},
          elements: {
            reference: e,
            popper: t
          },
          attributes: {},
          styles: {}
        },
            c = [],
            u = !1,
            l = {
          state: s,
          setOptions: function (n) {
            var o = "function" == typeof n ? n(s.options) : n;
            p(), s.options = Object.assign({}, i, s.options, o), s.scrollParents = {
              reference: lr(e) ? Zr(e) : e.contextElement ? Zr(e.contextElement) : [],
              popper: Zr(t)
            };

            var a = function (e) {
              var t = fo(e);
              return Ar.reduce(function (e, n) {
                return e.concat(t.filter(function (e) {
                  return e.phase === n;
                }));
              }, []);
            }(function (e) {
              var t = e.reduce(function (e, t) {
                var n = e[t.name];
                return e[t.name] = n ? Object.assign({}, n, t, {
                  options: Object.assign({}, n.options, t.options),
                  data: Object.assign({}, n.data, t.data)
                }) : t, e;
              }, {});
              return Object.keys(t).map(function (e) {
                return t[e];
              });
            }([].concat(r, s.options.modifiers)));

            return s.orderedModifiers = a.filter(function (e) {
              return e.enabled;
            }), s.orderedModifiers.forEach(function (e) {
              var t = e.name,
                  n = e.options,
                  r = void 0 === n ? {} : n,
                  o = e.effect;

              if ("function" == typeof o) {
                var i = o({
                  state: s,
                  name: t,
                  instance: l,
                  options: r
                });
                c.push(i || function () {});
              }
            }), l.update();
          },
          forceUpdate: function () {
            if (!u) {
              var e = s.elements,
                  t = e.reference,
                  n = e.popper;

              if (go(t, n)) {
                s.rects = {
                  reference: po(t, Er(n), "fixed" === s.options.strategy),
                  popper: mr(n)
                }, s.reset = !1, s.placement = s.options.placement, s.orderedModifiers.forEach(function (e) {
                  return s.modifiersData[e.name] = Object.assign({}, e.data);
                });

                for (var r = 0; r < s.orderedModifiers.length; r++) if (!0 !== s.reset) {
                  var o = s.orderedModifiers[r],
                      i = o.fn,
                      a = o.options,
                      c = void 0 === a ? {} : a,
                      p = o.name;
                  "function" == typeof i && (s = i({
                    state: s,
                    options: c,
                    name: p,
                    instance: l
                  }) || s);
                } else s.reset = !1, r = -1;
              }
            }
          },
          update: (o = function () {
            return new Promise(function (e) {
              l.forceUpdate(), e(s);
            });
          }, function () {
            return a || (a = new Promise(function (e) {
              Promise.resolve().then(function () {
                a = void 0, e(o());
              });
            })), a;
          }),
          destroy: function () {
            p(), u = !0;
          }
        };
        if (!go(e, t)) return l;

        function p() {
          c.forEach(function (e) {
            return e();
          }), c = [];
        }

        return l.setOptions(n).then(function (e) {
          !u && n.onFirstUpdate && n.onFirstUpdate(e);
        }), l;
      };
    }

    const mo = vo({
      defaultModifiers: [so, uo, Ur, $r, co, oo, lo, Vr]
    }),
          bo = ["enabled", "placement", "strategy", "modifiers"];
    const yo = {
      name: "applyStyles",
      enabled: !1,
      phase: "afterWrite",
      fn: () => {}
    },
          Oo = {
      name: "ariaDescribedBy",
      enabled: !0,
      phase: "afterWrite",
      effect: _ref => {
        let e = _ref.state;
        return () => {
          const _e$elements = e.elements,
                t = _e$elements.reference,
                n = _e$elements.popper;

          if ("removeAttribute" in t) {
            const e = (t.getAttribute("aria-describedby") || "").split(",").filter(e => e.trim() !== n.id);
            e.length ? t.setAttribute("aria-describedby", e.join(",")) : t.removeAttribute("aria-describedby");
          }
        };
      },
      fn: _ref2 => {
        let e = _ref2.state;
        var t;
        const _e$elements2 = e.elements,
              n = _e$elements2.popper,
              r = _e$elements2.reference,
              o = null == (t = n.getAttribute("role")) ? void 0 : t.toLowerCase();

        if (n.id && "tooltip" === o && "setAttribute" in r) {
          const e = r.getAttribute("aria-describedby");
          if (e && -1 !== e.split(",").indexOf(n.id)) return;
          r.setAttribute("aria-describedby", e ? "".concat(e, ",").concat(n.id) : n.id);
        }
      }
    },
          wo = [];

    var xo = function (e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      let _n$enabled = n.enabled,
          r = _n$enabled === void 0 ? !0 : _n$enabled,
          _n$placement = n.placement,
          i = _n$placement === void 0 ? "bottom" : _n$placement,
          _n$strategy = n.strategy,
          a = _n$strategy === void 0 ? "absolute" : _n$strategy,
          _n$modifiers = n.modifiers,
          s = _n$modifiers === void 0 ? wo : _n$modifiers,
          c = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            i = Object.keys(e);

        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

        return o;
      }(n, bo);

      const u = Object(o.useRef)(s),
            l = Object(o.useRef)(),
            p = Object(o.useCallback)(() => {
        var e;
        null == (e = l.current) || e.update();
      }, []),
            f = Object(o.useCallback)(() => {
        var e;
        null == (e = l.current) || e.forceUpdate();
      }, []),
            _sr = sr(Object(o.useState)({
        placement: i,
        update: p,
        forceUpdate: f,
        attributes: {},
        styles: {
          popper: {},
          arrow: {}
        }
      })),
            _sr2 = _slicedToArray(_sr, 2),
            d = _sr2[0],
            h = _sr2[1],
            g = Object(o.useMemo)(() => ({
        name: "updateStateModifier",
        enabled: !0,
        phase: "write",
        requires: ["computeStyles"],
        fn: _ref3 => {
          let e = _ref3.state;
          const t = {},
                n = {};
          Object.keys(e.elements).forEach(r => {
            t[r] = e.styles[r], n[r] = e.attributes[r];
          }), h({
            state: e,
            styles: t,
            attributes: n,
            update: p,
            forceUpdate: f,
            placement: e.placement
          });
        }
      }), [p, f, h]),
            v = Object(o.useMemo)(() => (ar(u.current, s) || (u.current = s), u.current), [s]);

      return Object(o.useEffect)(() => {
        l.current && r && l.current.setOptions({
          placement: i,
          strategy: a,
          modifiers: [...v, g, yo]
        });
      }, [a, i, g, r, v]), Object(o.useEffect)(() => {
        if (r && null != e && null != t) return l.current = mo(e, t, Object.assign({}, c, {
          placement: i,
          strategy: a,
          modifiers: [...v, Oo, g]
        })), () => {
          null != l.current && (l.current.destroy(), l.current = void 0, h(e => Object.assign({}, e, {
            attributes: {},
            styles: {
              popper: {}
            }
          })));
        };
      }, [r, e, t]), d;
    },
        jo = !("undefined" == typeof window || !window.document || !window.document.createElement),
        So = !1,
        Eo = !1;

    try {
      var ko = {
        get passive() {
          return So = !0;
        },

        get once() {
          return Eo = So = !0;
        }

      };
      jo && (window.addEventListener("test", ko, ko), window.removeEventListener("test", ko, !0));
    } catch (e) {}

    var Po = function (e, t, n, r) {
      if (r && "boolean" != typeof r && !Eo) {
        var o = r.once,
            i = r.capture,
            a = n;
        !Eo && o && (a = n.__once || function e(r) {
          this.removeEventListener(t, e, i), n.call(this, r);
        }, n.__once = a), e.addEventListener(t, a, So ? r : i);
      }

      e.addEventListener(t, n, r);
    };

    var Co = function (e, t, n, r) {
      var o = r && "boolean" != typeof r ? r.capture : r;
      e.removeEventListener(t, n, o), n.__once && e.removeEventListener(t, n.__once, o);
    };

    var _o = function (e, t, n, r) {
      return Po(e, t, n, r), function () {
        Co(e, t, n, r);
      };
    };

    function Ro(e) {
      return e && e.ownerDocument || document;
    }

    var No = function (e) {
      var t = Object(o.useRef)(e);
      return Object(o.useEffect)(function () {
        t.current = e;
      }, [e]), t;
    };

    function Do(e) {
      var t = No(e);
      return Object(o.useCallback)(function () {
        return t.current && t.current.apply(t, arguments);
      }, [t]);
    }

    const Io = () => {};

    const Lo = e => e && ("current" in e ? e.current : e),
          Mo = {
      click: "mousedown",
      mouseup: "mousedown",
      pointerup: "pointerdown"
    };

    var To = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Io;

      let _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          n = _ref4.disabled,
          _ref4$clickTrigger = _ref4.clickTrigger,
          r = _ref4$clickTrigger === void 0 ? "click" : _ref4$clickTrigger;

      const i = Object(o.useRef)(!1),
            a = Object(o.useRef)(!1),
            s = Object(o.useCallback)(t => {
        const n = Lo(e);
        var r;
        zn()(!!n, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node"), i.current = !n || !!((r = t).metaKey || r.altKey || r.ctrlKey || r.shiftKey) || !function (e) {
          return 0 === e.button;
        }(t) || !!Ln(n, t.target) || a.current, a.current = !1;
      }, [e]),
            c = Do(t => {
        const n = Lo(e);
        n && Ln(n, t.target) && (a.current = !0);
      }),
            u = Do(e => {
        i.current || t(e);
      });
      Object(o.useEffect)(() => {
        if (n || null == e) return;
        const t = Ro(Lo(e));
        let o = (t.defaultView || window).event,
            i = null;
        Mo[r] && (i = _o(t, Mo[r], c, !0));

        const a = _o(t, r, s, !0),
              l = _o(t, r, e => {
          e !== o ? u(e) : o = void 0;
        });

        let p = [];
        return "ontouchstart" in t.documentElement && (p = [].slice.call(t.body.children).map(e => _o(e, "mousemove", Io))), () => {
          null == i || i(), a(), l(), p.forEach(e => e());
        };
      }, [e, n, r, s, c, u]);
    };

    const Ao = () => {};

    var Vo = function (e, t) {
      let _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          n = _ref5.disabled,
          r = _ref5.clickTrigger;

      const i = t || Ao;
      To(e, i, {
        disabled: n,
        clickTrigger: r
      });
      const a = Do(e => {
        27 === e.keyCode && i(e);
      });
      Object(o.useEffect)(() => {
        if (n || null == e) return;
        const t = Ro(Lo(e));
        let r = (t.defaultView || window).event;

        const o = _o(t, "keyup", e => {
          e !== r ? a(e) : r = void 0;
        });

        return () => {
          o();
        };
      }, [e, n, a]);
    };

    const Fo = Object(o.createContext)(jo ? window : void 0);
    Fo.Provider;

    function zo() {
      return Object(o.useContext)(Fo);
    }

    const Ho = (e, t) => {
      var n;
      return jo ? null == e ? (t || Ro()).body : ("function" == typeof e && (e = e()), e && "current" in e && (e = e.current), null != (n = e) && n.nodeType && e || null) : null;
    };

    function Uo(e, t) {
      const n = zo(),
            _Object = Object(o.useState)(() => Ho(e, null == n ? void 0 : n.document)),
            _Object2 = _slicedToArray(_Object, 2),
            r = _Object2[0],
            i = _Object2[1];

      if (!r) {
        const t = Ho(e);
        t && i(t);
      }

      return Object(o.useEffect)(() => {
        t && r && t(r);
      }, [t, r]), Object(o.useEffect)(() => {
        const t = Ho(e);
        t !== r && i(t);
      }, [e, r]), r;
    }

    function Bo() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Array.isArray(e) ? e : Object.keys(e).map(t => (e[t].name = t, e[t]));
    }

    function $o(_ref6) {
      let e = _ref6.enabled,
          t = _ref6.enableEvents,
          n = _ref6.placement,
          r = _ref6.flip,
          o = _ref6.offset,
          i = _ref6.fixed,
          a = _ref6.containerPadding,
          s = _ref6.arrowElement,
          _ref6$popperConfig = _ref6.popperConfig,
          c = _ref6$popperConfig === void 0 ? {} : _ref6$popperConfig;
      var u, l, p, f;

      const d = function (e) {
        const t = {};
        return Array.isArray(e) ? (null == e || e.forEach(e => {
          t[e.name] = e;
        }), t) : e || t;
      }(c.modifiers);

      return Object.assign({}, c, {
        placement: n,
        enabled: e,
        strategy: i ? "fixed" : c.strategy,
        modifiers: Bo(Object.assign({}, d, {
          eventListeners: {
            enabled: t
          },
          preventOverflow: Object.assign({}, d.preventOverflow, {
            options: a ? Object.assign({
              padding: a
            }, null == (u = d.preventOverflow) ? void 0 : u.options) : null == (l = d.preventOverflow) ? void 0 : l.options
          }),
          offset: {
            options: Object.assign({
              offset: o
            }, null == (p = d.offset) ? void 0 : p.options)
          },
          arrow: Object.assign({}, d.arrow, {
            enabled: !!s,
            options: Object.assign({}, null == (f = d.arrow) ? void 0 : f.options, {
              element: s
            })
          }),
          flip: Object.assign({
            enabled: !!r
          }, d.flip)
        }))
      });
    }

    var qo = n(1);
    const Wo = o.forwardRef((e, t) => {
      const n = e.flip,
            r = e.offset,
            i = e.placement,
            a = e.containerPadding,
            _e$popperConfig = e.popperConfig,
            s = _e$popperConfig === void 0 ? {} : _e$popperConfig,
            c = e.transition,
            _rr = rr(),
            _rr2 = _slicedToArray(_rr, 2),
            u = _rr2[0],
            l = _rr2[1],
            _rr3 = rr(),
            _rr4 = _slicedToArray(_rr3, 2),
            p = _rr4[0],
            f = _rr4[1],
            d = Zn(l, t),
            h = Uo(e.container),
            g = Uo(e.target),
            _Object3 = Object(o.useState)(!e.show),
            _Object4 = _slicedToArray(_Object3, 2),
            v = _Object4[0],
            m = _Object4[1],
            b = xo(g, u, $o({
        placement: i,
        enableEvents: !!e.show,
        containerPadding: a || 5,
        flip: n,
        offset: r,
        arrowElement: p,
        popperConfig: s
      }));

      e.show ? v && m(!1) : e.transition || v || m(!0);

      const y = function () {
        m(!0), e.onExited && e.onExited(...arguments);
      },
            O = e.show || c && !v;

      if (Vo(u, e.onHide, {
        disabled: !e.rootClose || e.rootCloseDisabled,
        clickTrigger: e.rootCloseEvent
      }), !O) return null;
      let w = e.children(Object.assign({}, b.attributes.popper, {
        style: b.styles.popper,
        ref: d
      }), {
        popper: b,
        placement: i,
        show: !!e.show,
        arrowProps: Object.assign({}, b.attributes.arrow, {
          style: b.styles.arrow,
          ref: f
        })
      });

      if (c) {
        const t = e.onExit,
              n = e.onExiting,
              r = e.onEnter,
              o = e.onEntering,
              i = e.onEntered;
        w = Object(qo.jsx)(c, {
          in: e.show,
          appear: !0,
          onExit: t,
          onExiting: n,
          onExited: y,
          onEnter: r,
          onEntering: o,
          onEntered: i,
          children: w
        });
      }

      return h ? nr.a.createPortal(w, h) : null;
    });
    Wo.displayName = "Overlay";
    var Ko = Wo;
    const Yo = ["xxl", "xl", "lg", "md", "sm", "xs"],
          Go = o.createContext({
      prefixes: {},
      breakpoints: Yo
    }),
          Jo = Go.Consumer,
          Xo = Go.Provider;

    function Zo(e, t) {
      const _Object5 = Object(o.useContext)(Go),
            n = _Object5.prefixes;

      return e || n[t] || t;
    }

    function Qo() {
      const _Object6 = Object(o.useContext)(Go),
            e = _Object6.dir;

      return "rtl" === e;
    }

    var ei = /-(.)/g;

    const ti = e => {
      return e[0].toUpperCase() + (t = e, t.replace(ei, function (e, t) {
        return t.toUpperCase();
      })).slice(1);
      var t;
    };

    function ni(e) {
      let _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref7$displayName = _ref7.displayName,
          t = _ref7$displayName === void 0 ? ti(e) : _ref7$displayName,
          n = _ref7.Component,
          r = _ref7.defaultProps;

      const i = o.forwardRef((_ref8, a) => {
        let t = _ref8.className,
            r = _ref8.bsPrefix,
            _ref8$as = _ref8.as,
            o = _ref8$as === void 0 ? n || "div" : _ref8$as,
            i = _objectWithoutProperties(_ref8, _excluded);

        const s = Zo(r, e);
        return Object(qo.jsx)(o, _objectSpread({
          ref: a,
          className: er()(t, s)
        }, i));
      });
      return i.defaultProps = r, i.displayName = t, i;
    }

    var ri = ni("popover-header"),
        oi = ni("popover-body");
    o.Component;

    function ii(e, t) {
      let n = e;
      return "left" === e ? n = t ? "end" : "start" : "right" === e && (n = t ? "start" : "end"), n;
    }

    const ai = o.forwardRef((_ref9, l) => {
      let e = _ref9.bsPrefix,
          t = _ref9.placement,
          n = _ref9.className,
          r = _ref9.style,
          o = _ref9.children,
          i = _ref9.body,
          a = _ref9.arrowProps,
          s = _ref9.popper,
          c = _ref9.show,
          u = _objectWithoutProperties(_ref9, _excluded2);

      const p = Zo(e, "popover"),
            f = Qo(),
            _ref10 = (null == t ? void 0 : t.split("-")) || [],
            _ref11 = _slicedToArray(_ref10, 1),
            d = _ref11[0],
            h = ii(d, f);

      return Object(qo.jsxs)("div", _objectSpread(_objectSpread({
        ref: l,
        role: "tooltip",
        style: r,
        "x-placement": d,
        className: er()(n, p, d && "bs-popover-" + h)
      }, u), {}, {
        children: [Object(qo.jsx)("div", _objectSpread({
          className: "popover-arrow"
        }, a)), i ? Object(qo.jsx)(oi, {
          children: o
        }) : o]
      }));
    });
    ai.defaultProps = {
      placement: "right"
    };
    var si = Object.assign(ai, {
      Header: ri,
      Body: oi,
      POPPER_OFFSET: [0, 8]
    });

    var ci = !1,
        ui = i.a.createContext(null),
        li = function (e) {
      function t(t, n) {
        var r;
        r = e.call(this, t, n) || this;
        var o,
            i = n && !n.isMounting ? t.enter : t.appear;
        return r.appearStatus = null, t.in ? i ? (o = "exited", r.appearStatus = "entering") : o = "entered" : o = t.unmountOnExit || t.mountOnEnter ? "unmounted" : "exited", r.state = {
          status: o
        }, r.nextCallback = null, r;
      }

      Kn(t, e), t.getDerivedStateFromProps = function (e, t) {
        return e.in && "unmounted" === t.status ? {
          status: "exited"
        } : null;
      };
      var n = t.prototype;
      return n.componentDidMount = function () {
        this.updateStatus(!0, this.appearStatus);
      }, n.componentDidUpdate = function (e) {
        var t = null;

        if (e !== this.props) {
          var n = this.state.status;
          this.props.in ? "entering" !== n && "entered" !== n && (t = "entering") : "entering" !== n && "entered" !== n || (t = "exiting");
        }

        this.updateStatus(!1, t);
      }, n.componentWillUnmount = function () {
        this.cancelNextCallback();
      }, n.getTimeouts = function () {
        var e,
            t,
            n,
            r = this.props.timeout;
        return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
          exit: e,
          enter: t,
          appear: n
        };
      }, n.updateStatus = function (e, t) {
        if (void 0 === e && (e = !1), null !== t) {
          if (this.cancelNextCallback(), "entering" === t) {
            if (this.props.unmountOnExit || this.props.mountOnEnter) {
              var n = this.props.nodeRef ? this.props.nodeRef.current : nr.a.findDOMNode(this);
              n && function (e) {
                e.scrollTop;
              }(n);
            }

            this.performEnter(e);
          } else this.performExit();
        } else this.props.unmountOnExit && "exited" === this.state.status && this.setState({
          status: "unmounted"
        });
      }, n.performEnter = function (e) {
        var t = this,
            n = this.props.enter,
            r = this.context ? this.context.isMounting : e,
            o = this.props.nodeRef ? [r] : [nr.a.findDOMNode(this), r],
            i = o[0],
            a = o[1],
            s = this.getTimeouts(),
            c = r ? s.appear : s.enter;
        !e && !n || ci ? this.safeSetState({
          status: "entered"
        }, function () {
          t.props.onEntered(i);
        }) : (this.props.onEnter(i, a), this.safeSetState({
          status: "entering"
        }, function () {
          t.props.onEntering(i, a), t.onTransitionEnd(c, function () {
            t.safeSetState({
              status: "entered"
            }, function () {
              t.props.onEntered(i, a);
            });
          });
        }));
      }, n.performExit = function () {
        var e = this,
            t = this.props.exit,
            n = this.getTimeouts(),
            r = this.props.nodeRef ? void 0 : nr.a.findDOMNode(this);
        t && !ci ? (this.props.onExit(r), this.safeSetState({
          status: "exiting"
        }, function () {
          e.props.onExiting(r), e.onTransitionEnd(n.exit, function () {
            e.safeSetState({
              status: "exited"
            }, function () {
              e.props.onExited(r);
            });
          });
        })) : this.safeSetState({
          status: "exited"
        }, function () {
          e.props.onExited(r);
        });
      }, n.cancelNextCallback = function () {
        null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
      }, n.safeSetState = function (e, t) {
        t = this.setNextCallback(t), this.setState(e, t);
      }, n.setNextCallback = function (e) {
        var t = this,
            n = !0;
        return this.nextCallback = function (r) {
          n && (n = !1, t.nextCallback = null, e(r));
        }, this.nextCallback.cancel = function () {
          n = !1;
        }, this.nextCallback;
      }, n.onTransitionEnd = function (e, t) {
        this.setNextCallback(t);
        var n = this.props.nodeRef ? this.props.nodeRef.current : nr.a.findDOMNode(this),
            r = null == e && !this.props.addEndListener;

        if (n && !r) {
          if (this.props.addEndListener) {
            var o = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
                i = o[0],
                a = o[1];
            this.props.addEndListener(i, a);
          }

          null != e && setTimeout(this.nextCallback, e);
        } else setTimeout(this.nextCallback, 0);
      }, n.render = function () {
        var e = this.state.status;
        if ("unmounted" === e) return null;
        var t = this.props,
            n = t.children,
            r = (t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef, Un(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
        return i.a.createElement(ui.Provider, {
          value: null
        }, "function" == typeof n ? n(e, r) : i.a.cloneElement(i.a.Children.only(n), r));
      }, t;
    }(i.a.Component);

    function pi() {}

    li.contextType = ui, li.propTypes = {}, li.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: pi,
      onEntering: pi,
      onEntered: pi,
      onExit: pi,
      onExiting: pi,
      onExited: pi
    }, li.UNMOUNTED = "unmounted", li.EXITED = "exited", li.ENTERING = "entering", li.ENTERED = "entered", li.EXITING = "exiting";
    var fi = li;

    function di(e, t) {
      return function (e) {
        var t = Ro(e);
        return t && t.defaultView || window;
      }(e).getComputedStyle(e, t);
    }

    var hi = /([A-Z])/g;
    var gi = /^ms-/;

    function vi(e) {
      return function (e) {
        return e.replace(hi, "-$1").toLowerCase();
      }(e).replace(gi, "-ms-");
    }

    var mi = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

    var bi = function (e, t) {
      var n = "",
          r = "";
      if ("string" == typeof t) return e.style.getPropertyValue(vi(t)) || di(e).getPropertyValue(vi(t));
      Object.keys(t).forEach(function (o) {
        var i = t[o];
        i || 0 === i ? !function (e) {
          return !(!e || !mi.test(e));
        }(o) ? n += vi(o) + ": " + i + ";" : r += o + "(" + i + ") " : e.style.removeProperty(vi(o));
      }), r && (n += "transform: " + r + ";"), e.style.cssText += ";" + n;
    };

    function yi(e, t, n) {
      void 0 === n && (n = 5);

      var r = !1,
          o = setTimeout(function () {
        r || function (e, t, n, r) {
          if (void 0 === n && (n = !1), void 0 === r && (r = !0), e) {
            var o = document.createEvent("HTMLEvents");
            o.initEvent(t, n, r), e.dispatchEvent(o);
          }
        }(e, "transitionend", !0);
      }, t + n),
          i = _o(e, "transitionend", function () {
        r = !0;
      }, {
        once: !0
      });

      return function () {
        clearTimeout(o), i();
      };
    }

    function Oi(e, t, n, r) {
      var o, i;
      null == n && (o = bi(e, "transitionDuration") || "", i = -1 === o.indexOf("ms") ? 1e3 : 1, n = parseFloat(o) * i || 0);

      var a = yi(e, n, r),
          s = _o(e, "transitionend", t);

      return function () {
        a(), s();
      };
    }

    function wi(e, t) {
      const n = bi(e, t) || "",
            r = -1 === n.indexOf("ms") ? 1e3 : 1;
      return parseFloat(n) * r;
    }

    function xi(e, t) {
      const n = wi(e, "transitionDuration"),
            r = wi(e, "transitionDelay"),
            o = Oi(e, n => {
        n.target === e && (o(), t(n));
      }, n + r);
    }

    function ji(e) {
      return e && "setState" in e ? nr.a.findDOMNode(e) : null != e ? e : null;
    }

    var Si = i.a.forwardRef((_ref12, f) => {
      let e = _ref12.onEnter,
          t = _ref12.onEntering,
          n = _ref12.onEntered,
          r = _ref12.onExit,
          a = _ref12.onExiting,
          s = _ref12.onExited,
          c = _ref12.addEndListener,
          u = _ref12.children,
          l = _ref12.childRef,
          p = _objectWithoutProperties(_ref12, _excluded3);

      const d = Object(o.useRef)(null),
            h = Zn(d, l),
            g = e => {
        h(ji(e));
      },
            v = e => t => {
        e && d.current && e(d.current, t);
      },
            m = Object(o.useCallback)(v(e), [e]),
            b = Object(o.useCallback)(v(t), [t]),
            y = Object(o.useCallback)(v(n), [n]),
            O = Object(o.useCallback)(v(r), [r]),
            w = Object(o.useCallback)(v(a), [a]),
            x = Object(o.useCallback)(v(s), [s]),
            j = Object(o.useCallback)(v(c), [c]);

      return Object(qo.jsx)(fi, _objectSpread(_objectSpread({
        ref: f
      }, p), {}, {
        onEnter: m,
        onEntered: y,
        onEntering: b,
        onExit: O,
        onExited: x,
        onExiting: w,
        addEndListener: j,
        nodeRef: d,
        children: "function" == typeof u ? (e, t) => u(e, _objectSpread(_objectSpread({}, t), {}, {
          ref: g
        })) : i.a.cloneElement(u, {
          ref: g
        })
      }));
    });
    const Ei = {
      entering: "show",
      entered: "show"
    },
          ki = o.forwardRef((_ref13, i) => {
      let e = _ref13.className,
          t = _ref13.children,
          _ref13$transitionClas = _ref13.transitionClasses,
          n = _ref13$transitionClas === void 0 ? {} : _ref13$transitionClas,
          r = _objectWithoutProperties(_ref13, _excluded4);

      const a = Object(o.useCallback)((e, t) => {
        !function (e) {
          e.offsetHeight;
        }(e), null == r.onEnter || r.onEnter(e, t);
      }, [r]);
      return Object(qo.jsx)(Si, _objectSpread(_objectSpread({
        ref: i,
        addEndListener: xi
      }, r), {}, {
        onEnter: a,
        childRef: t.ref,
        children: (r, i) => o.cloneElement(t, _objectSpread(_objectSpread({}, i), {}, {
          className: er()("fade", e, t.props.className, Ei[r], n[r])
        }))
      }));
    });
    ki.defaultProps = {
      in: !1,
      timeout: 300,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1
    }, ki.displayName = "Fade";
    var Pi = ki;
    const Ci = {
      transition: Pi,
      rootClose: !1,
      show: !1,
      placement: "top"
    };

    const _i = o.forwardRef((_ref14, i) => {
      let e = _ref14.children,
          t = _ref14.transition,
          _ref14$popperConfig = _ref14.popperConfig,
          n = _ref14$popperConfig === void 0 ? {} : _ref14$popperConfig,
          r = _objectWithoutProperties(_ref14, _excluded5);

      const a = Object(o.useRef)({}),
            _ref15 = function (e) {
        const t = Object(o.useRef)(null),
              n = Zo(void 0, "popover"),
              r = Object(o.useMemo)(() => ({
          name: "offset",
          options: {
            offset: () => {
              return t.current && (r = t.current, o = n, r.classList ? o && r.classList.contains(o) : -1 !== (" " + (r.className.baseVal || r.className) + " ").indexOf(" " + o + " ")) ? e || si.POPPER_OFFSET : e || [0, 0];
              var r, o;
            }
          }
        }), [e, n]);
        return [t, [r]];
      }(r.offset),
            _ref16 = _slicedToArray(_ref15, 2),
            s = _ref16[0],
            c = _ref16[1],
            u = Zn(i, s),
            l = !0 === t ? Pi : t || void 0;

      return Object(qo.jsx)(Ko, _objectSpread(_objectSpread({}, r), {}, {
        ref: u,
        popperConfig: _objectSpread(_objectSpread({}, n), {}, {
          modifiers: c.concat(n.modifiers || [])
        }),
        transition: l,
        children: (n, _ref17) => {
          let r = _ref17.arrowProps,
              i = _ref17.popper,
              s = _ref17.show;
          var c, u;
          !function (e, t) {
            const n = e.ref,
                  r = t.ref;
            e.ref = n.__wrapped || (n.__wrapped = e => n(ji(e))), t.ref = r.__wrapped || (r.__wrapped = e => r(ji(e)));
          }(n, r);
          const l = null == i ? void 0 : i.placement,
                p = Object.assign(a.current, {
            state: null == i ? void 0 : i.state,
            scheduleUpdate: null == i ? void 0 : i.update,
            placement: l,
            outOfBoundaries: (null == i || null == (c = i.state) || null == (u = c.modifiersData.hide) ? void 0 : u.isReferenceHidden) || !1
          });
          return "function" == typeof e ? e(_objectSpread(_objectSpread(_objectSpread({}, n), {}, {
            placement: l,
            show: s
          }, !t && s && {
            className: "show"
          }), {}, {
            popper: p,
            arrowProps: r
          })) : o.cloneElement(e, _objectSpread(_objectSpread({}, n), {}, {
            placement: l,
            arrowProps: r,
            popper: p,
            className: er()(e.props.className, !t && s && "show"),
            style: _objectSpread(_objectSpread({}, e.props.style), n.style)
          }));
        }
      }));
    });

    _i.displayName = "Overlay", _i.defaultProps = Ci;
    var Ri = _i;

    function Ni(e, t, n) {
      const _t2 = _slicedToArray(t, 1),
            r = _t2[0],
            o = r.currentTarget,
            i = r.relatedTarget || r.nativeEvent[n];

      i && i === o || Ln(o, i) || e(...t);
    }

    function Di(_ref18) {
      let e = _ref18.trigger,
          t = _ref18.overlay,
          n = _ref18.children,
          _ref18$popperConfig = _ref18.popperConfig,
          r = _ref18$popperConfig === void 0 ? {} : _ref18$popperConfig,
          i = _ref18.show,
          _ref18$defaultShow = _ref18.defaultShow,
          a = _ref18$defaultShow === void 0 ? !1 : _ref18$defaultShow,
          s = _ref18.onToggle,
          c = _ref18.delay,
          u = _ref18.placement,
          _ref18$flip = _ref18.flip,
          l = _ref18$flip === void 0 ? u && -1 !== u.indexOf("auto") : _ref18$flip,
          p = _objectWithoutProperties(_ref18, _excluded6);

      const f = Object(o.useRef)(null),
            d = Zn(f, n.ref),
            h = Vn(),
            g = Object(o.useRef)(""),
            _qn = qn(i, a, s),
            _qn2 = _slicedToArray(_qn, 2),
            v = _qn2[0],
            m = _qn2[1],
            b = function (e) {
        return e && "object" == typeof e ? e : {
          show: e,
          hide: e
        };
      }(c),
            _ref19 = "function" != typeof n ? o.Children.only(n).props : {},
            y = _ref19.onFocus,
            O = _ref19.onBlur,
            w = _ref19.onClick,
            x = Object(o.useCallback)(() => {
        h.clear(), g.current = "show", b.show ? h.set(() => {
          "show" === g.current && m(!0);
        }, b.show) : m(!0);
      }, [b.show, m, h]),
            j = Object(o.useCallback)(() => {
        h.clear(), g.current = "hide", b.hide ? h.set(() => {
          "hide" === g.current && m(!1);
        }, b.hide) : m(!1);
      }, [b.hide, m, h]),
            S = Object(o.useCallback)(function () {
        x(), null == y || y(...arguments);
      }, [x, y]),
            E = Object(o.useCallback)(function () {
        j(), null == O || O(...arguments);
      }, [j, O]),
            k = Object(o.useCallback)(function () {
        m(!v), null == w || w(...arguments);
      }, [w, m, v]),
            P = Object(o.useCallback)(function () {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }

        Ni(x, e, "fromElement");
      }, [x]),
            C = Object(o.useCallback)(function () {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }

        Ni(j, e, "toElement");
      }, [j]),
            _ = null == e ? [] : [].concat(e),
            R = {
        ref: e => {
          d(ji(e));
        }
      };

      return -1 !== _.indexOf("click") && (R.onClick = k), -1 !== _.indexOf("focus") && (R.onFocus = S, R.onBlur = E), -1 !== _.indexOf("hover") && (R.onMouseOver = P, R.onMouseOut = C), Object(qo.jsxs)(qo.Fragment, {
        children: ["function" == typeof n ? n(R) : Object(o.cloneElement)(n, R), Object(qo.jsx)(Ri, _objectSpread(_objectSpread({}, p), {}, {
          show: v,
          onHide: j,
          flip: l,
          placement: u,
          popperConfig: r,
          target: f.current,
          children: t
        }))]
      });
    }

    Di.defaultProps = {
      defaultShow: !1,
      trigger: ["hover", "focus"]
    };
    var Ii = Di;
    const Li = o.forwardRef((_ref20, u) => {
      let e = _ref20.bsPrefix,
          t = _ref20.placement,
          n = _ref20.className,
          r = _ref20.style,
          o = _ref20.children,
          i = _ref20.arrowProps,
          a = _ref20.popper,
          s = _ref20.show,
          c = _objectWithoutProperties(_ref20, _excluded7);

      e = Zo(e, "tooltip");

      const l = Qo(),
            _ref21 = (null == t ? void 0 : t.split("-")) || [],
            _ref22 = _slicedToArray(_ref21, 1),
            p = _ref22[0],
            f = ii(p, l);

      return Object(qo.jsxs)("div", _objectSpread(_objectSpread({
        ref: u,
        style: r,
        role: "tooltip",
        "x-placement": p,
        className: er()(n, e, "bs-tooltip-" + f)
      }, c), {}, {
        children: [Object(qo.jsx)("div", _objectSpread({
          className: "tooltip-arrow"
        }, i)), Object(qo.jsx)("div", {
          className: e + "-inner",
          children: o
        })]
      }));
    });
    Li.defaultProps = {
      placement: "right"
    }, Li.displayName = "Tooltip";
    var Mi,
        Ti = Li;

    function Ai(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Vi(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function Fi(e, t) {
      return (Fi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function zi(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Ui(e);

        if (t) {
          var o = Ui(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Hi(this, n);
      };
    }

    function Hi(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Ui(e) {
      return (Ui = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Bi(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var $i,
        qi = (Bi((Mi = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fi(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = zi(a);

      function a() {
        return Ai(this, a), o.apply(this, arguments);
      }

      return t = a, (n = [{
        key: "_show",
        get: function () {
          var e = this.props.show;
          if (null == e) throw new Error("OptionalViewIcon requires a 'show' property");
          return e;
        }
      }, {
        key: "_url",
        get: function () {
          var e = this.props.url;
          if (!e) throw new Error("OptionalViewIcon requires a 'url' property");
          return e;
        }
      }, {
        key: "_hint",
        get: function () {
          var e = this.props.hint;
          if (!e) throw new Error("OptionalViewIcon requires a 'hint' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          return this._show ? i.a.createElement(Ii, {
            placement: "top",
            delay: {
              show: 250,
              hide: 400
            },
            overlay: i.a.createElement(Ti, null, this._hint)
          }, i.a.createElement("a", {
            href: this._url,
            className: "optional-link"
          }, i.a.createElement(gt.FontAwesomeIcon, {
            icon: vt.faEye
          }))) : null;
        }
      }]) && Vi(t.prototype, n), r && Vi(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(i.a.Component)).prototype, "_show", [a.computed], Object.getOwnPropertyDescriptor(Mi.prototype, "_show"), Mi.prototype), Bi(Mi.prototype, "_url", [a.computed], Object.getOwnPropertyDescriptor(Mi.prototype, "_url"), Mi.prototype), Bi(Mi.prototype, "_hint", [a.computed], Object.getOwnPropertyDescriptor(Mi.prototype, "_hint"), Mi.prototype), Mi);

    function Wi(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ki(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function Yi(e, t) {
      return (Yi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Gi(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Xi(e);

        if (t) {
          var o = Xi(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Ji(this, n);
      };
    }

    function Ji(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Xi(e) {
      return (Xi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Zi(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Qi,
        ea = (Zi(($i = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Yi(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = Gi(a);

      function a() {
        return Wi(this, a), o.apply(this, arguments);
      }

      return t = a, (n = [{
        key: "_show",
        get: function () {
          var e = this.props.show;
          if (null == e) throw new Error("OptionalEditIcon requires a 'show' property");
          return e;
        }
      }, {
        key: "_url",
        get: function () {
          var e = this.props.url;
          if (!e) throw new Error("OptionalEditIcon requires a 'url' property");
          return e;
        }
      }, {
        key: "_hint",
        get: function () {
          var e = this.props.hint;
          if (!e) throw new Error("OptionalEditIcon requires a 'hint' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          return this._show ? i.a.createElement(Ii, {
            placement: "top",
            delay: {
              show: 250,
              hide: 400
            },
            overlay: i.a.createElement(Ti, null, this._hint)
          }, i.a.createElement("a", {
            href: this._url,
            className: "optional-link"
          }, i.a.createElement(gt.FontAwesomeIcon, {
            icon: vt.faEdit
          }))) : null;
        }
      }]) && Ki(t.prototype, n), r && Ki(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(i.a.Component)).prototype, "_show", [a.computed], Object.getOwnPropertyDescriptor($i.prototype, "_show"), $i.prototype), Zi($i.prototype, "_url", [a.computed], Object.getOwnPropertyDescriptor($i.prototype, "_url"), $i.prototype), Zi($i.prototype, "_hint", [a.computed], Object.getOwnPropertyDescriptor($i.prototype, "_hint"), $i.prototype), $i);

    function ta(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function na(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function ra(e, t) {
      return (ra = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function oa(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = aa(e);

        if (t) {
          var o = aa(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ia(this, n);
      };
    }

    function ia(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function aa(e) {
      return (aa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sa(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var ca = (sa((Qi = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ra(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = oa(a);

      function a() {
        return ta(this, a), o.apply(this, arguments);
      }

      return t = a, (n = [{
        key: "_show",
        get: function () {
          var e = this.props.show;
          if (null == e) throw new Error("OptionalDeleteIcon requires a 'show' property");
          return e;
        }
      }, {
        key: "_url",
        get: function () {
          var e = this.props.url;
          if (!e) throw new Error("OptionalDeleteIcon requires a 'url' property");
          return e;
        }
      }, {
        key: "_hint",
        get: function () {
          var e = this.props.hint;
          if (!e) throw new Error("OptionalDeleteIcon requires a 'hint' property");
          return e;
        }
      }, {
        key: "_confirmationMessage",
        get: function () {
          var e = this.props.confirmationMessage;
          if (!e) throw new Error("OptionalDeleteIcon requires a 'confirmationMessage' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          return this._show ? i.a.createElement(Ii, {
            placement: "top",
            delay: {
              show: 250,
              hide: 400
            },
            overlay: i.a.createElement(Ti, null, this._hint)
          }, i.a.createElement("a", {
            href: this._url,
            rel: "nofollow",
            "data-method": "delete",
            "data-confirm": this._confirmationMessage,
            className: "optional-link"
          }, i.a.createElement(gt.FontAwesomeIcon, {
            icon: vt.faTrashAlt
          }))) : null;
        }
      }]) && na(t.prototype, n), r && na(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(i.a.Component)).prototype, "_show", [a.computed], Object.getOwnPropertyDescriptor(Qi.prototype, "_show"), Qi.prototype), sa(Qi.prototype, "_url", [a.computed], Object.getOwnPropertyDescriptor(Qi.prototype, "_url"), Qi.prototype), sa(Qi.prototype, "_hint", [a.computed], Object.getOwnPropertyDescriptor(Qi.prototype, "_hint"), Qi.prototype), sa(Qi.prototype, "_confirmationMessage", [a.computed], Object.getOwnPropertyDescriptor(Qi.prototype, "_confirmationMessage"), Qi.prototype), Qi);

    var ua = function () {
      function e(e) {
        var t = this;
        this._insertTag = function (e) {
          var n;
          n = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e);
        }, this.isSpeedy = void 0 === e.speedy || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
      }

      var t = e.prototype;
      return t.hydrate = function (e) {
        e.forEach(this._insertTag);
      }, t.insert = function (e) {
        this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
          var t = document.createElement("style");
          return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
        }(this));
        var t = this.tags[this.tags.length - 1];

        if (this.isSpeedy) {
          var n = function (e) {
            if (e.sheet) return e.sheet;

            for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
          }(t);

          try {
            n.insertRule(e, n.cssRules.length);
          } catch (e) {
            0;
          }
        } else t.appendChild(document.createTextNode(e));

        this.ctr++;
      }, t.flush = function () {
        this.tags.forEach(function (e) {
          return e.parentNode && e.parentNode.removeChild(e);
        }), this.tags = [], this.ctr = 0;
      }, e;
    }(),
        la = "-webkit-",
        pa = "rule",
        fa = "decl",
        da = "@keyframes",
        ha = Math.abs,
        ga = String.fromCharCode,
        va = Object.assign;

    function ma(e, t) {
      return 45 ^ xa(e, 0) ? (((t << 2 ^ xa(e, 0)) << 2 ^ xa(e, 1)) << 2 ^ xa(e, 2)) << 2 ^ xa(e, 3) : 0;
    }

    function ba(e) {
      return e.trim();
    }

    function ya(e, t) {
      return (e = t.exec(e)) ? e[0] : e;
    }

    function Oa(e, t, n) {
      return e.replace(t, n);
    }

    function wa(e, t) {
      return e.indexOf(t);
    }

    function xa(e, t) {
      return 0 | e.charCodeAt(t);
    }

    function ja(e, t, n) {
      return e.slice(t, n);
    }

    function Sa(e) {
      return e.length;
    }

    function Ea(e) {
      return e.length;
    }

    function ka(e, t) {
      return t.push(e), e;
    }

    function Pa(e, t) {
      return e.map(t).join("");
    }

    var Ca = 1,
        _a = 1,
        Ra = 0,
        Na = 0,
        Da = 0,
        Ia = "";

    function La(e, t, n, r, o, i, a) {
      return {
        value: e,
        root: t,
        parent: n,
        type: r,
        props: o,
        children: i,
        line: Ca,
        column: _a,
        length: a,
        return: ""
      };
    }

    function Ma(e, t) {
      return va(La("", null, null, "", null, null, 0), e, {
        length: -e.length
      }, t);
    }

    function Ta() {
      return Da = Na < Ra ? xa(Ia, Na++) : 0, _a++, 10 === Da && (_a = 1, Ca++), Da;
    }

    function Aa() {
      return xa(Ia, Na);
    }

    function Va() {
      return Na;
    }

    function Fa(e, t) {
      return ja(Ia, e, t);
    }

    function za(e) {
      switch (e) {
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
          return 5;

        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
          return 4;

        case 58:
          return 3;

        case 34:
        case 39:
        case 40:
        case 91:
          return 2;

        case 41:
        case 93:
          return 1;
      }

      return 0;
    }

    function Ha(e) {
      return Ca = _a = 1, Ra = Sa(Ia = e), Na = 0, [];
    }

    function Ua(e) {
      return Ia = "", e;
    }

    function Ba(e) {
      return ba(Fa(Na - 1, function e(t) {
        for (; Ta();) switch (Da) {
          case t:
            return Na;

          case 34:
          case 39:
            34 !== t && 39 !== t && e(Da);
            break;

          case 40:
            41 === t && e(t);
            break;

          case 92:
            Ta();
        }

        return Na;
      }(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
    }

    function $a(e) {
      for (; (Da = Aa()) && Da < 33;) Ta();

      return za(e) > 2 || za(Da) > 3 ? "" : " ";
    }

    function qa(e, t) {
      for (; --t && Ta() && !(Da < 48 || Da > 102 || Da > 57 && Da < 65 || Da > 70 && Da < 97););

      return Fa(e, Va() + (t < 6 && 32 == Aa() && 32 == Ta()));
    }

    function Wa(e, t) {
      for (; Ta() && e + Da !== 57 && (e + Da !== 84 || 47 !== Aa()););

      return "/*" + Fa(t, Na - 1) + "*" + ga(47 === e ? e : Ta());
    }

    function Ka(e) {
      for (; !za(Aa());) Ta();

      return Fa(e, Na);
    }

    function Ya(e) {
      return Ua(function e(t, n, r, o, i, a, s, c, u) {
        var l = 0,
            p = 0,
            f = s,
            d = 0,
            h = 0,
            g = 0,
            v = 1,
            m = 1,
            b = 1,
            y = 0,
            O = "",
            w = i,
            x = a,
            j = o,
            S = O;

        for (; m;) switch (g = y, y = Ta()) {
          case 40:
            if (108 != g && 58 == xa(S, f - 1)) {
              -1 != wa(S += Oa(Ba(y), "&", "&\f"), "&\f") && (b = -1);
              break;
            }

          case 34:
          case 39:
          case 91:
            S += Ba(y);
            break;

          case 9:
          case 10:
          case 13:
          case 32:
            S += $a(g);
            break;

          case 92:
            S += qa(Va() - 1, 7);
            continue;

          case 47:
            switch (Aa()) {
              case 42:
              case 47:
                ka(Ja(Wa(Ta(), Va()), n, r), u);
                break;

              default:
                S += "/";
            }

            break;

          case 123 * v:
            c[l++] = Sa(S) * b;

          case 125 * v:
          case 59:
          case 0:
            switch (y) {
              case 0:
              case 125:
                m = 0;

              case 59 + p:
                h > 0 && Sa(S) - f && ka(h > 32 ? Xa(S + ";", o, r, f - 1) : Xa(Oa(S, " ", "") + ";", o, r, f - 2), u);
                break;

              case 59:
                S += ";";

              default:
                if (ka(j = Ga(S, n, r, l, p, i, c, O, w = [], x = [], f), a), 123 === y) if (0 === p) e(S, n, j, j, w, a, f, c, x);else switch (99 === d && 110 === xa(S, 3) ? 100 : d) {
                  case 100:
                  case 109:
                  case 115:
                    e(t, j, j, o && ka(Ga(t, j, j, 0, 0, i, c, O, i, w = [], f), x), i, x, f, c, o ? w : x);
                    break;

                  default:
                    e(S, j, j, j, [""], x, 0, c, x);
                }
            }

            l = p = h = 0, v = b = 1, O = S = "", f = s;
            break;

          case 58:
            f = 1 + Sa(S), h = g;

          default:
            if (v < 1) if (123 == y) --v;else if (125 == y && 0 == v++ && 125 == (Da = Na > 0 ? xa(Ia, --Na) : 0, _a--, 10 === Da && (_a = 1, Ca--), Da)) continue;

            switch (S += ga(y), y * v) {
              case 38:
                b = p > 0 ? 1 : (S += "\f", -1);
                break;

              case 44:
                c[l++] = (Sa(S) - 1) * b, b = 1;
                break;

              case 64:
                45 === Aa() && (S += Ba(Ta())), d = Aa(), p = f = Sa(O = S += Ka(Va())), y++;
                break;

              case 45:
                45 === g && 2 == Sa(S) && (v = 0);
            }

        }

        return a;
      }("", null, null, null, [""], e = Ha(e), 0, [0], e));
    }

    function Ga(e, t, n, r, o, i, a, s, c, u, l) {
      for (var p = o - 1, f = 0 === o ? i : [""], d = Ea(f), h = 0, g = 0, v = 0; h < r; ++h) for (var m = 0, b = ja(e, p + 1, p = ha(g = a[h])), y = e; m < d; ++m) (y = ba(g > 0 ? f[m] + " " + b : Oa(b, /&\f/g, f[m]))) && (c[v++] = y);

      return La(e, t, n, 0 === o ? pa : s, c, u, l);
    }

    function Ja(e, t, n) {
      return La(e, t, n, "comm", ga(Da), ja(e, 2, -2), 0);
    }

    function Xa(e, t, n, r) {
      return La(e, t, n, fa, ja(e, 0, r), ja(e, r + 1, -1), r);
    }

    function Za(e, t) {
      for (var n = "", r = Ea(e), o = 0; o < r; o++) n += t(e[o], o, e, t) || "";

      return n;
    }

    function Qa(e, t, n, r) {
      switch (e.type) {
        case "@import":
        case fa:
          return e.return = e.return || e.value;

        case "comm":
          return "";

        case da:
          return e.return = e.value + "{" + Za(e.children, r) + "}";

        case pa:
          e.value = e.props.join(",");
      }

      return Sa(n = Za(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
    }

    var es = function (e) {
      var t = Object.create(null);
      return function (n) {
        return void 0 === t[n] && (t[n] = e(n)), t[n];
      };
    },
        ts = function (e, t, n) {
      for (var r = 0, o = 0; r = o, o = Aa(), 38 === r && 12 === o && (t[n] = 1), !za(o);) Ta();

      return Fa(e, Na);
    },
        ns = function (e, t) {
      return Ua(function (e, t) {
        var n = -1,
            r = 44;

        do {
          switch (za(r)) {
            case 0:
              38 === r && 12 === Aa() && (t[n] = 1), e[n] += ts(Na - 1, t, n);
              break;

            case 2:
              e[n] += Ba(r);
              break;

            case 4:
              if (44 === r) {
                e[++n] = 58 === Aa() ? "&\f" : "", t[n] = e[n].length;
                break;
              }

            default:
              e[n] += ga(r);
          }
        } while (r = Ta());

        return e;
      }(Ha(e), t));
    },
        rs = new WeakMap(),
        os = function (e) {
      if ("rule" === e.type && e.parent && !(e.length < 1)) {
        for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; "rule" !== n.type;) if (!(n = n.parent)) return;

        if ((1 !== e.props.length || 58 === t.charCodeAt(0) || rs.get(n)) && !r) {
          rs.set(e, !0);

          for (var o = [], i = ns(t, o), a = n.props, s = 0, c = 0; s < i.length; s++) for (var u = 0; u < a.length; u++, c++) e.props[c] = o[s] ? i[s].replace(/&\f/g, a[u]) : a[u] + " " + i[s];
        }
      }
    },
        is = function (e) {
      if ("decl" === e.type) {
        var t = e.value;
        108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = "");
      }
    };

    var as = [function (e, t, n, r) {
      if (e.length > -1 && !e.return) switch (e.type) {
        case fa:
          e.return = function e(t, n) {
            switch (ma(t, n)) {
              case 5103:
                return la + "print-" + t + t;

              case 5737:
              case 4201:
              case 3177:
              case 3433:
              case 1641:
              case 4457:
              case 2921:
              case 5572:
              case 6356:
              case 5844:
              case 3191:
              case 6645:
              case 3005:
              case 6391:
              case 5879:
              case 5623:
              case 6135:
              case 4599:
              case 4855:
              case 4215:
              case 6389:
              case 5109:
              case 5365:
              case 5621:
              case 3829:
                return la + t + t;

              case 5349:
              case 4246:
              case 4810:
              case 6968:
              case 2756:
                return la + t + "-moz-" + t + "-ms-" + t + t;

              case 6828:
              case 4268:
                return la + t + "-ms-" + t + t;

              case 6165:
                return la + t + "-ms-flex-" + t + t;

              case 5187:
                return la + t + Oa(t, /(\w+).+(:[^]+)/, la + "box-$1$2-ms-flex-$1$2") + t;

              case 5443:
                return la + t + "-ms-flex-item-" + Oa(t, /flex-|-self/, "") + t;

              case 4675:
                return la + t + "-ms-flex-line-pack" + Oa(t, /align-content|flex-|-self/, "") + t;

              case 5548:
                return la + t + "-ms-" + Oa(t, "shrink", "negative") + t;

              case 5292:
                return la + t + "-ms-" + Oa(t, "basis", "preferred-size") + t;

              case 6060:
                return la + "box-" + Oa(t, "-grow", "") + la + t + "-ms-" + Oa(t, "grow", "positive") + t;

              case 4554:
                return la + Oa(t, /([^-])(transform)/g, "$1" + la + "$2") + t;

              case 6187:
                return Oa(Oa(Oa(t, /(zoom-|grab)/, la + "$1"), /(image-set)/, la + "$1"), t, "") + t;

              case 5495:
              case 3959:
                return Oa(t, /(image-set\([^]*)/, la + "$1$`$1");

              case 4968:
                return Oa(Oa(t, /(.+:)(flex-)?(.*)/, la + "box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + la + t + t;

              case 4095:
              case 3583:
              case 4068:
              case 2532:
                return Oa(t, /(.+)-inline(.+)/, la + "$1$2") + t;

              case 8116:
              case 7059:
              case 5753:
              case 5535:
              case 5445:
              case 5701:
              case 4933:
              case 4677:
              case 5533:
              case 5789:
              case 5021:
              case 4765:
                if (Sa(t) - 1 - n > 6) switch (xa(t, n + 1)) {
                  case 109:
                    if (45 !== xa(t, n + 4)) break;

                  case 102:
                    return Oa(t, /(.+:)(.+)-([^]+)/, "$1" + la + "$2-$3$1-moz-" + (108 == xa(t, n + 3) ? "$3" : "$2-$3")) + t;

                  case 115:
                    return ~wa(t, "stretch") ? e(Oa(t, "stretch", "fill-available"), n) + t : t;
                }
                break;

              case 4949:
                if (115 !== xa(t, n + 1)) break;

              case 6444:
                switch (xa(t, Sa(t) - 3 - (~wa(t, "!important") && 10))) {
                  case 107:
                    return Oa(t, ":", ":" + la) + t;

                  case 101:
                    return Oa(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + la + (45 === xa(t, 14) ? "inline-" : "") + "box$3$1" + la + "$2$3$1-ms-$2box$3") + t;
                }

                break;

              case 5936:
                switch (xa(t, n + 11)) {
                  case 114:
                    return la + t + "-ms-" + Oa(t, /[svh]\w+-[tblr]{2}/, "tb") + t;

                  case 108:
                    return la + t + "-ms-" + Oa(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;

                  case 45:
                    return la + t + "-ms-" + Oa(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
                }

                return la + t + "-ms-" + t + t;
            }

            return t;
          }(e.value, e.length);

          break;

        case da:
          return Za([Ma(e, {
            value: Oa(e.value, "@", "@" + la)
          })], r);

        case pa:
          if (e.length) return Pa(e.props, function (t) {
            switch (ya(t, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Za([Ma(e, {
                  props: [Oa(t, /:(read-\w+)/, ":-moz-$1")]
                })], r);

              case "::placeholder":
                return Za([Ma(e, {
                  props: [Oa(t, /:(plac\w+)/, ":" + la + "input-$1")]
                }), Ma(e, {
                  props: [Oa(t, /:(plac\w+)/, ":-moz-$1")]
                }), Ma(e, {
                  props: [Oa(t, /:(plac\w+)/, "-ms-input-$1")]
                })], r);
            }

            return "";
          });
      }
    }],
        ss = function (e) {
      var t = e.key;

      if ("css" === t) {
        var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
        Array.prototype.forEach.call(n, function (e) {
          -1 !== e.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(e), e.setAttribute("data-s", ""));
        });
      }

      var r = e.stylisPlugins || as;
      var o,
          i,
          a = {},
          s = [];
      o = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function (e) {
        for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) a[t[n]] = !0;

        s.push(e);
      });

      var c,
          u,
          l = [Qa, (u = function (e) {
        c.insert(e);
      }, function (e) {
        e.root || (e = e.return) && u(e);
      })],
          p = function (e) {
        var t = Ea(e);
        return function (n, r, o, i) {
          for (var a = "", s = 0; s < t; s++) a += e[s](n, r, o, i) || "";

          return a;
        };
      }([os, is].concat(r, l));

      i = function (e, t, n, r) {
        c = n, Za(Ya(e ? e + "{" + t.styles + "}" : t.styles), p), r && (f.inserted[t.name] = !0);
      };

      var f = {
        key: t,
        sheet: new ua({
          key: t,
          container: o,
          nonce: e.nonce,
          speedy: e.speedy,
          prepend: e.prepend,
          insertionPoint: e.insertionPoint
        }),
        nonce: e.nonce,
        inserted: a,
        registered: {},
        insert: i
      };
      return f.sheet.hydrate(s), f;
    };

    n(19);

    function cs(e, t, n) {
      var r = "";
      return n.split(" ").forEach(function (n) {
        void 0 !== e[n] ? t.push(e[n] + ";") : r += n + " ";
      }), r;
    }

    var us = function (e, t, n) {
      var r = e.key + "-" + t.name;
      !1 === n && void 0 === e.registered[r] && (e.registered[r] = t.styles);
    },
        ls = function (e, t, n) {
      us(e, t, n);
      var r = e.key + "-" + t.name;

      if (void 0 === e.inserted[t.name]) {
        var o = t;

        do {
          e.insert(t === o ? "." + r : "", o, e.sheet, !0);
          o = o.next;
        } while (void 0 !== o);
      }
    };

    var ps = function (e) {
      for (var t, n = 0, r = 0, o = e.length; o >= 4; ++r, o -= 4) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(r) | (255 & e.charCodeAt(++r)) << 8 | (255 & e.charCodeAt(++r)) << 16 | (255 & e.charCodeAt(++r)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);

      switch (o) {
        case 3:
          n ^= (255 & e.charCodeAt(r + 2)) << 16;

        case 2:
          n ^= (255 & e.charCodeAt(r + 1)) << 8;

        case 1:
          n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) + (59797 * (n >>> 16) << 16);
      }

      return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
    },
        fs = {
      animationIterationCount: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    },
        ds = /[A-Z]|^ms/g,
        hs = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
        gs = function (e) {
      return 45 === e.charCodeAt(1);
    },
        vs = function (e) {
      return null != e && "boolean" != typeof e;
    },
        ms = es(function (e) {
      return gs(e) ? e : e.replace(ds, "-$&").toLowerCase();
    }),
        bs = function (e, t) {
      switch (e) {
        case "animation":
        case "animationName":
          if ("string" == typeof t) return t.replace(hs, function (e, t, n) {
            return Os = {
              name: t,
              styles: n,
              next: Os
            }, t;
          });
      }

      return 1 === fs[e] || gs(e) || "number" != typeof t || 0 === t ? t : t + "px";
    };

    function ys(e, t, n) {
      if (null == n) return "";
      if (void 0 !== n.__emotion_styles) return n;

      switch (typeof n) {
        case "boolean":
          return "";

        case "object":
          if (1 === n.anim) return Os = {
            name: n.name,
            styles: n.styles,
            next: Os
          }, n.name;

          if (void 0 !== n.styles) {
            var r = n.next;
            if (void 0 !== r) for (; void 0 !== r;) Os = {
              name: r.name,
              styles: r.styles,
              next: Os
            }, r = r.next;
            return n.styles + ";";
          }

          return function (e, t, n) {
            var r = "";
            if (Array.isArray(n)) for (var o = 0; o < n.length; o++) r += ys(e, t, n[o]) + ";";else for (var i in n) {
              var a = n[i];
              if ("object" != typeof a) null != t && void 0 !== t[a] ? r += i + "{" + t[a] + "}" : vs(a) && (r += ms(i) + ":" + bs(i, a) + ";");else if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
                var s = ys(e, t, a);

                switch (i) {
                  case "animation":
                  case "animationName":
                    r += ms(i) + ":" + s + ";";
                    break;

                  default:
                    r += i + "{" + s + "}";
                }
              } else for (var c = 0; c < a.length; c++) vs(a[c]) && (r += ms(i) + ":" + bs(i, a[c]) + ";");
            }
            return r;
          }(e, t, n);

        case "function":
          if (void 0 !== e) {
            var o = Os,
                i = n(e);
            return Os = o, ys(e, t, i);
          }

          break;

        case "string":
      }

      if (null == t) return n;
      var a = t[n];
      return void 0 !== a ? a : n;
    }

    var Os,
        ws = /label:\s*([^\s;\n{]+)\s*(;|$)/g;

    var xs = function (e, t, n) {
      if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
      var r = !0,
          o = "";
      Os = void 0;
      var i = e[0];
      null == i || void 0 === i.raw ? (r = !1, o += ys(n, t, i)) : o += i[0];

      for (var a = 1; a < e.length; a++) o += ys(n, t, e[a]), r && (o += i[a]);

      ws.lastIndex = 0;

      for (var s, c = ""; null !== (s = ws.exec(o));) c += "-" + s[1];

      return {
        name: ps(o) + c,
        styles: o,
        next: Os
      };
    },
        js = !!o.useInsertionEffect && o.useInsertionEffect,
        Ss = js || function (e) {
      return e();
    },
        Es = (js || o.useLayoutEffect, {}.hasOwnProperty),
        ks = Object(o.createContext)("undefined" != typeof HTMLElement ? ss({
      key: "css"
    }) : null);

    ks.Provider;

    var Ps = function (e) {
      return Object(o.forwardRef)(function (t, n) {
        var r = Object(o.useContext)(ks);
        return e(t, r, n);
      });
    },
        Cs = Object(o.createContext)({});

    var _s = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
        Rs = function (e, t) {
      var n = {};

      for (var r in t) Es.call(t, r) && (n[r] = t[r]);

      return n[_s] = e, n;
    },
        Ns = function (e) {
      var t = e.cache,
          n = e.serialized,
          r = e.isStringTag;
      us(t, n, r);
      Ss(function () {
        return ls(t, n, r);
      });
      return null;
    },
        Ds = Ps(function (e, t, n) {
      var r = e.css;
      "string" == typeof r && void 0 !== t.registered[r] && (r = t.registered[r]);
      var i = e[_s],
          a = [r],
          s = "";
      "string" == typeof e.className ? s = cs(t.registered, a, e.className) : null != e.className && (s = e.className + " ");
      var c = xs(a, void 0, Object(o.useContext)(Cs));
      s += t.key + "-" + c.name;
      var u = {};

      for (var l in e) Es.call(e, l) && "css" !== l && l !== _s && (u[l] = e[l]);

      return u.ref = n, u.className = s, Object(o.createElement)(o.Fragment, null, Object(o.createElement)(Ns, {
        cache: t,
        serialized: c,
        isStringTag: "string" == typeof i
      }), Object(o.createElement)(i, u));
    });

    n(42);

    var Is = function (e, t) {
      var n = arguments;
      if (null == t || !Es.call(t, "css")) return o.createElement.apply(void 0, n);
      var r = n.length,
          i = new Array(r);
      i[0] = Ds, i[1] = Rs(e, t);

      for (var a = 2; a < r; a++) i[a] = n[a];

      return o.createElement.apply(null, i);
    };

    function Ls() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

      return xs(t);
    }

    var Ms = function e(t) {
      for (var n = t.length, r = 0, o = ""; r < n; r++) {
        var i = t[r];

        if (null != i) {
          var a = void 0;

          switch (typeof i) {
            case "boolean":
              break;

            case "object":
              if (Array.isArray(i)) a = e(i);else for (var s in a = "", i) i[s] && s && (a && (a += " "), a += s);
              break;

            default:
              a = i;
          }

          a && (o && (o += " "), o += a);
        }
      }

      return o;
    };

    function Ts(e, t, n) {
      var r = [],
          o = cs(e, r, n);
      return r.length < 2 ? n : o + t(r);
    }

    var As = function (e) {
      var t = e.cache,
          n = e.serializedArr;
      Ss(function () {
        for (var e = 0; e < n.length; e++) ls(t, n[e], !1);
      });
      return null;
    },
        Vs = Ps(function (e, t) {
      var n = [],
          r = function () {
        for (var e = arguments.length, r = new Array(e), o = 0; o < e; o++) r[o] = arguments[o];

        var i = xs(r, t.registered);
        return n.push(i), us(t, i, !1), t.key + "-" + i.name;
      },
          i = {
        css: r,
        cx: function () {
          for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) n[o] = arguments[o];

          return Ts(t.registered, r, Ms(n));
        },
        theme: Object(o.useContext)(Cs)
      },
          a = e.children(i);

      return !0, Object(o.createElement)(o.Fragment, null, Object(o.createElement)(As, {
        cache: t,
        serializedArr: n
      }), a);
    });

    function Fs(e, t) {
      if (null == e) return {};
      var n,
          r,
          o = Un(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }

      return o;
    }

    function zs(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];

      return r;
    }

    function Hs(e, t) {
      if (e) {
        if ("string" == typeof e) return zs(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? zs(e, t) : void 0;
      }
    }

    function Us(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != n) {
          var r,
              o,
              i,
              a,
              s = [],
              c = !0,
              u = !1;

          try {
            if (i = (n = n.call(e)).next, 0 === t) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
          } catch (e) {
            u = !0, o = e;
          } finally {
            try {
              if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
            } finally {
              if (u) throw o;
            }
          }

          return s;
        }
      }(e, t) || Hs(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Bs(e) {
      return (Bs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function $s(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function qs(e) {
      var t = function (e, t) {
        if ("object" !== Bs(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];

        if (void 0 !== n) {
          var r = n.call(e, t || "default");
          if ("object" !== Bs(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" === Bs(t) ? t : String(t);
    }

    function Ws(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qs(r.key), r);
      }
    }

    function Ks(e, t, n) {
      return t && Ws(e.prototype, t), n && Ws(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function Ys(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Wn(e, t);
    }

    function Gs(e, t, n) {
      return (t = qs(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Js(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function Xs(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function Zs(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Xs(Object(n), !0).forEach(function (t) {
          Js(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xs(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    function Qs(e) {
      return (Qs = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ec(e, t) {
      return !t || "object" != typeof t && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function tc(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = Qs(e);

        if (t) {
          var o = Qs(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return ec(this, n);
      };
    }

    var nc = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"],
        rc = function () {};

    function oc(e, t) {
      return t ? "-" === t[0] ? e + t : e + "__" + t : e;
    }

    function ic(e, t, n) {
      var r = [n];
      if (t && e) for (var o in t) t.hasOwnProperty(o) && t[o] && r.push("".concat(oc(e, o)));
      return r.filter(function (e) {
        return e;
      }).map(function (e) {
        return String(e).trim();
      }).join(" ");
    }

    var ac = function (e) {
      return t = e, Array.isArray(t) ? e.filter(Boolean) : "object" === Bs(e) && null !== e ? [e] : [];
      var t;
    },
        sc = function (e) {
      return e.className, e.clearValue, e.cx, e.getStyles, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, Zs({}, Fs(e, nc));
    };

    function cc(e) {
      return [document.documentElement, document.body, window].indexOf(e) > -1;
    }

    function uc(e) {
      return cc(e) ? window.pageYOffset : e.scrollTop;
    }

    function lc(e, t) {
      cc(e) ? window.scrollTo(0, t) : e.scrollTop = t;
    }

    function pc(e, t, n, r) {
      return n * ((e = e / r - 1) * e * e + 1) + t;
    }

    function fc(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200,
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : rc,
          o = uc(e),
          i = t - o,
          a = 10,
          s = 0;

      function c() {
        var t = pc(s += a, o, i, n);
        lc(e, t), s < n ? window.requestAnimationFrame(c) : r(e);
      }

      c();
    }

    function dc() {
      try {
        return document.createEvent("TouchEvent"), !0;
      } catch (e) {
        return !1;
      }
    }

    var hc = !1,
        gc = {
      get passive() {
        return hc = !0;
      }

    },
        vc = "undefined" != typeof window ? window : {};
    vc.addEventListener && vc.removeEventListener && (vc.addEventListener("p", rc, gc), vc.removeEventListener("p", rc, !1));
    var mc = hc;

    function bc(e) {
      return null != e;
    }

    function yc(e, t, n) {
      return e ? t : n;
    }

    function Oc(e) {
      var t = e.maxHeight,
          n = e.menuEl,
          r = e.minHeight,
          o = e.placement,
          i = e.shouldScroll,
          a = e.isFixedPosition,
          s = e.theme.spacing,
          c = function (e) {
        var t = getComputedStyle(e),
            n = "absolute" === t.position,
            r = /(auto|scroll)/;
        if ("fixed" === t.position) return document.documentElement;

        for (var o = e; o = o.parentElement;) if (t = getComputedStyle(o), (!n || "static" !== t.position) && r.test(t.overflow + t.overflowY + t.overflowX)) return o;

        return document.documentElement;
      }(n),
          u = {
        placement: "bottom",
        maxHeight: t
      };

      if (!n || !n.offsetParent) return u;
      var l,
          p = c.getBoundingClientRect().height,
          f = n.getBoundingClientRect(),
          d = f.bottom,
          h = f.height,
          g = f.top,
          v = n.offsetParent.getBoundingClientRect().top,
          m = a ? window.innerHeight : cc(l = c) ? window.innerHeight : l.clientHeight,
          b = uc(c),
          y = parseInt(getComputedStyle(n).marginBottom, 10),
          O = parseInt(getComputedStyle(n).marginTop, 10),
          w = v - O,
          x = m - g,
          j = w + b,
          S = p - b - g,
          E = d - m + b + y,
          k = b + g - O;

      switch (o) {
        case "auto":
        case "bottom":
          if (x >= h) return {
            placement: "bottom",
            maxHeight: t
          };
          if (S >= h && !a) return i && fc(c, E, 160), {
            placement: "bottom",
            maxHeight: t
          };
          if (!a && S >= r || a && x >= r) return i && fc(c, E, 160), {
            placement: "bottom",
            maxHeight: a ? x - y : S - y
          };

          if ("auto" === o || a) {
            var P = t,
                C = a ? w : j;
            return C >= r && (P = Math.min(C - y - s.controlHeight, t)), {
              placement: "top",
              maxHeight: P
            };
          }

          if ("bottom" === o) return i && lc(c, E), {
            placement: "bottom",
            maxHeight: t
          };
          break;

        case "top":
          if (w >= h) return {
            placement: "top",
            maxHeight: t
          };
          if (j >= h && !a) return i && fc(c, k, 160), {
            placement: "top",
            maxHeight: t
          };

          if (!a && j >= r || a && w >= r) {
            var _ = t;
            return (!a && j >= r || a && w >= r) && (_ = a ? w - O : j - O), i && fc(c, k, 160), {
              placement: "top",
              maxHeight: _
            };
          }

          return {
            placement: "bottom",
            maxHeight: t
          };

        default:
          throw new Error('Invalid placement provided "'.concat(o, '".'));
      }

      return u;
    }

    var wc = function (e) {
      return "auto" === e ? "bottom" : e;
    },
        xc = Object(o.createContext)({
      getPortalPlacement: null
    }),
        jc = function (e) {
      Ys(n, e);
      var t = tc(n);

      function n() {
        var e;
        $s(this, n);

        for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];

        return (e = t.call.apply(t, [this].concat(o))).state = {
          maxHeight: e.props.maxMenuHeight,
          placement: null
        }, e.context = void 0, e.getPlacement = function (t) {
          var n = e.props,
              r = n.minMenuHeight,
              o = n.maxMenuHeight,
              i = n.menuPlacement,
              a = n.menuPosition,
              s = n.menuShouldScrollIntoView,
              c = n.theme;

          if (t) {
            var u = "fixed" === a,
                l = Oc({
              maxHeight: o,
              menuEl: t,
              minHeight: r,
              placement: i,
              shouldScroll: s && !u,
              isFixedPosition: u,
              theme: c
            }),
                p = e.context.getPortalPlacement;
            p && p(l), e.setState(l);
          }
        }, e.getUpdatedProps = function () {
          var t = e.props.menuPlacement,
              n = e.state.placement || wc(t);
          return Zs(Zs({}, e.props), {}, {
            placement: n,
            maxHeight: e.state.maxHeight
          });
        }, e;
      }

      return Ks(n, [{
        key: "render",
        value: function () {
          return (0, this.props.children)({
            ref: this.getPlacement,
            placerProps: this.getUpdatedProps()
          });
        }
      }]), n;
    }(o.Component);

    jc.contextType = xc;

    var Sc = function (e) {
      var t = e.theme,
          n = t.spacing.baseUnit;
      return {
        color: t.colors.neutral40,
        padding: "".concat(2 * n, "px ").concat(3 * n, "px"),
        textAlign: "center"
      };
    },
        Ec = Sc,
        kc = Sc,
        Pc = function (e) {
      var t = e.children,
          n = e.className,
          r = e.cx,
          o = e.getStyles,
          i = e.innerProps;
      return Is("div", Hn({
        css: o("noOptionsMessage", e),
        className: r({
          "menu-notice": !0,
          "menu-notice--no-options": !0
        }, n)
      }, i), t);
    };

    Pc.defaultProps = {
      children: "No options"
    };

    var Cc = function (e) {
      var t = e.children,
          n = e.className,
          r = e.cx,
          o = e.getStyles,
          i = e.innerProps;
      return Is("div", Hn({
        css: o("loadingMessage", e),
        className: r({
          "menu-notice": !0,
          "menu-notice--loading": !0
        }, n)
      }, i), t);
    };

    Cc.defaultProps = {
      children: "Loading..."
    };

    var _c,
        Rc = function (e) {
      Ys(n, e);
      var t = tc(n);

      function n() {
        var e;
        $s(this, n);

        for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];

        return (e = t.call.apply(t, [this].concat(o))).state = {
          placement: null
        }, e.getPortalPlacement = function (t) {
          var n = t.placement;
          n !== wc(e.props.menuPlacement) && e.setState({
            placement: n
          });
        }, e;
      }

      return Ks(n, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.appendTo,
              n = e.children,
              r = e.className,
              o = e.controlElement,
              i = e.cx,
              a = e.innerProps,
              s = e.menuPlacement,
              c = e.menuPosition,
              u = e.getStyles,
              l = "fixed" === c;
          if (!t && !l || !o) return null;

          var p = this.state.placement || wc(s),
              f = function (e) {
            var t = e.getBoundingClientRect();
            return {
              bottom: t.bottom,
              height: t.height,
              left: t.left,
              right: t.right,
              top: t.top,
              width: t.width
            };
          }(o),
              d = l ? 0 : window.pageYOffset,
              h = f[p] + d,
              g = Is("div", Hn({
            css: u("menuPortal", {
              offset: h,
              position: c,
              rect: f
            }),
            className: i({
              "menu-portal": !0
            }, r)
          }, a), n);

          return Is(xc.Provider, {
            value: {
              getPortalPlacement: this.getPortalPlacement
            }
          }, t ? Object(tr.createPortal)(g, t) : g);
        }
      }]), n;
    }(o.Component),
        Nc = ["size"];

    var Dc,
        Ic,
        Lc = {
      name: "8mmkcg",
      styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    },
        Mc = function (e) {
      var t = e.size,
          n = Fs(e, Nc);
      return Is("svg", Hn({
        height: t,
        width: t,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: Lc
      }, n));
    },
        Tc = function (e) {
      return Is(Mc, Hn({
        size: 20
      }, e), Is("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
      }));
    },
        Ac = function (e) {
      return Is(Mc, Hn({
        size: 20
      }, e), Is("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
      }));
    },
        Vc = function (e) {
      var t = e.isFocused,
          n = e.theme,
          r = n.spacing.baseUnit,
          o = n.colors;
      return {
        label: "indicatorContainer",
        color: t ? o.neutral60 : o.neutral20,
        display: "flex",
        padding: 2 * r,
        transition: "color 150ms",
        ":hover": {
          color: t ? o.neutral80 : o.neutral40
        }
      };
    },
        Fc = Vc,
        zc = Vc,
        Hc = function () {
      var e = Ls.apply(void 0, arguments),
          t = "animation-" + e.name;
      return {
        name: t,
        styles: "@keyframes " + t + "{" + e.styles + "}",
        anim: 1,
        toString: function () {
          return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
      };
    }(_c || (Dc = ["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"], Ic || (Ic = Dc.slice(0)), _c = Object.freeze(Object.defineProperties(Dc, {
      raw: {
        value: Object.freeze(Ic)
      }
    })))),
        Uc = function (e) {
      var t = e.delay,
          n = e.offset;
      return Is("span", {
        css: Ls({
          animation: "".concat(Hc, " 1s ease-in-out ").concat(t, "ms infinite;"),
          backgroundColor: "currentColor",
          borderRadius: "1em",
          display: "inline-block",
          marginLeft: n ? "1em" : void 0,
          height: "1em",
          verticalAlign: "top",
          width: "1em"
        }, "", "")
      });
    },
        Bc = function (e) {
      var t = e.className,
          n = e.cx,
          r = e.getStyles,
          o = e.innerProps,
          i = e.isRtl;
      return Is("div", Hn({
        css: r("loadingIndicator", e),
        className: n({
          indicator: !0,
          "loading-indicator": !0
        }, t)
      }, o), Is(Uc, {
        delay: 0,
        offset: i
      }), Is(Uc, {
        delay: 160,
        offset: !0
      }), Is(Uc, {
        delay: 320,
        offset: !i
      }));
    };

    Bc.defaultProps = {
      size: 4
    };

    var $c = ["data"],
        qc = ["innerRef", "isDisabled", "isHidden", "inputClassName"],
        Wc = {
      gridArea: "1 / 2",
      font: "inherit",
      minWidth: "2px",
      border: 0,
      margin: 0,
      outline: 0,
      padding: 0
    },
        Kc = {
      flex: "1 1 auto",
      display: "inline-grid",
      gridArea: "1 / 1 / 2 / 3",
      gridTemplateColumns: "0 min-content",
      "&:after": Zs({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
      }, Wc)
    },
        Yc = function (e) {
      return Zs({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: e ? 0 : 1,
        width: "100%"
      }, Wc);
    },
        Gc = function (e) {
      var t = e.children,
          n = e.innerProps;
      return Is("div", n, t);
    };

    var Jc = {
      ClearIndicator: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.innerProps;
        return Is("div", Hn({
          css: o("clearIndicator", e),
          className: r({
            indicator: !0,
            "clear-indicator": !0
          }, n)
        }, i), t || Is(Tc, null));
      },
      Control: function (e) {
        var t = e.children,
            n = e.cx,
            r = e.getStyles,
            o = e.className,
            i = e.isDisabled,
            a = e.isFocused,
            s = e.innerRef,
            c = e.innerProps,
            u = e.menuIsOpen;
        return Is("div", Hn({
          ref: s,
          css: r("control", e),
          className: n({
            control: !0,
            "control--is-disabled": i,
            "control--is-focused": a,
            "control--menu-is-open": u
          }, o)
        }, c), t);
      },
      DropdownIndicator: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.innerProps;
        return Is("div", Hn({
          css: o("dropdownIndicator", e),
          className: r({
            indicator: !0,
            "dropdown-indicator": !0
          }, n)
        }, i), t || Is(Ac, null));
      },
      DownChevron: Ac,
      CrossIcon: Tc,
      Group: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.Heading,
            a = e.headingProps,
            s = e.innerProps,
            c = e.label,
            u = e.theme,
            l = e.selectProps;
        return Is("div", Hn({
          css: o("group", e),
          className: r({
            group: !0
          }, n)
        }, s), Is(i, Hn({}, a, {
          selectProps: l,
          theme: u,
          getStyles: o,
          cx: r
        }), c), Is("div", null, t));
      },
      GroupHeading: function (e) {
        var t = e.getStyles,
            n = e.cx,
            r = e.className,
            o = sc(e);
        o.data;
        var i = Fs(o, $c);
        return Is("div", Hn({
          css: t("groupHeading", e),
          className: n({
            "group-heading": !0
          }, r)
        }, i));
      },
      IndicatorsContainer: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.innerProps,
            i = e.getStyles;
        return Is("div", Hn({
          css: i("indicatorsContainer", e),
          className: r({
            indicators: !0
          }, n)
        }, o), t);
      },
      IndicatorSeparator: function (e) {
        var t = e.className,
            n = e.cx,
            r = e.getStyles,
            o = e.innerProps;
        return Is("span", Hn({}, o, {
          css: r("indicatorSeparator", e),
          className: n({
            "indicator-separator": !0
          }, t)
        }));
      },
      Input: function (e) {
        var t = e.className,
            n = e.cx,
            r = e.getStyles,
            o = e.value,
            i = sc(e),
            a = i.innerRef,
            s = i.isDisabled,
            c = i.isHidden,
            u = i.inputClassName,
            l = Fs(i, qc);
        return Is("div", {
          className: n({
            "input-container": !0
          }, t),
          css: r("input", e),
          "data-value": o || ""
        }, Is("input", Hn({
          className: n({
            input: !0
          }, u),
          ref: a,
          style: Yc(c),
          disabled: s
        }, l)));
      },
      LoadingIndicator: Bc,
      Menu: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.innerRef,
            a = e.innerProps;
        return Is("div", Hn({
          css: o("menu", e),
          className: r({
            menu: !0
          }, n),
          ref: i
        }, a), t);
      },
      MenuList: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.innerProps,
            a = e.innerRef,
            s = e.isMulti;
        return Is("div", Hn({
          css: o("menuList", e),
          className: r({
            "menu-list": !0,
            "menu-list--is-multi": s
          }, n),
          ref: a
        }, i), t);
      },
      MenuPortal: Rc,
      LoadingMessage: Cc,
      NoOptionsMessage: Pc,
      MultiValue: function (e) {
        var t = e.children,
            n = e.className,
            r = e.components,
            o = e.cx,
            i = e.data,
            a = e.getStyles,
            s = e.innerProps,
            c = e.isDisabled,
            u = e.removeProps,
            l = e.selectProps,
            p = r.Container,
            f = r.Label,
            d = r.Remove;
        return Is(Vs, null, function (r) {
          var h = r.css,
              g = r.cx;
          return Is(p, {
            data: i,
            innerProps: Zs({
              className: g(h(a("multiValue", e)), o({
                "multi-value": !0,
                "multi-value--is-disabled": c
              }, n))
            }, s),
            selectProps: l
          }, Is(f, {
            data: i,
            innerProps: {
              className: g(h(a("multiValueLabel", e)), o({
                "multi-value__label": !0
              }, n))
            },
            selectProps: l
          }, t), Is(d, {
            data: i,
            innerProps: Zs({
              className: g(h(a("multiValueRemove", e)), o({
                "multi-value__remove": !0
              }, n)),
              "aria-label": "Remove ".concat(t || "option")
            }, u),
            selectProps: l
          }));
        });
      },
      MultiValueContainer: Gc,
      MultiValueLabel: Gc,
      MultiValueRemove: function (e) {
        var t = e.children,
            n = e.innerProps;
        return Is("div", Hn({
          role: "button"
        }, n), t || Is(Tc, {
          size: 14
        }));
      },
      Option: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.isDisabled,
            a = e.isFocused,
            s = e.isSelected,
            c = e.innerRef,
            u = e.innerProps;
        return Is("div", Hn({
          css: o("option", e),
          className: r({
            option: !0,
            "option--is-disabled": i,
            "option--is-focused": a,
            "option--is-selected": s
          }, n),
          ref: c,
          "aria-disabled": i
        }, u), t);
      },
      Placeholder: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.innerProps;
        return Is("div", Hn({
          css: o("placeholder", e),
          className: r({
            placeholder: !0
          }, n)
        }, i), t);
      },
      SelectContainer: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.innerProps,
            a = e.isDisabled,
            s = e.isRtl;
        return Is("div", Hn({
          css: o("container", e),
          className: r({
            "--is-disabled": a,
            "--is-rtl": s
          }, n)
        }, i), t);
      },
      SingleValue: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.getStyles,
            i = e.isDisabled,
            a = e.innerProps;
        return Is("div", Hn({
          css: o("singleValue", e),
          className: r({
            "single-value": !0,
            "single-value--is-disabled": i
          }, n)
        }, a), t);
      },
      ValueContainer: function (e) {
        var t = e.children,
            n = e.className,
            r = e.cx,
            o = e.innerProps,
            i = e.isMulti,
            a = e.getStyles,
            s = e.hasValue;
        return Is("div", Hn({
          css: a("valueContainer", e),
          className: r({
            "value-container": !0,
            "value-container--is-multi": i,
            "value-container--has-value": s
          }, n)
        }, o), t);
      }
    };

    function Xc(e) {
      return function (e) {
        if (Array.isArray(e)) return zs(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || Hs(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    var Zc = Number.isNaN || function (e) {
      return "number" == typeof e && e != e;
    };

    function Qc(e, t) {
      if (e.length !== t.length) return !1;

      for (var n = 0; n < e.length; n++) if (r = e[n], o = t[n], !(r === o || Zc(r) && Zc(o))) return !1;

      var r, o;
      return !0;
    }

    var eu = function (e, t) {
      var n;
      void 0 === t && (t = Qc);
      var r,
          o = [],
          i = !1;
      return function () {
        for (var a = [], s = 0; s < arguments.length; s++) a[s] = arguments[s];

        return i && n === this && t(a, o) || (r = e.apply(this, a), i = !0, n = this, o = a), r;
      };
    };

    for (var tu = {
      name: "7pg0cj-a11yText",
      styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
    }, nu = function (e) {
      return Is("span", Hn({
        css: tu
      }, e));
    }, ru = {
      guidance: function (e) {
        var t = e.isSearchable,
            n = e.isMulti,
            r = e.isDisabled,
            o = e.tabSelectsValue;

        switch (e.context) {
          case "menu":
            return "Use Up and Down to choose options".concat(r ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(o ? ", press Tab to select the option and exit the menu" : "", ".");

          case "input":
            return "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "");

          case "value":
            return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";

          default:
            return "";
        }
      },
      onChange: function (e) {
        var t = e.action,
            n = e.label,
            r = void 0 === n ? "" : n,
            o = e.labels,
            i = e.isDisabled;

        switch (t) {
          case "deselect-option":
          case "pop-value":
          case "remove-value":
            return "option ".concat(r, ", deselected.");

          case "clear":
            return "All selected options have been cleared.";

          case "initial-input-focus":
            return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");

          case "select-option":
            return "option ".concat(r, i ? " is disabled. Select another option." : ", selected.");

          default:
            return "";
        }
      },
      onFocus: function (e) {
        var t = e.context,
            n = e.focused,
            r = e.options,
            o = e.label,
            i = void 0 === o ? "" : o,
            a = e.selectValue,
            s = e.isDisabled,
            c = e.isSelected,
            u = function (e, t) {
          return e && e.length ? "".concat(e.indexOf(t) + 1, " of ").concat(e.length) : "";
        };

        if ("value" === t && a) return "value ".concat(i, " focused, ").concat(u(a, n), ".");

        if ("menu" === t) {
          var l = s ? " disabled" : "",
              p = "".concat(c ? "selected" : "focused").concat(l);
          return "option ".concat(i, " ").concat(p, ", ").concat(u(r, n), ".");
        }

        return "";
      },
      onFilter: function (e) {
        var t = e.inputValue,
            n = e.resultsMessage;
        return "".concat(n).concat(t ? " for search term " + t : "", ".");
      }
    }, ou = function (e) {
      var t = e.ariaSelection,
          n = e.focusedOption,
          r = e.focusedValue,
          i = e.focusableOptions,
          a = e.isFocused,
          s = e.selectValue,
          c = e.selectProps,
          u = e.id,
          l = c.ariaLiveMessages,
          p = c.getOptionLabel,
          f = c.inputValue,
          d = c.isMulti,
          h = c.isOptionDisabled,
          g = c.isSearchable,
          v = c.menuIsOpen,
          m = c.options,
          b = c.screenReaderStatus,
          y = c.tabSelectsValue,
          O = c["aria-label"],
          w = c["aria-live"],
          x = Object(o.useMemo)(function () {
        return Zs(Zs({}, ru), l || {});
      }, [l]),
          j = Object(o.useMemo)(function () {
        var e,
            n = "";

        if (t && x.onChange) {
          var r = t.option,
              o = t.options,
              i = t.removedValue,
              a = t.removedValues,
              c = t.value,
              u = i || r || (e = c, Array.isArray(e) ? null : e),
              l = u ? p(u) : "",
              f = o || a || void 0,
              d = f ? f.map(p) : [],
              g = Zs({
            isDisabled: u && h(u, s),
            label: l,
            labels: d
          }, t);
          n = x.onChange(g);
        }

        return n;
      }, [t, x, h, s, p]),
          S = Object(o.useMemo)(function () {
        var e = "",
            t = n || r,
            o = !!(n && s && s.includes(n));

        if (t && x.onFocus) {
          var i = {
            focused: t,
            label: p(t),
            isDisabled: h(t, s),
            isSelected: o,
            options: m,
            context: t === n ? "menu" : "value",
            selectValue: s
          };
          e = x.onFocus(i);
        }

        return e;
      }, [n, r, p, h, x, m, s]),
          E = Object(o.useMemo)(function () {
        var e = "";

        if (v && m.length && x.onFilter) {
          var t = b({
            count: i.length
          });
          e = x.onFilter({
            inputValue: f,
            resultsMessage: t
          });
        }

        return e;
      }, [i, f, v, x, m, b]),
          k = Object(o.useMemo)(function () {
        var e = "";

        if (x.guidance) {
          var t = r ? "value" : v ? "menu" : "input";
          e = x.guidance({
            "aria-label": O,
            context: t,
            isDisabled: n && h(n, s),
            isMulti: d,
            isSearchable: g,
            tabSelectsValue: y
          });
        }

        return e;
      }, [O, n, r, d, h, g, v, x, s, y]),
          P = "".concat(S, " ").concat(E, " ").concat(k),
          C = Is(o.Fragment, null, Is("span", {
        id: "aria-selection"
      }, j), Is("span", {
        id: "aria-context"
      }, P)),
          _ = "initial-input-focus" === (null == t ? void 0 : t.action);

      return Is(o.Fragment, null, Is(nu, {
        id: u
      }, _ && C), Is(nu, {
        "aria-live": w,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
      }, a && !_ && C));
    }, iu = [{
      base: "A",
      letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
    }, {
      base: "AA",
      letters: "Ꜳ"
    }, {
      base: "AE",
      letters: "ÆǼǢ"
    }, {
      base: "AO",
      letters: "Ꜵ"
    }, {
      base: "AU",
      letters: "Ꜷ"
    }, {
      base: "AV",
      letters: "ꜸꜺ"
    }, {
      base: "AY",
      letters: "Ꜽ"
    }, {
      base: "B",
      letters: "BⒷＢḂḄḆɃƂƁ"
    }, {
      base: "C",
      letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
    }, {
      base: "D",
      letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
    }, {
      base: "DZ",
      letters: "ǱǄ"
    }, {
      base: "Dz",
      letters: "ǲǅ"
    }, {
      base: "E",
      letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
    }, {
      base: "F",
      letters: "FⒻＦḞƑꝻ"
    }, {
      base: "G",
      letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
    }, {
      base: "H",
      letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    }, {
      base: "I",
      letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
    }, {
      base: "J",
      letters: "JⒿＪĴɈ"
    }, {
      base: "K",
      letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    }, {
      base: "L",
      letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    }, {
      base: "LJ",
      letters: "Ǉ"
    }, {
      base: "Lj",
      letters: "ǈ"
    }, {
      base: "M",
      letters: "MⓂＭḾṀṂⱮƜ"
    }, {
      base: "N",
      letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
    }, {
      base: "NJ",
      letters: "Ǌ"
    }, {
      base: "Nj",
      letters: "ǋ"
    }, {
      base: "O",
      letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
    }, {
      base: "OI",
      letters: "Ƣ"
    }, {
      base: "OO",
      letters: "Ꝏ"
    }, {
      base: "OU",
      letters: "Ȣ"
    }, {
      base: "P",
      letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
    }, {
      base: "Q",
      letters: "QⓆＱꝖꝘɊ"
    }, {
      base: "R",
      letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    }, {
      base: "S",
      letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    }, {
      base: "T",
      letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    }, {
      base: "TZ",
      letters: "Ꜩ"
    }, {
      base: "U",
      letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    }, {
      base: "V",
      letters: "VⓋＶṼṾƲꝞɅ"
    }, {
      base: "VY",
      letters: "Ꝡ"
    }, {
      base: "W",
      letters: "WⓌＷẀẂŴẆẄẈⱲ"
    }, {
      base: "X",
      letters: "XⓍＸẊẌ"
    }, {
      base: "Y",
      letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
    }, {
      base: "Z",
      letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    }, {
      base: "a",
      letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
    }, {
      base: "aa",
      letters: "ꜳ"
    }, {
      base: "ae",
      letters: "æǽǣ"
    }, {
      base: "ao",
      letters: "ꜵ"
    }, {
      base: "au",
      letters: "ꜷ"
    }, {
      base: "av",
      letters: "ꜹꜻ"
    }, {
      base: "ay",
      letters: "ꜽ"
    }, {
      base: "b",
      letters: "bⓑｂḃḅḇƀƃɓ"
    }, {
      base: "c",
      letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
    }, {
      base: "d",
      letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
    }, {
      base: "dz",
      letters: "ǳǆ"
    }, {
      base: "e",
      letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
    }, {
      base: "f",
      letters: "fⓕｆḟƒꝼ"
    }, {
      base: "g",
      letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
    }, {
      base: "h",
      letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    }, {
      base: "hv",
      letters: "ƕ"
    }, {
      base: "i",
      letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
    }, {
      base: "j",
      letters: "jⓙｊĵǰɉ"
    }, {
      base: "k",
      letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    }, {
      base: "l",
      letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
    }, {
      base: "lj",
      letters: "ǉ"
    }, {
      base: "m",
      letters: "mⓜｍḿṁṃɱɯ"
    }, {
      base: "n",
      letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
    }, {
      base: "nj",
      letters: "ǌ"
    }, {
      base: "o",
      letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
    }, {
      base: "oi",
      letters: "ƣ"
    }, {
      base: "ou",
      letters: "ȣ"
    }, {
      base: "oo",
      letters: "ꝏ"
    }, {
      base: "p",
      letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
    }, {
      base: "q",
      letters: "qⓠｑɋꝗꝙ"
    }, {
      base: "r",
      letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    }, {
      base: "s",
      letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
    }, {
      base: "t",
      letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    }, {
      base: "tz",
      letters: "ꜩ"
    }, {
      base: "u",
      letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    }, {
      base: "v",
      letters: "vⓥｖṽṿʋꝟʌ"
    }, {
      base: "vy",
      letters: "ꝡ"
    }, {
      base: "w",
      letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
    }, {
      base: "x",
      letters: "xⓧｘẋẍ"
    }, {
      base: "y",
      letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
    }, {
      base: "z",
      letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }], au = new RegExp("[" + iu.map(function (e) {
      return e.letters;
    }).join("") + "]", "g"), su = {}, cu = 0; cu < iu.length; cu++) for (var uu = iu[cu], lu = 0; lu < uu.letters.length; lu++) su[uu.letters[lu]] = uu.base;

    var pu = function (e) {
      return e.replace(au, function (e) {
        return su[e];
      });
    },
        fu = eu(pu),
        du = function (e) {
      return e.replace(/^\s+|\s+$/g, "");
    },
        hu = function (e) {
      return "".concat(e.label, " ").concat(e.value);
    },
        gu = ["innerRef"];

    function vu(e) {
      var t = e.innerRef,
          n = function (e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];

        var o = Object.entries(e).filter(function (e) {
          var t = Us(e, 1)[0];
          return !n.includes(t);
        });
        return o.reduce(function (e, t) {
          var n = Us(t, 2),
              r = n[0],
              o = n[1];
          return e[r] = o, e;
        }, {});
      }(Fs(e, gu), "onExited", "in", "enter", "exit", "appear");

      return Is("input", Hn({
        ref: t
      }, n, {
        css: Ls({
          label: "dummyInput",
          background: 0,
          border: 0,
          caretColor: "transparent",
          fontSize: "inherit",
          gridArea: "1 / 1 / 2 / 3",
          outline: 0,
          padding: 0,
          width: 1,
          color: "transparent",
          left: -100,
          opacity: 0,
          position: "relative",
          transform: "scale(.01)"
        }, "", "")
      }));
    }

    var mu = ["boxSizing", "height", "overflow", "paddingRight", "position"],
        bu = {
      boxSizing: "border-box",
      overflow: "hidden",
      position: "relative",
      height: "100%"
    };

    function yu(e) {
      e.preventDefault();
    }

    function Ou(e) {
      e.stopPropagation();
    }

    function wu() {
      var e = this.scrollTop,
          t = this.scrollHeight,
          n = e + this.offsetHeight;
      0 === e ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
    }

    function xu() {
      return "ontouchstart" in window || navigator.maxTouchPoints;
    }

    var ju = !("undefined" == typeof window || !window.document || !window.document.createElement),
        Su = 0,
        Eu = {
      capture: !1,
      passive: !1
    };

    var ku = function () {
      return document.activeElement && document.activeElement.blur();
    },
        Pu = {
      name: "1kfdb0e",
      styles: "position:fixed;left:0;bottom:0;right:0;top:0"
    };

    function Cu(e) {
      var t = e.children,
          n = e.lockEnabled,
          r = e.captureEnabled,
          i = function (e) {
        var t = e.isEnabled,
            n = e.onBottomArrive,
            r = e.onBottomLeave,
            i = e.onTopArrive,
            a = e.onTopLeave,
            s = Object(o.useRef)(!1),
            c = Object(o.useRef)(!1),
            u = Object(o.useRef)(0),
            l = Object(o.useRef)(null),
            p = Object(o.useCallback)(function (e, t) {
          if (null !== l.current) {
            var o = l.current,
                u = o.scrollTop,
                p = o.scrollHeight,
                f = o.clientHeight,
                d = l.current,
                h = t > 0,
                g = p - f - u,
                v = !1;
            g > t && s.current && (r && r(e), s.current = !1), h && c.current && (a && a(e), c.current = !1), h && t > g ? (n && !s.current && n(e), d.scrollTop = p, v = !0, s.current = !0) : !h && -t > u && (i && !c.current && i(e), d.scrollTop = 0, v = !0, c.current = !0), v && function (e) {
              e.preventDefault(), e.stopPropagation();
            }(e);
          }
        }, [n, r, i, a]),
            f = Object(o.useCallback)(function (e) {
          p(e, e.deltaY);
        }, [p]),
            d = Object(o.useCallback)(function (e) {
          u.current = e.changedTouches[0].clientY;
        }, []),
            h = Object(o.useCallback)(function (e) {
          var t = u.current - e.changedTouches[0].clientY;
          p(e, t);
        }, [p]),
            g = Object(o.useCallback)(function (e) {
          if (e) {
            var t = !!mc && {
              passive: !1
            };
            e.addEventListener("wheel", f, t), e.addEventListener("touchstart", d, t), e.addEventListener("touchmove", h, t);
          }
        }, [h, d, f]),
            v = Object(o.useCallback)(function (e) {
          e && (e.removeEventListener("wheel", f, !1), e.removeEventListener("touchstart", d, !1), e.removeEventListener("touchmove", h, !1));
        }, [h, d, f]);
        return Object(o.useEffect)(function () {
          if (t) {
            var e = l.current;
            return g(e), function () {
              v(e);
            };
          }
        }, [t, g, v]), function (e) {
          l.current = e;
        };
      }({
        isEnabled: void 0 === r || r,
        onBottomArrive: e.onBottomArrive,
        onBottomLeave: e.onBottomLeave,
        onTopArrive: e.onTopArrive,
        onTopLeave: e.onTopLeave
      }),
          a = function (e) {
        var t = e.isEnabled,
            n = e.accountForScrollbars,
            r = void 0 === n || n,
            i = Object(o.useRef)({}),
            a = Object(o.useRef)(null),
            s = Object(o.useCallback)(function (e) {
          if (ju) {
            var t = document.body,
                n = t && t.style;

            if (r && mu.forEach(function (e) {
              var t = n && n[e];
              i.current[e] = t;
            }), r && Su < 1) {
              var o = parseInt(i.current.paddingRight, 10) || 0,
                  a = document.body ? document.body.clientWidth : 0,
                  s = window.innerWidth - a + o || 0;
              Object.keys(bu).forEach(function (e) {
                var t = bu[e];
                n && (n[e] = t);
              }), n && (n.paddingRight = "".concat(s, "px"));
            }

            t && xu() && (t.addEventListener("touchmove", yu, Eu), e && (e.addEventListener("touchstart", wu, Eu), e.addEventListener("touchmove", Ou, Eu))), Su += 1;
          }
        }, [r]),
            c = Object(o.useCallback)(function (e) {
          if (ju) {
            var t = document.body,
                n = t && t.style;
            Su = Math.max(Su - 1, 0), r && Su < 1 && mu.forEach(function (e) {
              var t = i.current[e];
              n && (n[e] = t);
            }), t && xu() && (t.removeEventListener("touchmove", yu, Eu), e && (e.removeEventListener("touchstart", wu, Eu), e.removeEventListener("touchmove", Ou, Eu)));
          }
        }, [r]);
        return Object(o.useEffect)(function () {
          if (t) {
            var e = a.current;
            return s(e), function () {
              c(e);
            };
          }
        }, [t, s, c]), function (e) {
          a.current = e;
        };
      }({
        isEnabled: n
      });

      return Is(o.Fragment, null, n && Is("div", {
        onClick: ku,
        css: Pu
      }), t(function (e) {
        i(e), a(e);
      }));
    }

    var _u = {
      clearIndicator: zc,
      container: function (e) {
        var t = e.isDisabled;
        return {
          label: "container",
          direction: e.isRtl ? "rtl" : void 0,
          pointerEvents: t ? "none" : void 0,
          position: "relative"
        };
      },
      control: function (e) {
        var t = e.isDisabled,
            n = e.isFocused,
            r = e.theme,
            o = r.colors,
            i = r.borderRadius,
            a = r.spacing;
        return {
          label: "control",
          alignItems: "center",
          backgroundColor: t ? o.neutral5 : o.neutral0,
          borderColor: t ? o.neutral10 : n ? o.primary : o.neutral20,
          borderRadius: i,
          borderStyle: "solid",
          borderWidth: 1,
          boxShadow: n ? "0 0 0 1px ".concat(o.primary) : void 0,
          cursor: "default",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          minHeight: a.controlHeight,
          outline: "0 !important",
          position: "relative",
          transition: "all 100ms",
          "&:hover": {
            borderColor: n ? o.primary : o.neutral30
          }
        };
      },
      dropdownIndicator: Fc,
      group: function (e) {
        var t = e.theme.spacing;
        return {
          paddingBottom: 2 * t.baseUnit,
          paddingTop: 2 * t.baseUnit
        };
      },
      groupHeading: function (e) {
        var t = e.theme.spacing;
        return {
          label: "group",
          color: "#999",
          cursor: "default",
          display: "block",
          fontSize: "75%",
          fontWeight: 500,
          marginBottom: "0.25em",
          paddingLeft: 3 * t.baseUnit,
          paddingRight: 3 * t.baseUnit,
          textTransform: "uppercase"
        };
      },
      indicatorsContainer: function () {
        return {
          alignItems: "center",
          alignSelf: "stretch",
          display: "flex",
          flexShrink: 0
        };
      },
      indicatorSeparator: function (e) {
        var t = e.isDisabled,
            n = e.theme,
            r = n.spacing.baseUnit,
            o = n.colors;
        return {
          label: "indicatorSeparator",
          alignSelf: "stretch",
          backgroundColor: t ? o.neutral10 : o.neutral20,
          marginBottom: 2 * r,
          marginTop: 2 * r,
          width: 1
        };
      },
      input: function (e) {
        var t = e.isDisabled,
            n = e.value,
            r = e.theme,
            o = r.spacing,
            i = r.colors;
        return Zs({
          margin: o.baseUnit / 2,
          paddingBottom: o.baseUnit / 2,
          paddingTop: o.baseUnit / 2,
          visibility: t ? "hidden" : "visible",
          color: i.neutral80,
          transform: n ? "translateZ(0)" : ""
        }, Kc);
      },
      loadingIndicator: function (e) {
        var t = e.isFocused,
            n = e.size,
            r = e.theme,
            o = r.colors,
            i = r.spacing.baseUnit;
        return {
          label: "loadingIndicator",
          color: t ? o.neutral60 : o.neutral20,
          display: "flex",
          padding: 2 * i,
          transition: "color 150ms",
          alignSelf: "center",
          fontSize: n,
          lineHeight: 1,
          marginRight: n,
          textAlign: "center",
          verticalAlign: "middle"
        };
      },
      loadingMessage: kc,
      menu: function (e) {
        var t,
            n = e.placement,
            r = e.theme,
            o = r.borderRadius,
            i = r.spacing,
            a = r.colors;
        return Gs(t = {
          label: "menu"
        }, function (e) {
          return e ? {
            bottom: "top",
            top: "bottom"
          }[e] : "bottom";
        }(n), "100%"), Gs(t, "backgroundColor", a.neutral0), Gs(t, "borderRadius", o), Gs(t, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), Gs(t, "marginBottom", i.menuGutter), Gs(t, "marginTop", i.menuGutter), Gs(t, "position", "absolute"), Gs(t, "width", "100%"), Gs(t, "zIndex", 1), t;
      },
      menuList: function (e) {
        var t = e.maxHeight,
            n = e.theme.spacing.baseUnit;
        return {
          maxHeight: t,
          overflowY: "auto",
          paddingBottom: n,
          paddingTop: n,
          position: "relative",
          WebkitOverflowScrolling: "touch"
        };
      },
      menuPortal: function (e) {
        var t = e.rect,
            n = e.offset,
            r = e.position;
        return {
          left: t.left,
          position: r,
          top: n,
          width: t.width,
          zIndex: 1
        };
      },
      multiValue: function (e) {
        var t = e.theme,
            n = t.spacing,
            r = t.borderRadius;
        return {
          label: "multiValue",
          backgroundColor: t.colors.neutral10,
          borderRadius: r / 2,
          display: "flex",
          margin: n.baseUnit / 2,
          minWidth: 0
        };
      },
      multiValueLabel: function (e) {
        var t = e.theme,
            n = t.borderRadius,
            r = t.colors,
            o = e.cropWithEllipsis;
        return {
          borderRadius: n / 2,
          color: r.neutral80,
          fontSize: "85%",
          overflow: "hidden",
          padding: 3,
          paddingLeft: 6,
          textOverflow: o || void 0 === o ? "ellipsis" : void 0,
          whiteSpace: "nowrap"
        };
      },
      multiValueRemove: function (e) {
        var t = e.theme,
            n = t.spacing,
            r = t.borderRadius,
            o = t.colors;
        return {
          alignItems: "center",
          borderRadius: r / 2,
          backgroundColor: e.isFocused ? o.dangerLight : void 0,
          display: "flex",
          paddingLeft: n.baseUnit,
          paddingRight: n.baseUnit,
          ":hover": {
            backgroundColor: o.dangerLight,
            color: o.danger
          }
        };
      },
      noOptionsMessage: Ec,
      option: function (e) {
        var t = e.isDisabled,
            n = e.isFocused,
            r = e.isSelected,
            o = e.theme,
            i = o.spacing,
            a = o.colors;
        return {
          label: "option",
          backgroundColor: r ? a.primary : n ? a.primary25 : "transparent",
          color: t ? a.neutral20 : r ? a.neutral0 : "inherit",
          cursor: "default",
          display: "block",
          fontSize: "inherit",
          padding: "".concat(2 * i.baseUnit, "px ").concat(3 * i.baseUnit, "px"),
          width: "100%",
          userSelect: "none",
          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
          ":active": {
            backgroundColor: t ? void 0 : r ? a.primary : a.primary50
          }
        };
      },
      placeholder: function (e) {
        var t = e.theme,
            n = t.spacing;
        return {
          label: "placeholder",
          color: t.colors.neutral50,
          gridArea: "1 / 1 / 2 / 3",
          marginLeft: n.baseUnit / 2,
          marginRight: n.baseUnit / 2
        };
      },
      singleValue: function (e) {
        var t = e.isDisabled,
            n = e.theme,
            r = n.spacing,
            o = n.colors;
        return {
          label: "singleValue",
          color: t ? o.neutral40 : o.neutral80,
          gridArea: "1 / 1 / 2 / 3",
          marginLeft: r.baseUnit / 2,
          marginRight: r.baseUnit / 2,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      },
      valueContainer: function (e) {
        var t = e.theme.spacing,
            n = e.isMulti,
            r = e.hasValue,
            o = e.selectProps.controlShouldRenderValue;
        return {
          alignItems: "center",
          display: n && r && o ? "flex" : "grid",
          flex: 1,
          flexWrap: "wrap",
          padding: "".concat(t.baseUnit / 2, "px ").concat(2 * t.baseUnit, "px"),
          WebkitOverflowScrolling: "touch",
          position: "relative",
          overflow: "hidden"
        };
      }
    };
    var Ru,
        Nu = {
      borderRadius: 4,
      colors: {
        primary: "#2684FF",
        primary75: "#4C9AFF",
        primary50: "#B2D4FF",
        primary25: "#DEEBFF",
        danger: "#DE350B",
        dangerLight: "#FFBDAD",
        neutral0: "hsl(0, 0%, 100%)",
        neutral5: "hsl(0, 0%, 95%)",
        neutral10: "hsl(0, 0%, 90%)",
        neutral20: "hsl(0, 0%, 80%)",
        neutral30: "hsl(0, 0%, 70%)",
        neutral40: "hsl(0, 0%, 60%)",
        neutral50: "hsl(0, 0%, 50%)",
        neutral60: "hsl(0, 0%, 40%)",
        neutral70: "hsl(0, 0%, 30%)",
        neutral80: "hsl(0, 0%, 20%)",
        neutral90: "hsl(0, 0%, 10%)"
      },
      spacing: {
        baseUnit: 4,
        controlHeight: 38,
        menuGutter: 8
      }
    },
        Du = {
      "aria-live": "polite",
      backspaceRemovesValue: !0,
      blurInputOnSelect: dc(),
      captureMenuScroll: !dc(),
      closeMenuOnSelect: !0,
      closeMenuOnScroll: !1,
      components: {},
      controlShouldRenderValue: !0,
      escapeClearsValue: !1,
      filterOption: function (e, t) {
        if (e.data.__isNew__) return !0;
        var n = Zs({
          ignoreCase: !0,
          ignoreAccents: !0,
          stringify: hu,
          trim: !0,
          matchFrom: "any"
        }, Ru),
            r = n.ignoreCase,
            o = n.ignoreAccents,
            i = n.stringify,
            a = n.trim,
            s = n.matchFrom,
            c = a ? du(t) : t,
            u = a ? du(i(e)) : i(e);
        return r && (c = c.toLowerCase(), u = u.toLowerCase()), o && (c = fu(c), u = pu(u)), "start" === s ? u.substr(0, c.length) === c : u.indexOf(c) > -1;
      },
      formatGroupLabel: function (e) {
        return e.label;
      },
      getOptionLabel: function (e) {
        return e.label;
      },
      getOptionValue: function (e) {
        return e.value;
      },
      isDisabled: !1,
      isLoading: !1,
      isMulti: !1,
      isRtl: !1,
      isSearchable: !0,
      isOptionDisabled: function (e) {
        return !!e.isDisabled;
      },
      loadingMessage: function () {
        return "Loading...";
      },
      maxMenuHeight: 300,
      minMenuHeight: 140,
      menuIsOpen: !1,
      menuPlacement: "bottom",
      menuPosition: "absolute",
      menuShouldBlockScroll: !1,
      menuShouldScrollIntoView: !function () {
        try {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
          return !1;
        }
      }(),
      noOptionsMessage: function () {
        return "No options";
      },
      openMenuOnFocus: !1,
      openMenuOnClick: !0,
      options: [],
      pageSize: 5,
      placeholder: "Select...",
      screenReaderStatus: function (e) {
        var t = e.count;
        return "".concat(t, " result").concat(1 !== t ? "s" : "", " available");
      },
      styles: {},
      tabIndex: 0,
      tabSelectsValue: !0
    };

    function Iu(e, t, n, r) {
      return {
        type: "option",
        data: t,
        isDisabled: Fu(e, t, n),
        isSelected: zu(e, t, n),
        label: Au(e, t),
        value: Vu(e, t),
        index: r
      };
    }

    function Lu(e, t) {
      return e.options.map(function (n, r) {
        if ("options" in n) {
          var o = n.options.map(function (n, r) {
            return Iu(e, n, t, r);
          }).filter(function (t) {
            return Tu(e, t);
          });
          return o.length > 0 ? {
            type: "group",
            data: n,
            options: o,
            index: r
          } : void 0;
        }

        var i = Iu(e, n, t, r);
        return Tu(e, i) ? i : void 0;
      }).filter(bc);
    }

    function Mu(e) {
      return e.reduce(function (e, t) {
        return "group" === t.type ? e.push.apply(e, Xc(t.options.map(function (e) {
          return e.data;
        }))) : e.push(t.data), e;
      }, []);
    }

    function Tu(e, t) {
      var n = e.inputValue,
          r = void 0 === n ? "" : n,
          o = t.data,
          i = t.isSelected,
          a = t.label,
          s = t.value;
      return (!Uu(e) || !i) && Hu(e, {
        label: a,
        value: s,
        data: o
      }, r);
    }

    var Au = function (e, t) {
      return e.getOptionLabel(t);
    },
        Vu = function (e, t) {
      return e.getOptionValue(t);
    };

    function Fu(e, t, n) {
      return "function" == typeof e.isOptionDisabled && e.isOptionDisabled(t, n);
    }

    function zu(e, t, n) {
      if (n.indexOf(t) > -1) return !0;
      if ("function" == typeof e.isOptionSelected) return e.isOptionSelected(t, n);
      var r = Vu(e, t);
      return n.some(function (t) {
        return Vu(e, t) === r;
      });
    }

    function Hu(e, t, n) {
      return !e.filterOption || e.filterOption(t, n);
    }

    var Uu = function (e) {
      var t = e.hideSelectedOptions,
          n = e.isMulti;
      return void 0 === t ? n : t;
    },
        Bu = 1,
        $u = function (e) {
      Ys(n, e);
      var t = tc(n);

      function n(e) {
        var r;
        return $s(this, n), (r = t.call(this, e)).state = {
          ariaSelection: null,
          focusedOption: null,
          focusedValue: null,
          inputIsHidden: !1,
          isFocused: !1,
          selectValue: [],
          clearFocusValueOnUpdate: !1,
          prevWasFocused: !1,
          inputIsHiddenAfterUpdate: void 0,
          prevProps: void 0
        }, r.blockOptionHover = !1, r.isComposing = !1, r.commonProps = void 0, r.initialTouchX = 0, r.initialTouchY = 0, r.instancePrefix = "", r.openAfterFocus = !1, r.scrollToFocusedOptionOnUpdate = !1, r.userIsDragging = void 0, r.controlRef = null, r.getControlRef = function (e) {
          r.controlRef = e;
        }, r.focusedOptionRef = null, r.getFocusedOptionRef = function (e) {
          r.focusedOptionRef = e;
        }, r.menuListRef = null, r.getMenuListRef = function (e) {
          r.menuListRef = e;
        }, r.inputRef = null, r.getInputRef = function (e) {
          r.inputRef = e;
        }, r.focus = r.focusInput, r.blur = r.blurInput, r.onChange = function (e, t) {
          var n = r.props,
              o = n.onChange,
              i = n.name;
          t.name = i, r.ariaOnChange(e, t), o(e, t);
        }, r.setValue = function (e, t, n) {
          var o = r.props,
              i = o.closeMenuOnSelect,
              a = o.isMulti,
              s = o.inputValue;
          r.onInputChange("", {
            action: "set-value",
            prevInputValue: s
          }), i && (r.setState({
            inputIsHiddenAfterUpdate: !a
          }), r.onMenuClose()), r.setState({
            clearFocusValueOnUpdate: !0
          }), r.onChange(e, {
            action: t,
            option: n
          });
        }, r.selectOption = function (e) {
          var t = r.props,
              n = t.blurInputOnSelect,
              o = t.isMulti,
              i = t.name,
              a = r.state.selectValue,
              s = o && r.isOptionSelected(e, a),
              c = r.isOptionDisabled(e, a);

          if (s) {
            var u = r.getOptionValue(e);
            r.setValue(a.filter(function (e) {
              return r.getOptionValue(e) !== u;
            }), "deselect-option", e);
          } else {
            if (c) return void r.ariaOnChange(e, {
              action: "select-option",
              option: e,
              name: i
            });
            o ? r.setValue([].concat(Xc(a), [e]), "select-option", e) : r.setValue(e, "select-option");
          }

          n && r.blurInput();
        }, r.removeValue = function (e) {
          var t = r.props.isMulti,
              n = r.state.selectValue,
              o = r.getOptionValue(e),
              i = n.filter(function (e) {
            return r.getOptionValue(e) !== o;
          }),
              a = yc(t, i, i[0] || null);
          r.onChange(a, {
            action: "remove-value",
            removedValue: e
          }), r.focusInput();
        }, r.clearValue = function () {
          var e = r.state.selectValue;
          r.onChange(yc(r.props.isMulti, [], null), {
            action: "clear",
            removedValues: e
          });
        }, r.popValue = function () {
          var e = r.props.isMulti,
              t = r.state.selectValue,
              n = t[t.length - 1],
              o = t.slice(0, t.length - 1),
              i = yc(e, o, o[0] || null);
          r.onChange(i, {
            action: "pop-value",
            removedValue: n
          });
        }, r.getValue = function () {
          return r.state.selectValue;
        }, r.cx = function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

          return ic.apply(void 0, [r.props.classNamePrefix].concat(t));
        }, r.getOptionLabel = function (e) {
          return Au(r.props, e);
        }, r.getOptionValue = function (e) {
          return Vu(r.props, e);
        }, r.getStyles = function (e, t) {
          var n = _u[e](t);

          n.boxSizing = "border-box";
          var o = r.props.styles[e];
          return o ? o(n, t) : n;
        }, r.getElementId = function (e) {
          return "".concat(r.instancePrefix, "-").concat(e);
        }, r.getComponents = function () {
          return e = r.props, Zs(Zs({}, Jc), e.components);
          var e;
        }, r.buildCategorizedOptions = function () {
          return Lu(r.props, r.state.selectValue);
        }, r.getCategorizedOptions = function () {
          return r.props.menuIsOpen ? r.buildCategorizedOptions() : [];
        }, r.buildFocusableOptions = function () {
          return Mu(r.buildCategorizedOptions());
        }, r.getFocusableOptions = function () {
          return r.props.menuIsOpen ? r.buildFocusableOptions() : [];
        }, r.ariaOnChange = function (e, t) {
          r.setState({
            ariaSelection: Zs({
              value: e
            }, t)
          });
        }, r.onMenuMouseDown = function (e) {
          0 === e.button && (e.stopPropagation(), e.preventDefault(), r.focusInput());
        }, r.onMenuMouseMove = function (e) {
          r.blockOptionHover = !1;
        }, r.onControlMouseDown = function (e) {
          if (!e.defaultPrevented) {
            var t = r.props.openMenuOnClick;
            r.state.isFocused ? r.props.menuIsOpen ? "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && r.onMenuClose() : t && r.openMenu("first") : (t && (r.openAfterFocus = !0), r.focusInput()), "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && e.preventDefault();
          }
        }, r.onDropdownIndicatorMouseDown = function (e) {
          if (!(e && "mousedown" === e.type && 0 !== e.button || r.props.isDisabled)) {
            var t = r.props,
                n = t.isMulti,
                o = t.menuIsOpen;
            r.focusInput(), o ? (r.setState({
              inputIsHiddenAfterUpdate: !n
            }), r.onMenuClose()) : r.openMenu("first"), e.preventDefault();
          }
        }, r.onClearIndicatorMouseDown = function (e) {
          e && "mousedown" === e.type && 0 !== e.button || (r.clearValue(), e.preventDefault(), r.openAfterFocus = !1, "touchend" === e.type ? r.focusInput() : setTimeout(function () {
            return r.focusInput();
          }));
        }, r.onScroll = function (e) {
          "boolean" == typeof r.props.closeMenuOnScroll ? e.target instanceof HTMLElement && cc(e.target) && r.props.onMenuClose() : "function" == typeof r.props.closeMenuOnScroll && r.props.closeMenuOnScroll(e) && r.props.onMenuClose();
        }, r.onCompositionStart = function () {
          r.isComposing = !0;
        }, r.onCompositionEnd = function () {
          r.isComposing = !1;
        }, r.onTouchStart = function (e) {
          var t = e.touches,
              n = t && t.item(0);
          n && (r.initialTouchX = n.clientX, r.initialTouchY = n.clientY, r.userIsDragging = !1);
        }, r.onTouchMove = function (e) {
          var t = e.touches,
              n = t && t.item(0);

          if (n) {
            var o = Math.abs(n.clientX - r.initialTouchX),
                i = Math.abs(n.clientY - r.initialTouchY);
            r.userIsDragging = o > 5 || i > 5;
          }
        }, r.onTouchEnd = function (e) {
          r.userIsDragging || (r.controlRef && !r.controlRef.contains(e.target) && r.menuListRef && !r.menuListRef.contains(e.target) && r.blurInput(), r.initialTouchX = 0, r.initialTouchY = 0);
        }, r.onControlTouchEnd = function (e) {
          r.userIsDragging || r.onControlMouseDown(e);
        }, r.onClearIndicatorTouchEnd = function (e) {
          r.userIsDragging || r.onClearIndicatorMouseDown(e);
        }, r.onDropdownIndicatorTouchEnd = function (e) {
          r.userIsDragging || r.onDropdownIndicatorMouseDown(e);
        }, r.handleInputChange = function (e) {
          var t = r.props.inputValue,
              n = e.currentTarget.value;
          r.setState({
            inputIsHiddenAfterUpdate: !1
          }), r.onInputChange(n, {
            action: "input-change",
            prevInputValue: t
          }), r.props.menuIsOpen || r.onMenuOpen();
        }, r.onInputFocus = function (e) {
          r.props.onFocus && r.props.onFocus(e), r.setState({
            inputIsHiddenAfterUpdate: !1,
            isFocused: !0
          }), (r.openAfterFocus || r.props.openMenuOnFocus) && r.openMenu("first"), r.openAfterFocus = !1;
        }, r.onInputBlur = function (e) {
          var t = r.props.inputValue;
          r.menuListRef && r.menuListRef.contains(document.activeElement) ? r.inputRef.focus() : (r.props.onBlur && r.props.onBlur(e), r.onInputChange("", {
            action: "input-blur",
            prevInputValue: t
          }), r.onMenuClose(), r.setState({
            focusedValue: null,
            isFocused: !1
          }));
        }, r.onOptionHover = function (e) {
          r.blockOptionHover || r.state.focusedOption === e || r.setState({
            focusedOption: e
          });
        }, r.shouldHideSelectedOptions = function () {
          return Uu(r.props);
        }, r.onKeyDown = function (e) {
          var t = r.props,
              n = t.isMulti,
              o = t.backspaceRemovesValue,
              i = t.escapeClearsValue,
              a = t.inputValue,
              s = t.isClearable,
              c = t.isDisabled,
              u = t.menuIsOpen,
              l = t.onKeyDown,
              p = t.tabSelectsValue,
              f = t.openMenuOnFocus,
              d = r.state,
              h = d.focusedOption,
              g = d.focusedValue,
              v = d.selectValue;

          if (!(c || "function" == typeof l && (l(e), e.defaultPrevented))) {
            switch (r.blockOptionHover = !0, e.key) {
              case "ArrowLeft":
                if (!n || a) return;
                r.focusValue("previous");
                break;

              case "ArrowRight":
                if (!n || a) return;
                r.focusValue("next");
                break;

              case "Delete":
              case "Backspace":
                if (a) return;
                if (g) r.removeValue(g);else {
                  if (!o) return;
                  n ? r.popValue() : s && r.clearValue();
                }
                break;

              case "Tab":
                if (r.isComposing) return;
                if (e.shiftKey || !u || !p || !h || f && r.isOptionSelected(h, v)) return;
                r.selectOption(h);
                break;

              case "Enter":
                if (229 === e.keyCode) break;

                if (u) {
                  if (!h) return;
                  if (r.isComposing) return;
                  r.selectOption(h);
                  break;
                }

                return;

              case "Escape":
                u ? (r.setState({
                  inputIsHiddenAfterUpdate: !1
                }), r.onInputChange("", {
                  action: "menu-close",
                  prevInputValue: a
                }), r.onMenuClose()) : s && i && r.clearValue();
                break;

              case " ":
                if (a) return;

                if (!u) {
                  r.openMenu("first");
                  break;
                }

                if (!h) return;
                r.selectOption(h);
                break;

              case "ArrowUp":
                u ? r.focusOption("up") : r.openMenu("last");
                break;

              case "ArrowDown":
                u ? r.focusOption("down") : r.openMenu("first");
                break;

              case "PageUp":
                if (!u) return;
                r.focusOption("pageup");
                break;

              case "PageDown":
                if (!u) return;
                r.focusOption("pagedown");
                break;

              case "Home":
                if (!u) return;
                r.focusOption("first");
                break;

              case "End":
                if (!u) return;
                r.focusOption("last");
                break;

              default:
                return;
            }

            e.preventDefault();
          }
        }, r.instancePrefix = "react-select-" + (r.props.instanceId || ++Bu), r.state.selectValue = ac(e.value), r;
      }

      return Ks(n, [{
        key: "componentDidMount",
        value: function () {
          this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
        }
      }, {
        key: "componentDidUpdate",
        value: function (e) {
          var t,
              n,
              r,
              o,
              i,
              a = this.props,
              s = a.isDisabled,
              c = a.menuIsOpen,
              u = this.state.isFocused;
          (u && !s && e.isDisabled || u && c && !e.menuIsOpen) && this.focusInput(), u && s && !e.isDisabled && this.setState({
            isFocused: !1
          }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (t = this.menuListRef, n = this.focusedOptionRef, r = t.getBoundingClientRect(), o = n.getBoundingClientRect(), i = n.offsetHeight / 3, o.bottom + i > r.bottom ? lc(t, Math.min(n.offsetTop + n.clientHeight - t.offsetHeight + i, t.scrollHeight)) : o.top - i < r.top && lc(t, Math.max(n.offsetTop - i, 0)), this.scrollToFocusedOptionOnUpdate = !1);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "onMenuOpen",
        value: function () {
          this.props.onMenuOpen();
        }
      }, {
        key: "onMenuClose",
        value: function () {
          this.onInputChange("", {
            action: "menu-close",
            prevInputValue: this.props.inputValue
          }), this.props.onMenuClose();
        }
      }, {
        key: "onInputChange",
        value: function (e, t) {
          this.props.onInputChange(e, t);
        }
      }, {
        key: "focusInput",
        value: function () {
          this.inputRef && this.inputRef.focus();
        }
      }, {
        key: "blurInput",
        value: function () {
          this.inputRef && this.inputRef.blur();
        }
      }, {
        key: "openMenu",
        value: function (e) {
          var t = this,
              n = this.state,
              r = n.selectValue,
              o = n.isFocused,
              i = this.buildFocusableOptions(),
              a = "first" === e ? 0 : i.length - 1;

          if (!this.props.isMulti) {
            var s = i.indexOf(r[0]);
            s > -1 && (a = s);
          }

          this.scrollToFocusedOptionOnUpdate = !(o && this.menuListRef), this.setState({
            inputIsHiddenAfterUpdate: !1,
            focusedValue: null,
            focusedOption: i[a]
          }, function () {
            return t.onMenuOpen();
          });
        }
      }, {
        key: "focusValue",
        value: function (e) {
          var t = this.state,
              n = t.selectValue,
              r = t.focusedValue;

          if (this.props.isMulti) {
            this.setState({
              focusedOption: null
            });
            var o = n.indexOf(r);
            r || (o = -1);
            var i = n.length - 1,
                a = -1;

            if (n.length) {
              switch (e) {
                case "previous":
                  a = 0 === o ? 0 : -1 === o ? i : o - 1;
                  break;

                case "next":
                  o > -1 && o < i && (a = o + 1);
              }

              this.setState({
                inputIsHidden: -1 !== a,
                focusedValue: n[a]
              });
            }
          }
        }
      }, {
        key: "focusOption",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first",
              t = this.props.pageSize,
              n = this.state.focusedOption,
              r = this.getFocusableOptions();

          if (r.length) {
            var o = 0,
                i = r.indexOf(n);
            n || (i = -1), "up" === e ? o = i > 0 ? i - 1 : r.length - 1 : "down" === e ? o = (i + 1) % r.length : "pageup" === e ? (o = i - t) < 0 && (o = 0) : "pagedown" === e ? (o = i + t) > r.length - 1 && (o = r.length - 1) : "last" === e && (o = r.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
              focusedOption: r[o],
              focusedValue: null
            });
          }
        }
      }, {
        key: "getTheme",
        value: function () {
          return this.props.theme ? "function" == typeof this.props.theme ? this.props.theme(Nu) : Zs(Zs({}, Nu), this.props.theme) : Nu;
        }
      }, {
        key: "getCommonProps",
        value: function () {
          var e = this.clearValue,
              t = this.cx,
              n = this.getStyles,
              r = this.getValue,
              o = this.selectOption,
              i = this.setValue,
              a = this.props,
              s = a.isMulti,
              c = a.isRtl,
              u = a.options;
          return {
            clearValue: e,
            cx: t,
            getStyles: n,
            getValue: r,
            hasValue: this.hasValue(),
            isMulti: s,
            isRtl: c,
            options: u,
            selectOption: o,
            selectProps: a,
            setValue: i,
            theme: this.getTheme()
          };
        }
      }, {
        key: "hasValue",
        value: function () {
          return this.state.selectValue.length > 0;
        }
      }, {
        key: "hasOptions",
        value: function () {
          return !!this.getFocusableOptions().length;
        }
      }, {
        key: "isClearable",
        value: function () {
          var e = this.props,
              t = e.isClearable,
              n = e.isMulti;
          return void 0 === t ? n : t;
        }
      }, {
        key: "isOptionDisabled",
        value: function (e, t) {
          return Fu(this.props, e, t);
        }
      }, {
        key: "isOptionSelected",
        value: function (e, t) {
          return zu(this.props, e, t);
        }
      }, {
        key: "filterOption",
        value: function (e, t) {
          return Hu(this.props, e, t);
        }
      }, {
        key: "formatOptionLabel",
        value: function (e, t) {
          if ("function" == typeof this.props.formatOptionLabel) {
            var n = this.props.inputValue,
                r = this.state.selectValue;
            return this.props.formatOptionLabel(e, {
              context: t,
              inputValue: n,
              selectValue: r
            });
          }

          return this.getOptionLabel(e);
        }
      }, {
        key: "formatGroupLabel",
        value: function (e) {
          return this.props.formatGroupLabel(e);
        }
      }, {
        key: "startListeningComposition",
        value: function () {
          document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
        }
      }, {
        key: "stopListeningComposition",
        value: function () {
          document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
        }
      }, {
        key: "startListeningToTouch",
        value: function () {
          document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
        }
      }, {
        key: "stopListeningToTouch",
        value: function () {
          document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
        }
      }, {
        key: "renderInput",
        value: function () {
          var e = this.props,
              t = e.isDisabled,
              n = e.isSearchable,
              r = e.inputId,
              i = e.inputValue,
              a = e.tabIndex,
              s = e.form,
              c = e.menuIsOpen,
              u = this.getComponents().Input,
              l = this.state,
              p = l.inputIsHidden,
              f = l.ariaSelection,
              d = this.commonProps,
              h = r || this.getElementId("input"),
              g = Zs(Zs(Zs({
            "aria-autocomplete": "list",
            "aria-expanded": c,
            "aria-haspopup": !0,
            "aria-errormessage": this.props["aria-errormessage"],
            "aria-invalid": this.props["aria-invalid"],
            "aria-label": this.props["aria-label"],
            "aria-labelledby": this.props["aria-labelledby"],
            role: "combobox"
          }, c && {
            "aria-controls": this.getElementId("listbox"),
            "aria-owns": this.getElementId("listbox")
          }), !n && {
            "aria-readonly": !0
          }), this.hasValue() ? "initial-input-focus" === (null == f ? void 0 : f.action) && {
            "aria-describedby": this.getElementId("live-region")
          } : {
            "aria-describedby": this.getElementId("placeholder")
          });
          return n ? o.createElement(u, Hn({}, d, {
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: h,
            innerRef: this.getInputRef,
            isDisabled: t,
            isHidden: p,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: a,
            form: s,
            type: "text",
            value: i
          }, g)) : o.createElement(vu, Hn({
            id: h,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: rc,
            onFocus: this.onInputFocus,
            disabled: t,
            tabIndex: a,
            inputMode: "none",
            form: s,
            value: ""
          }, g));
        }
      }, {
        key: "renderPlaceholderOrValue",
        value: function () {
          var e = this,
              t = this.getComponents(),
              n = t.MultiValue,
              r = t.MultiValueContainer,
              i = t.MultiValueLabel,
              a = t.MultiValueRemove,
              s = t.SingleValue,
              c = t.Placeholder,
              u = this.commonProps,
              l = this.props,
              p = l.controlShouldRenderValue,
              f = l.isDisabled,
              d = l.isMulti,
              h = l.inputValue,
              g = l.placeholder,
              v = this.state,
              m = v.selectValue,
              b = v.focusedValue,
              y = v.isFocused;
          if (!this.hasValue() || !p) return h ? null : o.createElement(c, Hn({}, u, {
            key: "placeholder",
            isDisabled: f,
            isFocused: y,
            innerProps: {
              id: this.getElementId("placeholder")
            }
          }), g);
          if (d) return m.map(function (t, s) {
            var c = t === b,
                l = "".concat(e.getOptionLabel(t), "-").concat(e.getOptionValue(t));
            return o.createElement(n, Hn({}, u, {
              components: {
                Container: r,
                Label: i,
                Remove: a
              },
              isFocused: c,
              isDisabled: f,
              key: l,
              index: s,
              removeProps: {
                onClick: function () {
                  return e.removeValue(t);
                },
                onTouchEnd: function () {
                  return e.removeValue(t);
                },
                onMouseDown: function (e) {
                  e.preventDefault();
                }
              },
              data: t
            }), e.formatOptionLabel(t, "value"));
          });
          if (h) return null;
          var O = m[0];
          return o.createElement(s, Hn({}, u, {
            data: O,
            isDisabled: f
          }), this.formatOptionLabel(O, "value"));
        }
      }, {
        key: "renderClearIndicator",
        value: function () {
          var e = this.getComponents().ClearIndicator,
              t = this.commonProps,
              n = this.props,
              r = n.isDisabled,
              i = n.isLoading,
              a = this.state.isFocused;
          if (!this.isClearable() || !e || r || !this.hasValue() || i) return null;
          var s = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            "aria-hidden": "true"
          };
          return o.createElement(e, Hn({}, t, {
            innerProps: s,
            isFocused: a
          }));
        }
      }, {
        key: "renderLoadingIndicator",
        value: function () {
          var e = this.getComponents().LoadingIndicator,
              t = this.commonProps,
              n = this.props,
              r = n.isDisabled,
              i = n.isLoading,
              a = this.state.isFocused;
          if (!e || !i) return null;
          return o.createElement(e, Hn({}, t, {
            innerProps: {
              "aria-hidden": "true"
            },
            isDisabled: r,
            isFocused: a
          }));
        }
      }, {
        key: "renderIndicatorSeparator",
        value: function () {
          var e = this.getComponents(),
              t = e.DropdownIndicator,
              n = e.IndicatorSeparator;
          if (!t || !n) return null;
          var r = this.commonProps,
              i = this.props.isDisabled,
              a = this.state.isFocused;
          return o.createElement(n, Hn({}, r, {
            isDisabled: i,
            isFocused: a
          }));
        }
      }, {
        key: "renderDropdownIndicator",
        value: function () {
          var e = this.getComponents().DropdownIndicator;
          if (!e) return null;
          var t = this.commonProps,
              n = this.props.isDisabled,
              r = this.state.isFocused,
              i = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            "aria-hidden": "true"
          };
          return o.createElement(e, Hn({}, t, {
            innerProps: i,
            isDisabled: n,
            isFocused: r
          }));
        }
      }, {
        key: "renderMenu",
        value: function () {
          var e = this,
              t = this.getComponents(),
              n = t.Group,
              r = t.GroupHeading,
              i = t.Menu,
              a = t.MenuList,
              s = t.MenuPortal,
              c = t.LoadingMessage,
              u = t.NoOptionsMessage,
              l = t.Option,
              p = this.commonProps,
              f = this.state.focusedOption,
              d = this.props,
              h = d.captureMenuScroll,
              g = d.inputValue,
              v = d.isLoading,
              m = d.loadingMessage,
              b = d.minMenuHeight,
              y = d.maxMenuHeight,
              O = d.menuIsOpen,
              w = d.menuPlacement,
              x = d.menuPosition,
              j = d.menuPortalTarget,
              S = d.menuShouldBlockScroll,
              E = d.menuShouldScrollIntoView,
              k = d.noOptionsMessage,
              P = d.onMenuScrollToTop,
              C = d.onMenuScrollToBottom;
          if (!O) return null;

          var _,
              R = function (t, n) {
            var r = t.type,
                i = t.data,
                a = t.isDisabled,
                s = t.isSelected,
                c = t.label,
                u = t.value,
                d = f === i,
                h = a ? void 0 : function () {
              return e.onOptionHover(i);
            },
                g = a ? void 0 : function () {
              return e.selectOption(i);
            },
                v = "".concat(e.getElementId("option"), "-").concat(n),
                m = {
              id: v,
              onClick: g,
              onMouseMove: h,
              onMouseOver: h,
              tabIndex: -1
            };
            return o.createElement(l, Hn({}, p, {
              innerProps: m,
              data: i,
              isDisabled: a,
              isSelected: s,
              key: v,
              label: c,
              type: r,
              value: u,
              isFocused: d,
              innerRef: d ? e.getFocusedOptionRef : void 0
            }), e.formatOptionLabel(t.data, "menu"));
          };

          if (this.hasOptions()) _ = this.getCategorizedOptions().map(function (t) {
            if ("group" === t.type) {
              var i = t.data,
                  a = t.options,
                  s = t.index,
                  c = "".concat(e.getElementId("group"), "-").concat(s),
                  u = "".concat(c, "-heading");
              return o.createElement(n, Hn({}, p, {
                key: c,
                data: i,
                options: a,
                Heading: r,
                headingProps: {
                  id: u,
                  data: t.data
                },
                label: e.formatGroupLabel(t.data)
              }), t.options.map(function (e) {
                return R(e, "".concat(s, "-").concat(e.index));
              }));
            }

            if ("option" === t.type) return R(t, "".concat(t.index));
          });else if (v) {
            var N = m({
              inputValue: g
            });
            if (null === N) return null;
            _ = o.createElement(c, p, N);
          } else {
            var D = k({
              inputValue: g
            });
            if (null === D) return null;
            _ = o.createElement(u, p, D);
          }
          var I = {
            minMenuHeight: b,
            maxMenuHeight: y,
            menuPlacement: w,
            menuPosition: x,
            menuShouldScrollIntoView: E
          },
              L = o.createElement(jc, Hn({}, p, I), function (t) {
            var n = t.ref,
                r = t.placerProps,
                s = r.placement,
                c = r.maxHeight;
            return o.createElement(i, Hn({}, p, I, {
              innerRef: n,
              innerProps: {
                onMouseDown: e.onMenuMouseDown,
                onMouseMove: e.onMenuMouseMove,
                id: e.getElementId("listbox")
              },
              isLoading: v,
              placement: s
            }), o.createElement(Cu, {
              captureEnabled: h,
              onTopArrive: P,
              onBottomArrive: C,
              lockEnabled: S
            }, function (t) {
              return o.createElement(a, Hn({}, p, {
                innerRef: function (n) {
                  e.getMenuListRef(n), t(n);
                },
                isLoading: v,
                maxHeight: c,
                focusedOption: f
              }), _);
            }));
          });
          return j || "fixed" === x ? o.createElement(s, Hn({}, p, {
            appendTo: j,
            controlElement: this.controlRef,
            menuPlacement: w,
            menuPosition: x
          }), L) : L;
        }
      }, {
        key: "renderFormField",
        value: function () {
          var e = this,
              t = this.props,
              n = t.delimiter,
              r = t.isDisabled,
              i = t.isMulti,
              a = t.name,
              s = this.state.selectValue;

          if (a && !r) {
            if (i) {
              if (n) {
                var c = s.map(function (t) {
                  return e.getOptionValue(t);
                }).join(n);
                return o.createElement("input", {
                  name: a,
                  type: "hidden",
                  value: c
                });
              }

              var u = s.length > 0 ? s.map(function (t, n) {
                return o.createElement("input", {
                  key: "i-".concat(n),
                  name: a,
                  type: "hidden",
                  value: e.getOptionValue(t)
                });
              }) : o.createElement("input", {
                name: a,
                type: "hidden"
              });
              return o.createElement("div", null, u);
            }

            var l = s[0] ? this.getOptionValue(s[0]) : "";
            return o.createElement("input", {
              name: a,
              type: "hidden",
              value: l
            });
          }
        }
      }, {
        key: "renderLiveRegion",
        value: function () {
          var e = this.commonProps,
              t = this.state,
              n = t.ariaSelection,
              r = t.focusedOption,
              i = t.focusedValue,
              a = t.isFocused,
              s = t.selectValue,
              c = this.getFocusableOptions();
          return o.createElement(ou, Hn({}, e, {
            id: this.getElementId("live-region"),
            ariaSelection: n,
            focusedOption: r,
            focusedValue: i,
            isFocused: a,
            selectValue: s,
            focusableOptions: c
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.getComponents(),
              t = e.Control,
              n = e.IndicatorsContainer,
              r = e.SelectContainer,
              i = e.ValueContainer,
              a = this.props,
              s = a.className,
              c = a.id,
              u = a.isDisabled,
              l = a.menuIsOpen,
              p = this.state.isFocused,
              f = this.commonProps = this.getCommonProps();
          return o.createElement(r, Hn({}, f, {
            className: s,
            innerProps: {
              id: c,
              onKeyDown: this.onKeyDown
            },
            isDisabled: u,
            isFocused: p
          }), this.renderLiveRegion(), o.createElement(t, Hn({}, f, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: u,
            isFocused: p,
            menuIsOpen: l
          }), o.createElement(i, Hn({}, f, {
            isDisabled: u
          }), this.renderPlaceholderOrValue(), this.renderInput()), o.createElement(n, Hn({}, f, {
            isDisabled: u
          }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function (e, t) {
          var n = t.prevProps,
              r = t.clearFocusValueOnUpdate,
              o = t.inputIsHiddenAfterUpdate,
              i = t.ariaSelection,
              a = t.isFocused,
              s = t.prevWasFocused,
              c = e.options,
              u = e.value,
              l = e.menuIsOpen,
              p = e.inputValue,
              f = e.isMulti,
              d = ac(u),
              h = {};

          if (n && (u !== n.value || c !== n.options || l !== n.menuIsOpen || p !== n.inputValue)) {
            var g = l ? function (e, t) {
              return Mu(Lu(e, t));
            }(e, d) : [],
                v = r ? function (e, t) {
              var n = e.focusedValue,
                  r = e.selectValue.indexOf(n);

              if (r > -1) {
                if (t.indexOf(n) > -1) return n;
                if (r < t.length) return t[r];
              }

              return null;
            }(t, d) : null;
            h = {
              selectValue: d,
              focusedOption: function (e, t) {
                var n = e.focusedOption;
                return n && t.indexOf(n) > -1 ? n : t[0];
              }(t, g),
              focusedValue: v,
              clearFocusValueOnUpdate: !1
            };
          }

          var m = null != o && e !== n ? {
            inputIsHidden: o,
            inputIsHiddenAfterUpdate: void 0
          } : {},
              b = i,
              y = a && s;
          return a && !y && (b = {
            value: yc(f, d, d[0] || null),
            options: d,
            action: "initial-input-focus"
          }, y = !s), "initial-input-focus" === (null == i ? void 0 : i.action) && (b = null), Zs(Zs(Zs({}, h), m), {}, {
            prevProps: e,
            ariaSelection: b,
            prevWasFocused: y
          });
        }
      }]), n;
    }(o.Component);

    $u.defaultProps = Du;
    var qu = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
    var Wu = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
    n(35), n(15), n(36), n(38);
    var Ku,
        Yu = Object(o.forwardRef)(function (e, t) {
      var n,
          r,
          i,
          a,
          s,
          c,
          u,
          l,
          p,
          f,
          d,
          h,
          g,
          v,
          m,
          b,
          y,
          O,
          w,
          x,
          j,
          S,
          E,
          k,
          P,
          C,
          _,
          R,
          N,
          D,
          I,
          L = function (e) {
        var t = e.defaultOptions,
            n = void 0 !== t && t,
            r = e.cacheOptions,
            i = void 0 !== r && r,
            a = e.loadOptions;
        e.options;
        var s = e.isLoading,
            c = void 0 !== s && s,
            u = e.onInputChange,
            l = e.filterOption,
            p = void 0 === l ? null : l,
            f = Fs(e, Wu),
            d = f.inputValue,
            h = Object(o.useRef)(void 0),
            g = Object(o.useRef)(!1),
            v = Us(Object(o.useState)(Array.isArray(n) ? n : void 0), 2),
            m = v[0],
            b = v[1],
            y = Us(Object(o.useState)(void 0 !== d ? d : ""), 2),
            O = y[0],
            w = y[1],
            x = Us(Object(o.useState)(!0 === n), 2),
            j = x[0],
            S = x[1],
            E = Us(Object(o.useState)(void 0), 2),
            k = E[0],
            P = E[1],
            C = Us(Object(o.useState)([]), 2),
            _ = C[0],
            R = C[1],
            N = Us(Object(o.useState)(!1), 2),
            D = N[0],
            I = N[1],
            L = Us(Object(o.useState)({}), 2),
            M = L[0],
            T = L[1],
            A = Us(Object(o.useState)(void 0), 2),
            V = A[0],
            F = A[1],
            z = Us(Object(o.useState)(void 0), 2),
            H = z[0],
            U = z[1];
        i !== H && (T({}), U(i)), n !== V && (b(Array.isArray(n) ? n : void 0), F(n)), Object(o.useEffect)(function () {
          return g.current = !0, function () {
            g.current = !1;
          };
        }, []);
        var B = Object(o.useCallback)(function (e, t) {
          if (!a) return t();
          var n = a(e, t);
          n && "function" == typeof n.then && n.then(t, function () {
            return t();
          });
        }, [a]);
        Object(o.useEffect)(function () {
          !0 === n && B(O, function (e) {
            g.current && (b(e || []), S(!!h.current));
          });
        }, []);
        var $ = Object(o.useCallback)(function (e, t) {
          var n = function (e, t, n) {
            if (n) {
              var r = n(e, t);
              if ("string" == typeof r) return r;
            }

            return e;
          }(e, t, u);

          if (!n) return h.current = void 0, w(""), P(""), R([]), S(!1), void I(!1);
          if (i && M[n]) w(n), P(n), R(M[n]), S(!1), I(!1);else {
            var r = h.current = {};
            w(n), S(!0), I(!k), B(n, function (e) {
              g && r === h.current && (h.current = void 0, S(!1), P(n), R(e || []), I(!1), T(e ? Zs(Zs({}, M), {}, Gs({}, n, e)) : M));
            });
          }
        }, [i, B, k, M, u]),
            q = D ? [] : O && k ? _ : m || [];
        return Zs(Zs({}, f), {}, {
          options: q,
          isLoading: j || c,
          onInputChange: $,
          filterOption: p
        });
      }(e),
          M = (r = (n = L).defaultInputValue, i = void 0 === r ? "" : r, a = n.defaultMenuIsOpen, s = void 0 !== a && a, c = n.defaultValue, u = void 0 === c ? null : c, l = n.inputValue, p = n.menuIsOpen, f = n.onChange, d = n.onInputChange, h = n.onMenuClose, g = n.onMenuOpen, v = n.value, m = Fs(n, qu), b = Us(Object(o.useState)(void 0 !== l ? l : i), 2), y = b[0], O = b[1], w = Us(Object(o.useState)(void 0 !== p ? p : s), 2), x = w[0], j = w[1], S = Us(Object(o.useState)(void 0 !== v ? v : u), 2), E = S[0], k = S[1], P = Object(o.useCallback)(function (e, t) {
        "function" == typeof f && f(e, t), k(e);
      }, [f]), C = Object(o.useCallback)(function (e, t) {
        var n;
        "function" == typeof d && (n = d(e, t)), O(void 0 !== n ? n : e);
      }, [d]), _ = Object(o.useCallback)(function () {
        "function" == typeof g && g(), j(!0);
      }, [g]), R = Object(o.useCallback)(function () {
        "function" == typeof h && h(), j(!1);
      }, [h]), N = void 0 !== l ? l : y, D = void 0 !== p ? p : x, I = void 0 !== v ? v : E, Zs(Zs({}, m), {}, {
        inputValue: N,
        menuIsOpen: D,
        onChange: P,
        onInputChange: C,
        onMenuClose: R,
        onMenuOpen: _,
        value: I
      }));

      return o.createElement($u, Hn({
        ref: t
      }, M));
    });

    function Gu(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ju(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function Xu(e, t) {
      return (Xu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Zu(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = el(e);

        if (t) {
          var o = el(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Qu(this, n);
      };
    }

    function Qu(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function el(e) {
      return (el = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tl(e, t, n, r, o) {
      var i = {};
      return Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var nl = (tl((Ku = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xu(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = Zu(a);

      function a() {
        var e;
        Gu(this, a);

        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];

        return (e = o.call.apply(o, [this].concat(n)))._filterOptions = function (e, t) {
          return t.filter(function (t) {
            return t.label.toLowerCase().includes(e.toLowerCase());
          });
        }, e._asyncOptions = function (t) {
          return fetch(e._processorsUrl).then(function (e) {
            return e.json();
          }).then(function (n) {
            return e._filterOptions(t, n.filter(function (t) {
              return t.id !== e._currentProcessorId;
            }).map(function (e) {
              return {
                value: e.serial,
                label: e.name
              };
            }));
          }).catch(function (e) {
            return console.error("Failed to get list of processors: ".concat(e.message));
          });
        }, e._asyncCropOption = function (t) {
          return fetch("".concat(e._cropUrl, "/").concat(t)).then(function (e) {
            return e.json();
          }).then(function (e) {
            return {
              value: e.serial,
              label: e.name
            };
          });
        }, e;
      }

      return t = a, (n = [{
        key: "_processorsUrl",
        get: function () {
          var e = this.props.processorsUrl;
          if (!e) throw new Error("ProcessorSelector requires a 'processorsUrl' property");
          return e;
        }
      }, {
        key: "_initialValue",
        get: function () {
          var e = this.props.currentProcessorSerial;
          if (!e) return null;
          var t = this.props.currentProcessorName;
          return t ? {
            value: e,
            label: t
          } : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return i.a.createElement(j, {
            i18n: rt
          }, i.a.createElement(Yu, {
            placeholder: e("if2_processors.processors.select"),
            defaultValue: this._initialValue,
            name: "harvest_lot[processor_id]",
            cacheOptions: !0,
            defaultOptions: !0,
            isSearchable: !0,
            loadOptions: this._asyncOptions,
            className: "processor-selector-container",
            classNamePrefix: "processor-selector"
          }));
        }
      }]) && Ju(t.prototype, n), r && Ju(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(i.a.Component)).prototype, "_processorsUrl", [a.computed], Object.getOwnPropertyDescriptor(Ku.prototype, "_processorsUrl"), Ku.prototype), tl(Ku.prototype, "_initialValue", [a.computed], Object.getOwnPropertyDescriptor(Ku.prototype, "_initialValue"), Ku.prototype), Ku),
        rl = U()(nl),
        ol = Function.prototype.bind.call(Function.prototype.call, [].slice);

    function il(e, t) {
      return ol(e.querySelectorAll(t));
    }

    function al(e, t, n, r) {
      void 0 === r && (r = !1);
      var i = Do(n);
      Object(o.useEffect)(function () {
        var n = "function" == typeof e ? e() : e;
        return n.addEventListener(t, i, r), function () {
          return n.removeEventListener(t, i, r);
        };
      }, [e]);
    }

    var sl = o.createContext(null);
    const cl = ["children"];

    const ul = () => {};

    function ll() {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      const t = Object(o.useContext)(sl),
            _rr5 = rr(),
            _rr6 = _slicedToArray(_rr5, 2),
            n = _rr6[0],
            r = _rr6[1],
            i = Object(o.useRef)(!1),
            a = e.flip,
            s = e.offset,
            c = e.rootCloseEvent,
            _e$fixed = e.fixed,
            u = _e$fixed === void 0 ? !1 : _e$fixed,
            l = e.placement,
            _e$popperConfig2 = e.popperConfig,
            p = _e$popperConfig2 === void 0 ? {} : _e$popperConfig2,
            _e$enableEventListene = e.enableEventListeners,
            f = _e$enableEventListene === void 0 ? !0 : _e$enableEventListene,
            _e$usePopper = e.usePopper,
            d = _e$usePopper === void 0 ? !!t : _e$usePopper,
            h = null == (null == t ? void 0 : t.show) ? !!e.show : t.show;

      h && !i.current && (i.current = !0);

      const _ref23 = t || {},
            g = _ref23.placement,
            v = _ref23.setMenu,
            m = _ref23.menuElement,
            b = _ref23.toggleElement,
            y = xo(b, m, $o({
        placement: l || g || "bottom-start",
        enabled: d,
        enableEvents: null == f ? h : f,
        offset: s,
        flip: a,
        fixed: u,
        arrowElement: n,
        popperConfig: p
      })),
            O = Object.assign({
        ref: v || ul,
        "aria-labelledby": null == b ? void 0 : b.id
      }, y.attributes.popper, {
        style: y.styles.popper
      }),
            w = {
        show: h,
        placement: g,
        hasShown: i.current,
        toggle: null == t ? void 0 : t.toggle,
        popper: d ? y : null,
        arrowProps: d ? Object.assign({
          ref: r
        }, y.attributes.arrow, {
          style: y.styles.arrow
        }) : {}
      };

      return To(m, e => {
        null == t || t.toggle(!1, e);
      }, {
        clickTrigger: c,
        disabled: !h
      }), [O, w];
    }

    function pl(e) {
      let t = e.children,
          n = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            i = Object.keys(e);

        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

        return o;
      }(e, cl);

      const _ll = ll(n),
            _ll2 = _slicedToArray(_ll, 2),
            r = _ll2[0],
            o = _ll2[1];

      return Object(qo.jsx)(qo.Fragment, {
        children: t(r, o)
      });
    }

    pl.displayName = "DropdownMenu", pl.defaultProps = {
      usePopper: !0
    };
    var fl = pl;

    function dl(e, t, n, r) {
      Object.defineProperty(e, t, {
        get: n,
        set: r,
        enumerable: !0,
        configurable: !0
      });
    }

    var hl = {};
    dl(hl, "SSRProvider", () => ml), dl(hl, "useSSRSafeId", () => yl), dl(hl, "useIsSSR", () => Ol);
    const gl = {
      prefix: String(Math.round(1e10 * Math.random())),
      current: 0
    },
          vl = i.a.createContext(gl);

    function ml(e) {
      let t = Object(o.useContext)(vl),
          n = Object(o.useMemo)(() => ({
        prefix: t === gl ? "" : "".concat(t.prefix, "-").concat(++t.current),
        current: 0
      }), [t]);
      return i.a.createElement(vl.Provider, {
        value: n
      }, e.children);
    }

    let bl = Boolean("undefined" != typeof window && window.document && window.document.createElement);

    function yl(e) {
      let t = Object(o.useContext)(vl);
      return t !== gl || bl || console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server."), Object(o.useMemo)(() => e || "react-aria".concat(t.prefix, "-").concat(++t.current), [e]);
    }

    function Ol() {
      let e = Object(o.useContext)(vl) !== gl,
          _Object7 = Object(o.useState)(e),
          _Object8 = _slicedToArray(_Object7, 2),
          t = _Object8[0],
          n = _Object8[1];

      return "undefined" != typeof window && e && Object(o.useLayoutEffect)(() => {
        n(!1);
      }, []), t;
    }

    const wl = e => {
      var t;
      return "menu" === (null == (t = e.getAttribute("role")) ? void 0 : t.toLowerCase());
    },
          xl = () => {};

    function jl() {
      const e = yl(),
            _ref24 = Object(o.useContext)(sl) || {},
            _ref24$show = _ref24.show,
            t = _ref24$show === void 0 ? !1 : _ref24$show,
            _ref24$toggle = _ref24.toggle,
            n = _ref24$toggle === void 0 ? xl : _ref24$toggle,
            r = _ref24.setToggle,
            i = _ref24.menuElement,
            a = Object(o.useCallback)(e => {
        n(!t, e);
      }, [t, n]),
            s = {
        id: e,
        ref: r || xl,
        onClick: a,
        "aria-expanded": !!t
      };

      return i && wl(i) && (s["aria-haspopup"] = !0), [s, {
        show: t,
        toggle: n
      }];
    }

    function Sl(_ref25) {
      let e = _ref25.children;

      const _jl = jl(),
            _jl2 = _slicedToArray(_jl, 2),
            t = _jl2[0],
            n = _jl2[1];

      return Object(qo.jsx)(qo.Fragment, {
        children: e(t, n)
      });
    }

    Sl.displayName = "DropdownToggle";
    var El = Sl;

    const kl = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return null != e ? String(e) : t || null;
    };

    var Pl = o.createContext(null);
    const Cl = o.createContext(null);
    Cl.displayName = "NavContext";
    var _l = Cl;
    const Rl = ["as", "disabled"];

    function Nl(_ref26) {
      let e = _ref26.tagName,
          t = _ref26.disabled,
          n = _ref26.href,
          r = _ref26.target,
          o = _ref26.rel,
          i = _ref26.onClick,
          _ref26$tabIndex = _ref26.tabIndex,
          a = _ref26$tabIndex === void 0 ? 0 : _ref26$tabIndex,
          s = _ref26.type;
      e || (e = null != n || null != r || null != o ? "a" : "button");
      const c = {
        tagName: e
      };
      if ("button" === e) return [{
        type: s || "button",
        disabled: t
      }, c];

      const u = r => {
        (t || "a" === e && function (e) {
          return !e || "#" === e.trim();
        }(n)) && r.preventDefault(), t ? r.stopPropagation() : null == i || i(r);
      };

      return "a" === e && (n || (n = "#"), t && (n = void 0)), [{
        role: "button",
        disabled: void 0,
        tabIndex: t ? void 0 : a,
        href: n,
        target: "a" === e ? r : void 0,
        "aria-disabled": t || void 0,
        rel: "a" === e ? o : void 0,
        onClick: u,
        onKeyDown: e => {
          " " === e.key && (e.preventDefault(), u(e));
        }
      }, c];
    }

    const Dl = o.forwardRef((e, t) => {
      let n = e.as,
          r = e.disabled,
          o = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            i = Object.keys(e);

        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

        return o;
      }(e, Rl);

      const _Nl = Nl(Object.assign({
        tagName: n,
        disabled: r
      }, o)),
            _Nl2 = _slicedToArray(_Nl, 2),
            i = _Nl2[0],
            a = _Nl2[1].tagName;

      return Object(qo.jsx)(a, Object.assign({}, o, i, {
        ref: t
      }));
    });
    Dl.displayName = "Button";
    var Il = Dl;

    function Ll(e) {
      return "data-rr-ui-" + e;
    }

    const Ml = ["eventKey", "disabled", "onClick", "active", "as"];

    function Tl(_ref27) {
      let e = _ref27.key,
          t = _ref27.href,
          n = _ref27.active,
          r = _ref27.disabled,
          i = _ref27.onClick;

      const a = Object(o.useContext)(Pl),
            s = Object(o.useContext)(_l),
            _ref28 = s || {},
            c = _ref28.activeKey,
            u = kl(e, t),
            l = null == n && null != e ? kl(c) === u : n;

      return [{
        onClick: Do(e => {
          r || (null == i || i(e), a && !e.isPropagationStopped() && a(u, e));
        }),
        "aria-disabled": r || void 0,
        "aria-selected": l,
        [Ll("dropdown-item")]: ""
      }, {
        isActive: l
      }];
    }

    const Al = o.forwardRef((e, t) => {
      let n = e.eventKey,
          r = e.disabled,
          o = e.onClick,
          i = e.active,
          _e$as = e.as,
          a = _e$as === void 0 ? Il : _e$as,
          s = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            i = Object.keys(e);

        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

        return o;
      }(e, Ml);

      const _Tl = Tl({
        key: n,
        href: s.href,
        disabled: r,
        onClick: o,
        active: i
      }),
            _Tl2 = _slicedToArray(_Tl, 1),
            c = _Tl2[0];

      return Object(qo.jsx)(a, Object.assign({}, s, {
        ref: t
      }, c));
    });
    Al.displayName = "DropdownItem";
    var Vl = Al;

    function Fl() {
      const e = Object(o.useReducer)(function (e) {
        return !e;
      }, !1)[1],
            t = Object(o.useRef)(null),
            n = Object(o.useCallback)(n => {
        t.current = n, e();
      }, [e]);
      return [t, n];
    }

    function zl(_ref29) {
      let e = _ref29.defaultShow,
          t = _ref29.show,
          n = _ref29.onSelect,
          r = _ref29.onToggle,
          _ref29$itemSelector = _ref29.itemSelector,
          i = _ref29$itemSelector === void 0 ? "* [".concat(Ll("dropdown-item"), "]") : _ref29$itemSelector,
          a = _ref29.focusFirstItemOnShow,
          _ref29$placement = _ref29.placement,
          s = _ref29$placement === void 0 ? "bottom-start" : _ref29$placement,
          c = _ref29.children;

      const u = zo(),
            _qn3 = qn(t, e, r),
            _qn4 = _slicedToArray(_qn3, 2),
            l = _qn4[0],
            p = _qn4[1],
            _Fl = Fl(),
            _Fl2 = _slicedToArray(_Fl, 2),
            f = _Fl2[0],
            d = _Fl2[1],
            h = f.current,
            _Fl3 = Fl(),
            _Fl4 = _slicedToArray(_Fl3, 2),
            g = _Fl4[0],
            v = _Fl4[1],
            m = g.current,
            b = (y = l, O = Object(o.useRef)(null), Object(o.useEffect)(function () {
        O.current = y;
      }), O.current);

      var y, O;
      const w = Object(o.useRef)(null),
            x = Object(o.useRef)(!1),
            j = Object(o.useContext)(Pl),
            S = Object(o.useCallback)(function (e, t) {
        let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null == t ? void 0 : t.type;
        p(e, {
          originalEvent: t,
          source: n
        });
      }, [p]),
            E = Do((e, t) => {
        null == n || n(e, t), S(!1, t, "select"), t.isPropagationStopped() || null == j || j(e, t);
      }),
            k = Object(o.useMemo)(() => ({
        toggle: S,
        placement: s,
        show: l,
        menuElement: h,
        toggleElement: m,
        setMenu: d,
        setToggle: v
      }), [S, s, l, h, m, d, v]);
      h && b && !l && (x.current = h.contains(h.ownerDocument.activeElement));
      const P = Do(() => {
        m && m.focus && m.focus();
      }),
            C = Do(() => {
        const e = w.current;
        let t = a;
        if (null == t && (t = !(!f.current || !wl(f.current)) && "keyboard"), !1 === t || "keyboard" === t && !/^key.+$/.test(e)) return;
        const n = il(f.current, i)[0];
        n && n.focus && n.focus();
      });
      Object(o.useEffect)(() => {
        l ? C() : x.current && (x.current = !1, P());
      }, [l, x, P, C]), Object(o.useEffect)(() => {
        w.current = null;
      });

      const _ = (e, t) => {
        if (!f.current) return null;
        const n = il(f.current, i);
        let r = n.indexOf(e) + t;
        return r = Math.max(0, Math.min(r, n.length)), n[r];
      };

      return al(Object(o.useCallback)(() => u.document, [u]), "keydown", e => {
        var t, n;
        const r = e.key,
              o = e.target,
              i = null == (t = f.current) ? void 0 : t.contains(o),
              a = null == (n = g.current) ? void 0 : n.contains(o);
        if (/input|textarea/i.test(o.tagName) && (" " === r || "Escape" !== r && i || "Escape" === r && "search" === o.type)) return;
        if (!i && !a) return;
        if (!("Tab" !== r || f.current && l)) return;
        w.current = e.type;
        const s = {
          originalEvent: e,
          source: e.type
        };

        switch (r) {
          case "ArrowUp":
            {
              const t = _(o, -1);

              return t && t.focus && t.focus(), void e.preventDefault();
            }

          case "ArrowDown":
            if (e.preventDefault(), l) {
              const e = _(o, 1);

              e && e.focus && e.focus();
            } else p(!0, s);

            return;

          case "Tab":
            Po(o.ownerDocument, "keyup", e => {
              var t;
              ("Tab" !== e.key || e.target) && null != (t = f.current) && t.contains(e.target) || p(!1, s);
            }, {
              once: !0
            });
            break;

          case "Escape":
            "Escape" === r && (e.preventDefault(), e.stopPropagation()), p(!1, s);
        }
      }), Object(qo.jsx)(Pl.Provider, {
        value: E,
        children: Object(qo.jsx)(sl.Provider, {
          value: k,
          children: c
        })
      });
    }

    zl.displayName = "Dropdown", zl.Menu = fl, zl.Toggle = El, zl.Item = Vl;
    var Hl = zl;
    const Ul = o.createContext({});
    Ul.displayName = "DropdownContext";
    var Bl = Ul;
    var $l = n(14);
    new WeakMap();
    const ql = ["onKeyDown"];
    const Wl = o.forwardRef((e, t) => {
      let n = e.onKeyDown,
          r = function (e, t) {
        if (null == e) return {};
        var n,
            r,
            o = {},
            i = Object.keys(e);

        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);

        return o;
      }(e, ql);

      const _Nl3 = Nl(Object.assign({
        tagName: "a"
      }, r)),
            _Nl4 = _slicedToArray(_Nl3, 1),
            o = _Nl4[0],
            i = Do(e => {
        o.onKeyDown(e), null == n || n(e);
      });

      return ((a = r.href) && "#" !== a.trim() || r.role) && "button" !== r.role ? Object(qo.jsx)("a", Object.assign({
        ref: t
      }, r, {
        onKeyDown: n
      })) : Object(qo.jsx)("a", Object.assign({
        ref: t
      }, r, o, {
        onKeyDown: i
      }));
      var a;
    });
    Wl.displayName = "Anchor";
    var Kl = Wl;
    const Yl = o.forwardRef((_ref30, c) => {
      let e = _ref30.bsPrefix,
          t = _ref30.className,
          n = _ref30.eventKey,
          _ref30$disabled = _ref30.disabled,
          r = _ref30$disabled === void 0 ? !1 : _ref30$disabled,
          o = _ref30.onClick,
          i = _ref30.active,
          _ref30$as = _ref30.as,
          a = _ref30$as === void 0 ? Kl : _ref30$as,
          s = _objectWithoutProperties(_ref30, _excluded8);

      const u = Zo(e, "dropdown-item"),
            _Tl3 = Tl({
        key: n,
        href: s.href,
        disabled: r,
        onClick: o,
        active: i
      }),
            _Tl4 = _slicedToArray(_Tl3, 2),
            l = _Tl4[0],
            p = _Tl4[1];

      return Object(qo.jsx)(a, _objectSpread(_objectSpread(_objectSpread({}, s), l), {}, {
        ref: c,
        className: er()(t, u, p.isActive && "active", r && "disabled")
      }));
    });
    Yl.displayName = "DropdownItem";
    var Gl = Yl;
    const Jl = o.createContext(null);
    Jl.displayName = "InputGroupContext";
    var Xl = Jl;
    const Zl = o.createContext(null);
    Zl.displayName = "NavbarContext";
    var Ql = Zl;

    function ep(e, t) {
      return e;
    }

    function tp(e, t, n) {
      let r = e ? n ? "bottom-start" : "bottom-end" : n ? "bottom-end" : "bottom-start";
      return "up" === t ? r = e ? n ? "top-start" : "top-end" : n ? "top-end" : "top-start" : "end" === t ? r = e ? n ? "left-end" : "right-end" : n ? "left-start" : "right-start" : "start" === t && (r = e ? n ? "right-end" : "left-end" : n ? "right-start" : "left-start"), r;
    }

    const np = o.forwardRef((_ref31, f) => {
      let e = _ref31.bsPrefix,
          t = _ref31.className,
          n = _ref31.align,
          r = _ref31.rootCloseEvent,
          i = _ref31.flip,
          a = _ref31.show,
          s = _ref31.renderOnMount,
          _ref31$as = _ref31.as,
          c = _ref31$as === void 0 ? "div" : _ref31$as,
          u = _ref31.popperConfig,
          l = _ref31.variant,
          p = _objectWithoutProperties(_ref31, _excluded9);

      let d = !1;

      const h = Object(o.useContext)(Ql),
            g = Zo(e, "dropdown-menu"),
            _Object9 = Object(o.useContext)(Bl),
            v = _Object9.align,
            m = _Object9.drop,
            b = _Object9.isRTL;

      n = n || v;
      const y = Object(o.useContext)(Xl),
            O = [];
      if (n) if ("object" == typeof n) {
        const e = Object.keys(n);

        if (e.length) {
          const t = e[0],
                r = n[t];
          d = "start" === r, O.push("".concat(g, "-").concat(t, "-").concat(r));
        }
      } else "end" === n && (d = !0);

      const w = tp(d, m, b),
            _ll3 = ll({
        flip: i,
        rootCloseEvent: r,
        show: a,
        usePopper: !h && 0 === O.length,
        offset: [0, 2],
        popperConfig: u,
        placement: w
      }),
            _ll4 = _slicedToArray(_ll3, 2),
            x = _ll4[0],
            _ll4$ = _ll4[1],
            j = _ll4$.hasShown,
            S = _ll4$.popper,
            E = _ll4$.show,
            k = _ll4$.toggle;

      if (x.ref = Zn(ep(f), x.ref), Object($l.a)(() => {
        E && (null == S || S.update());
      }, [E]), !j && !s && !y) return null;
      "string" != typeof c && (x.show = E, x.close = () => null == k ? void 0 : k(!1), x.align = n);
      let P = p.style;
      return null != S && S.placement && (P = _objectSpread(_objectSpread({}, p.style), x.style), p["x-placement"] = S.placement), Object(qo.jsx)(c, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, p), x), {}, {
        style: P
      }, (O.length || h) && {
        "data-bs-popper": "static"
      }), {}, {
        className: er()(t, g, E && "show", d && g + "-end", l && "".concat(g, "-").concat(l), ...O)
      }));
    });
    np.displayName = "DropdownMenu", np.defaultProps = {
      flip: !0
    };
    var rp = np;
    const op = o.forwardRef((_ref32, s) => {
      let e = _ref32.as,
          t = _ref32.bsPrefix,
          n = _ref32.variant,
          r = _ref32.size,
          o = _ref32.active,
          i = _ref32.className,
          a = _objectWithoutProperties(_ref32, _excluded10);

      const c = Zo(t, "btn"),
            _Nl5 = Nl(_objectSpread({
        tagName: e
      }, a)),
            _Nl6 = _slicedToArray(_Nl5, 2),
            u = _Nl6[0],
            l = _Nl6[1].tagName,
            p = l;

      return Object(qo.jsx)(p, _objectSpread(_objectSpread(_objectSpread({}, u), a), {}, {
        ref: s,
        className: er()(i, c, o && "active", n && "".concat(c, "-").concat(n), r && "".concat(c, "-").concat(r), a.href && a.disabled && "disabled")
      }));
    });
    op.displayName = "Button", op.defaultProps = {
      variant: "primary",
      active: !1,
      disabled: !1
    };
    var ip = op;
    const ap = o.forwardRef((_ref33, s) => {
      let e = _ref33.bsPrefix,
          t = _ref33.split,
          n = _ref33.className,
          r = _ref33.childBsPrefix,
          _ref33$as = _ref33.as,
          i = _ref33$as === void 0 ? ip : _ref33$as,
          a = _objectWithoutProperties(_ref33, _excluded11);

      const c = Zo(e, "dropdown-toggle"),
            u = Object(o.useContext)(sl),
            l = Object(o.useContext)(Xl);
      void 0 !== r && (a.bsPrefix = r);

      const _jl3 = jl(),
            _jl4 = _slicedToArray(_jl3, 1),
            p = _jl4[0];

      return p.ref = Zn(p.ref, ep(s)), Object(qo.jsx)(i, _objectSpread(_objectSpread({
        className: er()(n, c, t && c + "-split", !!l && (null == u ? void 0 : u.show) && "show")
      }, p), a));
    });
    ap.displayName = "DropdownToggle";
    var sp = ap;
    const cp = ni("dropdown-header", {
      defaultProps: {
        role: "heading"
      }
    }),
          up = ni("dropdown-divider", {
      Component: "hr",
      defaultProps: {
        role: "separator"
      }
    }),
          lp = ni("dropdown-item-text", {
      Component: "span"
    }),
          pp = o.forwardRef((e, t) => {
      const _ref34 = function (e, t) {
        return Object.keys(t).reduce(function (n, r) {
          var o,
              i = n,
              a = i[Bn(r)],
              s = i[r],
              c = Un(i, [Bn(r), r].map($n)),
              u = t[r],
              l = qn(s, a, e[u]),
              p = l[0],
              f = l[1];
          return Hn({}, c, ((o = {})[r] = p, o[u] = f, o));
        }, e);
      }(e, {
        show: "onToggle"
      }),
            n = _ref34.bsPrefix,
            r = _ref34.drop,
            i = _ref34.show,
            a = _ref34.className,
            s = _ref34.align,
            c = _ref34.onSelect,
            u = _ref34.onToggle,
            l = _ref34.focusFirstItemOnShow,
            _ref34$as = _ref34.as,
            p = _ref34$as === void 0 ? "div" : _ref34$as,
            f = _ref34.navbar,
            d = _ref34.autoClose,
            h = _objectWithoutProperties(_ref34, _excluded12),
            g = Object(o.useContext)(Xl),
            v = Zo(n, "dropdown"),
            m = Qo(),
            b = Do((e, t) => {
        var n;
        t.originalEvent.currentTarget !== document || "keydown" === t.source && "Escape" !== t.originalEvent.key || (t.source = "rootClose"), n = t.source, (!1 === d ? "click" === n : "inside" === d ? "rootClose" !== n : "outside" !== d || "select" !== n) && (null == u || u(e, t));
      }),
            y = tp("end" === s, r, m),
            O = Object(o.useMemo)(() => ({
        align: s,
        drop: r,
        isRTL: m
      }), [s, r, m]);

      return Object(qo.jsx)(Bl.Provider, {
        value: O,
        children: Object(qo.jsx)(Hl, {
          placement: y,
          show: i,
          onSelect: c,
          onToggle: b,
          focusFirstItemOnShow: l,
          itemSelector: ".".concat(v, "-item:not(.disabled):not(:disabled)"),
          children: g ? h.children : Object(qo.jsx)(p, _objectSpread(_objectSpread({}, h), {}, {
            ref: t,
            className: er()(a, i && "show", (!r || "down" === r) && v, "up" === r && "dropup", "end" === r && "dropend", "start" === r && "dropstart")
          }))
        })
      });
    });
    pp.displayName = "Dropdown", pp.defaultProps = {
      navbar: !1,
      align: "start",
      autoClose: !0
    };
    var fp = Object.assign(pp, {
      Toggle: sp,
      Menu: rp,
      Item: Gl,
      ItemText: lp,
      Divider: up,
      Header: cp
    }),
        dp = n(3),
        hp = n.n(dp);
    const gp = hp.a.oneOf(["start", "end"]),
          vp = hp.a.oneOfType([gp, hp.a.shape({
      sm: gp
    }), hp.a.shape({
      md: gp
    }), hp.a.shape({
      lg: gp
    }), hp.a.shape({
      xl: gp
    }), hp.a.shape({
      xxl: gp
    }), hp.a.object]),
          mp = {
      id: hp.a.string,
      href: hp.a.string,
      onClick: hp.a.func,
      title: hp.a.node.isRequired,
      disabled: hp.a.bool,
      align: vp,
      menuRole: hp.a.string,
      renderMenuOnMount: hp.a.bool,
      rootCloseEvent: hp.a.string,
      menuVariant: hp.a.oneOf(["dark"]),
      bsPrefix: hp.a.string,
      variant: hp.a.string,
      size: hp.a.string
    },
          bp = o.forwardRef((_ref35, d) => {
      let e = _ref35.title,
          t = _ref35.children,
          n = _ref35.bsPrefix,
          r = _ref35.rootCloseEvent,
          o = _ref35.variant,
          i = _ref35.size,
          a = _ref35.menuRole,
          s = _ref35.renderMenuOnMount,
          c = _ref35.disabled,
          u = _ref35.href,
          l = _ref35.id,
          p = _ref35.menuVariant,
          f = _objectWithoutProperties(_ref35, _excluded13);

      return Object(qo.jsxs)(fp, _objectSpread(_objectSpread({
        ref: d
      }, f), {}, {
        children: [Object(qo.jsx)(sp, {
          id: l,
          href: u,
          size: i,
          variant: o,
          disabled: c,
          childBsPrefix: n,
          children: e
        }), Object(qo.jsx)(rp, {
          role: a,
          renderOnMount: s,
          rootCloseEvent: r,
          variant: p,
          children: t
        })]
      }));
    });
    bp.displayName = "DropdownButton", bp.propTypes = mp;
    var yp,
        Op = bp;

    function wp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function xp(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function jp(e, t) {
      return (jp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Sp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = kp(e);

        if (t) {
          var o = kp(this).constructor;
          n = Reflect.construct(r, arguments, o);
        } else n = r.apply(this, arguments);

        return Ep(this, n);
      };
    }

    function Ep(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function kp(e) {
      return (kp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Pp = (function (e, t, n, r, o) {
      var i = {};
      Object.keys(r).forEach(function (e) {
        i[e] = r[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = n.slice().reverse().reduce(function (n, r) {
        return r(e, t, n) || n;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((yp = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jp(e, t);
      }(a, e);
      var t,
          n,
          r,
          o = Sp(a);

      function a() {
        return wp(this, a), o.apply(this, arguments);
      }

      return t = a, (n = [{
        key: "_reportTypes",
        get: function () {
          var e = this.props.reportTypes;
          if (!e) throw new Error("ViewReportButton requires a 'reportTypes' property");
          return e.forEach(function (e) {
            if (!("name" in e)) throw new Error("ViewReportButton requires all report types to have a name");
            if (!("url" in e)) throw new Error("ViewReportButton requires all report types to have a url");
          }), e;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return i.a.createElement(j, {
            i18n: rt
          }, i.a.createElement(Op, {
            id: "dropdown-basic-button",
            title: e("if2_processors.harvest_lots.view_report")
          }, this._reportTypes.map(function (e) {
            return i.a.createElement(fp.Item, {
              href: e.url
            }, e.name);
          })));
        }
      }]) && xp(t.prototype, n), r && xp(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(i.a.Component)).prototype, "_reportTypes", [a.computed], Object.getOwnPropertyDescriptor(yp.prototype, "_reportTypes"), yp.prototype), yp),
        Cp = U()(Pp);
    "undefined" != typeof window ? window.IF2Processors = r : console.warn("Unable to register React components for IF2 Processors");
  }]);
});